  (function(){
    'use strict';

    var scriptEl = document.currentScript;
    var root = scriptEl ? scriptEl.closest('[data-msh-kb]') : null;
    if(!root) root = document.querySelector('[data-msh-kb]');
    if(!root) return;
    var sectionRoot = root.closest('[id^="shopify-section-"]') || root.parentElement;
    if(sectionRoot){ sectionRoot.setAttribute('data-msh-kb-section',''); }
    var configEl = root.querySelector('[data-kb-config]');
    var config = {};
    if(configEl){
      try{ config = JSON.parse(configEl.textContent || '{}') || {}; }catch(_cfgErr){ config = {}; }
    }
    var sectionId = String(config.sectionId || root.getAttribute('data-section-id') || root.id || 'default').trim();
    if(config.customCss){
      try{
        var customStyle = document.createElement('style');
        customStyle.setAttribute('data-kb-custom-css','');
        customStyle.textContent = String(config.customCss || '');
        root.appendChild(customStyle);
      }catch(_customCssErr){}
    }

    window.__mshBuilderBooted = window.__mshBuilderBooted || {};
    if(window.__mshBuilderBooted[sectionId]) return;
    window.__mshBuilderBooted[sectionId] = true;

    function preflightGetParam(name){
      try{
        var params = new URLSearchParams(window.location.search || '');
        return params.get(name) || '';
      }catch(_err){ return ''; }
    }
    function preflightGetLS(key){
      try{ return localStorage.getItem(key) || ''; }catch(_err){ return ''; }
    }
    function preflightSetLS(key, value){
      try{ localStorage.setItem(key, value); }catch(_err){}
    }
    function runSelectionPreflight(){
      var urlHandle = String(preflightGetParam('handle') || '').trim();
      var selectedHandle = '';
      if(urlHandle){
        selectedHandle = urlHandle;
        preflightSetLS('mshModelHandle', selectedHandle);
        preflightSetLS('mshShirtHandle', selectedHandle);
        preflightSetLS('msh_last_model', selectedHandle);
      }else{
        selectedHandle = String(preflightGetLS('mshModelHandle') || '').trim();
      }
      window.__MSH_SELECTED_HANDLE = selectedHandle;
      return selectedHandle;
    }
    runSelectionPreflight();
    syncKBMobileClass();

    var CANVAS = 1024;
    /* Back number geometry is permanently locked (no UI/localStorage overrides). */
    var LOCK_BACK = { size:0.276, x:0.5, y:0.334, gap:0.018 };
    /* Approved nape placement from pre-lock render constants (w=0.22, center x=0.5, center y=0.13) */
    var LOCK_NAPE = { size:0.22, x:0.50, y:0.13 };
    var adminModeEnabled = !!config.layoutModeEnabled;
    const KB_TUNE = adminModeEnabled && /kbtune=1/.test(location.search);
    /* Legacy inside-number placement fallback (used only if a digit SVG has no #badge-slot). */
    const INSIDE_BADGE_MAP = {
      '0': { ax:0.50, ay:0.83, s:0.30 },
      '1': { ax:0.50, ay:0.86, s:0.30 },
      '2': { ax:0.50, ay:0.83, s:0.30 },
      '3': { ax:0.50, ay:0.83, s:0.30 },
      '4': { ax:0.50, ay:0.83, s:0.30 },
      '5': { ax:0.50, ay:0.83, s:0.30 },
      '6': { ax:0.50, ay:0.83, s:0.30 },
      '7': { ax:0.50, ay:0.84, s:0.30 },
      '8': { ax:0.50, ay:0.82, s:0.30 },
      '9': { ax:0.50, ay:0.83, s:0.30 }
    };
    var INSIDE_BADGE_PRESET_STORAGE_KEY = 'msh_kb_inside_badge_presets_v1';
    /*
      Pair kerning algorithm (00-99):
      - Measure each digit once (bbox + alpha bounds + stroke inflation).
      - For each pair AB, compute required visual separation in px at locked size.
      - Outline/stroke increases visual footprint, so required spacing adds an outline compensation term.
      - Cache a PAIR_KERNING table for "00"..."99" and use it to place the right digit.
      This keeps back-number geometry locked while guaranteeing readable non-touching pairs.
    */
    var DIGIT_KERNING_BASE_PADDING_PX = 6;
    var DIGIT_KERNING_OUTLINE_FACTOR = 1.1;
    var DIGIT_KERNING_MAX_EXTRA_PX = 24;
    const KB_DEBUG = adminModeEnabled && /kbdebug=1/.test(location.search);
    const KB_PAGE_DEBUG = adminModeEnabled && /(?:\?|&)debug=1(?:&|$)/.test(location.search);
    const KB_METRICS = /kbmetrics=1/.test(location.search);
    var DIGIT_RASTER_BUDGET_MS = 30;
    var IMAGE_LOAD_TIMEOUT_MS = 3000;
    var PAIR_KERNING = Object.create(null);
    var DIGIT_SAFE_ANCHOR_BOX = {
      "0": { x:0.33, y:0.58, w:0.34, h:0.28 },
      "1": { x:0.34, y:0.70, w:0.32, h:0.24 },
      "2": { x:0.30, y:0.64, w:0.40, h:0.24 },
      "3": { x:0.30, y:0.64, w:0.40, h:0.24 },
      "4": { x:0.28, y:0.67, w:0.44, h:0.24 },
      "5": { x:0.30, y:0.64, w:0.40, h:0.24 },
      "6": { x:0.34, y:0.58, w:0.34, h:0.26 },
      "7": { x:0.28, y:0.70, w:0.44, h:0.22 },
      "8": { x:0.34, y:0.59, w:0.32, h:0.24 },
      "9": { x:0.32, y:0.58, w:0.34, h:0.26 }
    };
    var fallbackProductHandle = String(config.productHandle || '').trim();
    var modelsUrl = String(config.modelsUrl || '/pages/kit-match').trim();
    var sectionBackLayoutProfilesRaw = String(config.backLayoutProfiles || '{}');
    var kbLayoutQueryEnabled = adminModeEnabled && /(?:\?|&)kblayout=1(?:&|$)/.test(window.location.search || '');
    var kbLayoutEditorEnabled = adminModeEnabled && !!(window.Shopify && window.Shopify.designMode);
    var layoutModeActive = kbLayoutQueryEnabled || kbLayoutEditorEnabled;
    var BACK_LAYOUT_STORAGE_KEY = 'msh_kb_back_layout_profiles_v1';
    var LAYOUT_SCALE_MIN = 0.5;
    var LAYOUT_SCALE_MAX = 1.5;
    var LAYOUT_SCALE_STEP = 0.05;
    var productHandle = '';
    var ns = String(config.altNamespace || '').trim();
    var namespaceOverride = String(ns || '').trim();
    var LS_BASE = 'msh_kb_svg_v1_' + sectionId;
    var PALETTE = ['#ffffff','#000000','#d1d5db','#374151','#1e3a8a','#dc2626','#2563eb','#38bdf8','#16a34a','#facc15','#f97316','#7c3aed'];

    var elColour  = root.querySelector('[data-kb-colour]');
    var elBadge   = root.querySelector('[data-kb-badge]');
    var elSponsor = root.querySelector('[data-kb-sponsor]');
    var elNumber  = root.querySelector('[data-kb-number]');
    var insideTunePanel = root.querySelector('[data-kb-inside-tune]');
    var insideTuneNumber = root.querySelector('[data-kb-inside-number]');
    var insideTuneResetBtn = root.querySelector('[data-kb-inside-reset-number]');
    var insideTuneCopyBtn = root.querySelector('[data-kb-inside-copy]');
    var insideTuneClearBtn = root.querySelector('[data-kb-inside-clear]');
    var elFill    = root.querySelector('[data-kb-num-fill]');
    var elStroke  = root.querySelector('[data-kb-num-stroke]');
    var elFillHex = root.querySelector('[data-kb-fill-hex]');
    var elStrokeHex = root.querySelector('[data-kb-stroke-hex]');
    var fillRow = root.querySelector('[data-kb-fill-row]');
    var strokeRow = root.querySelector('[data-kb-stroke-row]');
    var napeTextRow = root.querySelector('[data-kb-nape-text-row]');
    var napeSquaresRow = root.querySelector('[data-kb-nape-squares-row]');
    var sheetToggleBtn = root.querySelector('[data-kb-sheet-toggle]');
    var bottomSheet = root.querySelector('[data-kb-bottom-sheet]');
    var elNapeTextOverrideColor = root.querySelector('[data-kb-nape-text-color]');
    var elNapeTextOverrideHex = root.querySelector('[data-kb-nape-text-hex]');
    var elNapeSquaresOverrideColor = root.querySelector('[data-kb-nape-squares-color]');
    var elNapeSquaresOverrideHex = root.querySelector('[data-kb-nape-squares-hex]');
    var elErr     = root.querySelector('[data-kb-error]');
    var elColourStatus = root.querySelector('[data-kb-colour-status]');
    var colourSwatchesHost = root.querySelector('[data-kb-colour-swatches]');
    var mobileColourSelected = root.querySelector('[data-kb-mobile-colour-selected]');
    var mobileColourOpenBtn = root.querySelector('[data-kb-mobile-colour-open]');
    var tabBtns = root.querySelectorAll('[data-kb-tab]');
    var tabPanels = root.querySelectorAll('[data-kb-tab-panel]');
    var mobileSideBtns = root.querySelectorAll('[data-kb-side]');
    var presetBtns = root.querySelectorAll('[data-kb-preset]');
    var loopBanner = root.querySelector('[data-kb-loop-banner]');
    var appShell = root.querySelector('[data-kb-app]');
    var debugPanel = root.querySelector('[data-kb-debug-panel]');
    var debugStrip = root.querySelector('[data-kb-debug-strip]');
    var headingTitle = root.querySelector('[data-kb-heading-title]');
    var sectionDebugMode = adminModeEnabled && !!config.debugMode;
    var layoutTools = root.querySelector('[data-kb-layout-tools]');
    var layoutTargetBtns = root.querySelectorAll('[data-kb-layout-target-seg] [data-kb-layout-target]');
    var layoutScaleInput = root.querySelector('[data-kb-layout-scale]');
    var layoutScaleOut = root.querySelector('[data-kb-layout-scale-out]');
    var layoutScaleDownBtn = root.querySelector('[data-kb-layout-scale-down]');
    var layoutScaleUpBtn = root.querySelector('[data-kb-layout-scale-up]');
    var layoutResetBtn = root.querySelector('[data-kb-layout-reset]');
    var layoutSaveBtn = root.querySelector('[data-kb-layout-save]');
    var layoutCopyBtn = root.querySelector('[data-kb-layout-copy]');
    var layoutJsonOutput = root.querySelector('[data-kb-layout-json]');
    var builderFetchStatus = 'idle';
    var builderFetchFailStatus = '';
    var builderLoadedTitle = '';
    var resolvedHandleForDebug = String(window.__MSH_SELECTED_HANDLE || '').trim();
    function isDebugEnabled(){
      return KB_DEBUG || !!window.__KB_DEBUG;
    }
    function isDebugStripEnabled(){
      return KB_PAGE_DEBUG || sectionDebugMode;
    }

    function updateBuilderHeadingFromProduct(product){
      if(!headingTitle || !product) return;
      var cleanTitle = stripBuilderSuffix(product.title || '');
      if(!cleanTitle) return;
      headingTitle.textContent = cleanTitle;
      setLS('mshModelName', cleanTitle);
      builderLoadedTitle = String(product.title || '');
      renderDebugStrip();
    }

    function renderDebugStrip(){
      if(!debugStrip) return;
      if(!isDebugStripEnabled()){
        debugStrip.hidden = true;
        return;
      }
      var params = new URLSearchParams(window.location.search || '');
      debugStrip.hidden = false;
      debugStrip.textContent = [
        'MSH Builder Debug',
        'href: ' + window.location.href,
        'params: handle=' + (params.get('handle') || '') + ' | kit=' + (params.get('kit') || '') + ' | band=' + (params.get('band') || '') + ' | model=' + (params.get('model') || ''),
        'resolved handle: ' + (resolvedHandleForDebug || '(none)'),
        'localStorage: mshModelHandle=' + (getLS('mshModelHandle') || '(empty)') + ' | mshModelName=' + (getLS('mshModelName') || '(empty)'),
        'product fetch: ' + builderFetchStatus + (builderFetchFailStatus ? (' (' + builderFetchFailStatus + ')') : ''),
        'loaded product title: ' + (builderLoadedTitle || '(none)')
      ].join('\n');
    }

    if(isDebugEnabled() && !debugPanel){
      debugPanel = document.createElement('div');
      debugPanel.className = 'msh-kb__debug';
      debugPanel.setAttribute('data-kb-debug-panel', '');
      var debugHost = root.querySelector('.msh-kb__previews') || root.querySelector('.msh-kb__body') || root;
      debugHost.appendChild(debugPanel);
    }
    var loadingFront = root.querySelector('[data-kb-loading-front]');
    var loadingBack = root.querySelector('[data-kb-loading-back]');
    var previewTriggers = root.querySelectorAll('[data-kb-lightbox-trigger]');
    var lightbox = root.querySelector('[data-kb-lightbox]');
    var lightboxDialog = root.querySelector('[data-kb-lightbox-dialog]');
    var lightboxStage = root.querySelector('[data-kb-lightbox-stage]');
    var lightboxStageHost = root.querySelector('[data-kb-lightbox-stage-host]');
    var lightboxCloseBtn = root.querySelector('[data-kb-lightbox-close]');
    var lightboxCloseXBtn = root.querySelector('[data-kb-lightbox-close-x]');
    var lightboxDownloadBtn = root.querySelector('[data-kb-lightbox-download]');

    var zoomOpenBtn = root.querySelector('[data-kb-zoom-open]');
    var dlFrontBtn = root.querySelector('[data-kb-dl-front]');
    var continueToShortsBtn = root.querySelector('[data-kb-continue-shorts]');
    var dlFrontBtnMain = root.querySelector('[data-kb-dl-front-main]');
    var dlFrontQuickBtn = root.querySelector('[data-kb-front-quick-download]');
    var dlBackBtns  = root.querySelectorAll('[data-kb-dl-back]');
    var backLockDebug = root.querySelector('[data-kb-back-lock-debug]');
    var clearBtn   = root.querySelector('[data-kb-clear]');
    var resetBtn   = root.querySelector('[data-kb-reset]');

    var toolChips = root.querySelectorAll('[data-kb-tool]');

    var svgFront = root.querySelector('[data-kb-preview="front"] [data-kb-svg="front"]');
    var svgBack  = root.querySelector('[data-kb-preview="back"] [data-kb-svg="back"]');
    var frontCanvasEl = root.querySelector('[data-kb-preview="front"] [data-kb-canvas="front"]');
    var backCanvasEl = root.querySelector('[data-kb-preview="back"] [data-kb-canvas="back"]');
    var baseFront = root.querySelector('[data-kb-base-front]');
    var baseBack  = root.querySelector('[data-kb-base-back]');
    var frontBadge = root.querySelector('[data-kb-front-badge]');
    var frontSponsor = root.querySelector('[data-kb-front-sponsor]');
    var defsBack = root.querySelector('[data-kb-defs-back]');
    var napeHolder = root.querySelector('[data-kb-nape]');
    var napeLayoutGroup = root.querySelector('[data-kb-nape-layout]');
    var numberLayoutGroup = root.querySelector('[data-kb-number-layout]');
    var numberGroup = root.querySelector('[data-kb-number-group]');
    var numberStrokeGroup = root.querySelector('[data-kb-number-stroke-group]');
    var numLogo = root.querySelector('[data-kb-numlogo]');
    var numLogoL = root.querySelector('[data-kb-numlogo-l]');
    var numLogoR = root.querySelector('[data-kb-numlogo-r]');
    var numLogoDebug = root.querySelector('[data-kb-numlogo-debug]');
    var reloadDigitsBtn = root.querySelector('[data-kb-reload-digits]');
    var reloadMsg = root.querySelector('[data-kb-reload-msg]');
    var resizeOverlay = root.querySelector('[data-kb-resize-overlay]');
    var resizeBox = root.querySelector('[data-kb-resize-box]');
    var resizeHandles = root.querySelectorAll('[data-kb-resize-handle]');
    var stageZoomToggles = root.querySelectorAll('[data-kb-zoom-toggle]');
    var stageNodes = {
      front: root.querySelector('[data-kb-stage="front"]'),
      back: root.querySelector('[data-kb-stage="back"]')
    };
    var stageInnerNodes = {
      front: root.querySelector('[data-kb-stage-inner="front"]'),
      back: root.querySelector('[data-kb-stage-inner="back"]')
    };
    var stageHomes = {
      front: stageNodes.front ? stageNodes.front.parentElement : null,
      back: stageNodes.back ? stageNodes.back.parentElement : null
    };
    var stagePlaceholders = { front:null, back:null };

    var sliders = {
      badgeS: root.querySelector('[data-kb-badge-s]'),
      badgeX: root.querySelector('[data-kb-badge-x]'),
      badgeY: root.querySelector('[data-kb-badge-y]'),

      sponsorS: root.querySelector('[data-kb-sponsor-s]'),
      sponsorX: root.querySelector('[data-kb-sponsor-x]'),
      sponsorY: root.querySelector('[data-kb-sponsor-y]')
    };

    var outs = {
      badgeS: root.querySelector('[data-kb-badge-s-out]'),
      badgeX: root.querySelector('[data-kb-badge-x-out]'),
      badgeY: root.querySelector('[data-kb-badge-y-out]'),

      sponsorS: root.querySelector('[data-kb-sponsor-s-out]'),
      sponsorX: root.querySelector('[data-kb-sponsor-x-out]'),
      sponsorY: root.querySelector('[data-kb-sponsor-y-out]')
    };


    var uiErrors = {
      main: '',
      digitRewrite: ''
    };

    function renderErr(){
      var parts = [];
      if(uiErrors.main) parts.push(uiErrors.main);
      if(uiErrors.digitRewrite) parts.push(uiErrors.digitRewrite);

      var msg = parts.join('\n\n');
      elErr.hidden = !msg;
      elErr.textContent = msg;
      if(msg) console.error('[MSH Kit Builder]', msg);
    }

    function showErr(msg){
      uiErrors.main = msg || '';
      renderErr();
    }

    function showDigitRewriteErr(msg){
      uiErrors.digitRewrite = msg || '';
      renderErr();
    }

    function clamp(n,min,max){ return Math.max(min, Math.min(max, n)); }
    function roundTo(value, places){
      var n = isFinite(value) ? value : 0;
      var factor = Math.pow(10, places || 0);
      return Math.round(n * factor) / factor;
    }
    function parseJsonObject(raw, fallback){
      try{
        var parsed = JSON.parse(String(raw || '').trim() || '{}');
        if(parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
      }catch(_jsonErr){}
      return fallback && typeof fallback === 'object' ? fallback : {};
    }
    function baseBackLayout(){
      return {
        nape: { x:LOCK_NAPE.x, y:LOCK_NAPE.y, s:1 },
        number: { x:LOCK_BACK.x, y:LOCK_BACK.y, s:1 }
      };
    }
    function sanitizeLayoutNode(rawNode, fallbackNode){
      var safeFallback = fallbackNode || { x:0.5, y:0.5, s:1 };
      var node = (rawNode && typeof rawNode === 'object') ? rawNode : {};
      return {
        x: clamp(isFinite(node.x) ? node.x : safeFallback.x, 0, 1),
        y: clamp(isFinite(node.y) ? node.y : safeFallback.y, 0, 1),
        s: clamp(isFinite(node.s) ? node.s : safeFallback.s, LAYOUT_SCALE_MIN, LAYOUT_SCALE_MAX)
      };
    }
    function normalizeBackLayoutProfile(raw){
      var fallback = baseBackLayout();
      var source = (raw && typeof raw === 'object') ? raw : {};
      return {
        nape: sanitizeLayoutNode(source.nape, fallback.nape),
        number: sanitizeLayoutNode(source.number, fallback.number)
      };
    }
    function backLayoutTransform(targetNode, baseNode){
      var targetX = (targetNode.x || 0) * CANVAS;
      var targetY = (targetNode.y || 0) * CANVAS;
      var baseX = (baseNode.x || 0) * CANVAS;
      var baseY = (baseNode.y || 0) * CANVAS;
      var scale = clamp(isFinite(targetNode.s) ? targetNode.s : 1, LAYOUT_SCALE_MIN, LAYOUT_SCALE_MAX);
      return 'translate(' + roundTo(targetX, 2) + ' ' + roundTo(targetY, 2) + ') scale(' + roundTo(scale, 4) + ') translate(' + roundTo(-baseX, 2) + ' ' + roundTo(-baseY, 2) + ')';
    }
    async function copyTextToClipboard(text){
      var copyText = String(text || '');
      if(navigator.clipboard && navigator.clipboard.writeText){
        await navigator.clipboard.writeText(copyText);
        return;
      }
      var temp = document.createElement('textarea');
      temp.value = copyText;
      temp.setAttribute('readonly', 'readonly');
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.focus();
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
    }
    function norm(s){ return String(s||'').toLowerCase().replace(/\s+/g,' ').trim(); }
    function getParam(name){
      try{
        var params = new URLSearchParams(window.location.search || '');
        return params.get(name) || '';
      }catch(_err){ return ''; }
    }
    function syncUrlSelectionToStorage(){
      var urlKit = norm(getParam('kit'));
      var urlBand = norm(getParam('band'));
      var urlHandle = String(getParam('handle') || '').trim();
      var urlModel = String(getParam('model') || '').trim();

      if(urlKit){
        if(urlKit === 'gk' || urlKit === 'goalkeeper'){
          setLS('mshKitType', 'gk');
          setLS('msh_mode', 'goalkeeper');
        }else if(urlKit === 'match'){
          setLS('mshKitType', 'match');
          setLS('msh_mode', 'match');
        }
      }
      if(urlBand){
        var cleanBand = normalizeAudience(urlBand);
        setLS('mshAgeBand', cleanBand);
        setLS('msh_audience', cleanBand);
      }
      if(urlHandle){
        setLS('msh_last_model', urlHandle);
      }
      if(urlModel){
        setLS('mshModelName', urlModel);
      }

      kbLog('selection sync', { kit:urlKit || null, band:urlBand || null, handle:urlHandle || null, model:urlModel || null });
    }
    function getLS(key){
      try{ return localStorage.getItem(key) || ''; }catch(_err){ return ''; }
    }
    function setLS(key, value){
      try{ localStorage.setItem(key, value); }catch(_err){}
    }
    function readBackLayoutProfilesFromStorage(){
      return parseJsonObject(getLS(BACK_LAYOUT_STORAGE_KEY), {});
    }
    function normalizeMode(v){
      var mode = norm(v);
      if(mode === 'gk' || mode === 'goalkeeper') return 'goalkeeper';
      return 'match';
    }
    function normalizeAudience(v){
      var aud = norm(v);
      return aud === 'jnr' ? 'jnr' : 'snr';
    }
    function stripBuilderSuffix(name){
      return String(name || '').replace(/\s*\(Builder\)\s*$/i, '').trim();
    }
    function getSelectedModelName(){
      return stripBuilderSuffix(getLS('mshModelName') || getParam('model') || '');
    }
    function getSelectedHandle(){
      return String(window.__MSH_SELECTED_HANDLE || getParam('handle') || getLS('mshModelHandle') || getLS('msh_last_model') || getParam('model') || '').trim();
    }
    function getSelectedMode(){
      return normalizeMode(getLS('mshKitType') || getLS('msh_mode') || getParam('kit') || getParam('mode') || 'match');
    }
    function getSelectedAudience(){
      return normalizeAudience(getLS('mshAgeBand') || getLS('msh_audience') || getParam('band') || getParam('aud') || 'snr');
    }
    function showSelectionMissingError(){
      elErr.hidden = false;
      elErr.innerHTML = 'No model selected. Go back and choose a model. '
        + '<a class="msh-kb__btn msh-kb__btn--primary" href="/pages/kit-match">Match shirts</a> '
        + '<a class="msh-kb__btn" href="/pages/kit-goalkeeper">Goalkeeper shirts</a>';
    }
    function showProductLoadError(handle, message){
      var safeMsg = String(message || 'Could not load selected product.');
      var statusMatch = safeMsg.match(/status\s+(\d+)/i);
      var statusCode = statusMatch ? statusMatch[1] : 'unknown';
      console.error('[MSH Kit Builder] Failed to load product handle:', handle, 'status:', statusCode, safeMsg);
      if(!(window.Shopify && window.Shopify.designMode)) return;
      elErr.hidden = false;
      elErr.innerHTML = 'Failed to load product handle: <strong>' + handle + '</strong>. ' + safeMsg + ' <button type="button" class="msh-kb__btn" data-kb-retry-product>Retry</button>';
      var retry = elErr.querySelector('[data-kb-retry-product]');
      if(retry){
        retry.addEventListener('click', function(){ window.location.reload(); }, { once:true });
      }
    }
    function fmtOut(v){
      var n = parseFloat(v); if(!isFinite(n)) n=0;
      return (Math.round(n*1000)/1000).toFixed(3);
    }
    function fmtTuneOut(v){
      var n = parseFloat(v); if(!isFinite(n)) n=0;
      return (Math.round(n*100)/100).toFixed(2);
    }
    function lsKey(colour){ return LS_BASE + '::' + productHandle + '::' + (colour||''); }
    function sanitizeNumber(v){ return String(v||'').replace(/\D+/g,'').slice(0,2); }
    function debounce(fn, ms){
      var t = 0;
      return function(){
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function(){ fn.apply(null, args); }, ms);
      };
    }
    function nowMs(){ return (window.performance && typeof window.performance.now === 'function') ? window.performance.now() : Date.now(); }
    var kbNow = function(){ return (nowMs()/1000).toFixed(3); };
    var kbLog = function(){
      if(!isDebugEnabled()) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[KB ' + kbNow() + ']');
      console.log.apply(console, args);
    };

    var frontState = { url:null, loadedUrl:'', status:'idle', img:null, err:null };
    var backState  = { url:null, loadedUrl:'', status:'idle', img:null, err:null };
    var lightboxSide = '';
    var lightboxMode = '';
    var insideBadgePresets = {};
    var overlayImageCache = {
      badge: { src:'', img:null },
      sponsor: { src:'', img:null }
    };
    var FRONT_SELECTION_PADDING_PX = 6;
    var SHIRT_STATE_STORAGE_KEY = 'msh_kb_state_v1';
    var ACTIVE_BROCHURE_PAYLOAD_KEY = 'msh_kb_brochure_payload_v1';
    var SNAPSHOT_DB_NAME = 'msh_kb';
    var SNAPSHOT_STORE_NAME = 'snapshots';
    var SHIRT_SNAPSHOT_CAPTURE_TIMEOUT_MS = 900;
    var shirtConfigVersion = 0;
    var shirtCaptureToken = 0;
    var lastShirtConfigFingerprint = '';

    function clonePresetConfig(cfg){
      var src = cfg || {};
      return {
        ax: clamp(isFinite(src.ax) ? src.ax : 0.50, 0, 1),
        ay: clamp(isFinite(src.ay) ? src.ay : 0.83, 0, 1),
        s: clamp(isFinite(src.s) ? src.s : 0.30, 0.10, 0.60)
      };
    }

    function sanitizeInsideBadgePresets(extra){
      var merged = {};
      if(!extra || typeof extra !== 'object') return merged;
      Object.keys(extra).forEach(function(numberStr){
        var digitConfigs = extra[numberStr];
        if(!digitConfigs || typeof digitConfigs !== 'object') return;
        var next = {};
        Object.keys(digitConfigs).forEach(function(digitIndex){
          next[String(digitIndex)] = clonePresetConfig(digitConfigs[digitIndex]);
        });
        merged[numberStr] = next;
      });
      return merged;
    }

    function loadInsideBadgePresets(){
      insideBadgePresets = {};
      try{
        var raw = localStorage.getItem(INSIDE_BADGE_PRESET_STORAGE_KEY);
        if(!raw) return;
        var parsed = JSON.parse(raw);
        insideBadgePresets = sanitizeInsideBadgePresets(parsed);
      }catch(_insidePresetErr){}
    }

    function saveInsideBadgePresets(){
      try{ localStorage.setItem(INSIDE_BADGE_PRESET_STORAGE_KEY, JSON.stringify(insideBadgePresets)); }catch(_insidePresetSaveErr){}
    }

    function getInsideBadgePreset(numberStr, digitIndex){
      var digitPresets = insideBadgePresets[numberStr];
      if(!digitPresets) return null;
      return digitPresets[String(digitIndex)] || null;
    }

    function getInsideBadgeConfig(digitChar, numberStr, digitIndex){
      var preset = getInsideBadgePreset(numberStr, digitIndex);
      var fallback = INSIDE_BADGE_MAP[digitChar] || { ax:0.50, ay:0.83, s:0.30 };
      return clonePresetConfig(preset || fallback);
    }


    var insideTuneFields = {
      '0': {
        panel: root.querySelector('[data-kb-inside-digit-panel="0"]'),
        ax: root.querySelector('[data-kb-inside-ax="0"]'),
        ay: root.querySelector('[data-kb-inside-ay="0"]'),
        s: root.querySelector('[data-kb-inside-s="0"]'),
        axOut: root.querySelector('[data-kb-inside-ax-out="0"]'),
        ayOut: root.querySelector('[data-kb-inside-ay-out="0"]'),
        sOut: root.querySelector('[data-kb-inside-s-out="0"]')
      },
      '1': {
        panel: root.querySelector('[data-kb-inside-digit-panel="1"]'),
        ax: root.querySelector('[data-kb-inside-ax="1"]'),
        ay: root.querySelector('[data-kb-inside-ay="1"]'),
        s: root.querySelector('[data-kb-inside-s="1"]'),
        axOut: root.querySelector('[data-kb-inside-ax-out="1"]'),
        ayOut: root.querySelector('[data-kb-inside-ay-out="1"]'),
        sOut: root.querySelector('[data-kb-inside-s-out="1"]')
      }
    };

    function getCurrentNumberStr(){
      var value = sanitizeNumber(elNumber && elNumber.value);
      return value || '10';
    }

    function ensureInsideBadgePreset(numberStr, digitIndex){
      var key = String(digitIndex);
      if(!insideBadgePresets[numberStr]) insideBadgePresets[numberStr] = {};
      if(!insideBadgePresets[numberStr][key]){
        var digitChar = numberStr.charAt(digitIndex) || numberStr.charAt(0) || '0';
        insideBadgePresets[numberStr][key] = clonePresetConfig(INSIDE_BADGE_MAP[digitChar]);
      }
      return insideBadgePresets[numberStr][key];
    }

    function syncInsideTuneDigit(numberStr, digitIndex){
      var key = String(digitIndex);
      var field = insideTuneFields[key];
      if(!field) return;
      var isTwoDigits = numberStr.length > 1;
      if(field.panel) field.panel.hidden = (key === '1' && !isTwoDigits);
      var cfg = getInsideBadgeConfig(numberStr.charAt(digitIndex) || numberStr.charAt(0) || '0', numberStr, digitIndex);
      if(field.ax) field.ax.value = cfg.ax;
      if(field.ay) field.ay.value = cfg.ay;
      if(field.s) field.s.value = cfg.s;
      if(field.axOut) field.axOut.textContent = fmtTuneOut(cfg.ax);
      if(field.ayOut) field.ayOut.textContent = fmtTuneOut(cfg.ay);
      if(field.sOut) field.sOut.textContent = fmtTuneOut(cfg.s);
    }

    function syncInsideTunePanel(){
      if(!insideTunePanel) return;
      insideTunePanel.hidden = !KB_TUNE;
      if(!KB_TUNE) return;
      var numberStr = getCurrentNumberStr();
      if(insideTuneNumber) insideTuneNumber.textContent = numberStr;
      syncInsideTuneDigit(numberStr, 0);
      syncInsideTuneDigit(numberStr, 1);
    }

    function updateInsidePresetFromField(digitIndex, key, value){
      var numberStr = getCurrentNumberStr();
      var cfg = ensureInsideBadgePreset(numberStr, digitIndex);
      cfg[key] = (key === 's') ? clamp(value, 0.10, 0.60) : clamp(value, 0, 1);
      saveInsideBadgePresets();
      syncInsideTunePanel();
      Render.request('tune inside badge');
    }

    async function copyInsidePresetsToClipboard(){
      var json = JSON.stringify(insideBadgePresets, null, 2);
      if(navigator.clipboard && navigator.clipboard.writeText){
        await navigator.clipboard.writeText(json);
        return;
      }
      var temp = document.createElement('textarea');
      temp.value = json;
      temp.setAttribute('readonly', 'readonly');
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.focus();
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
    }

    function getSideState(which){
      return which === 'front' ? frontState : backState;
    }

    function setSideState(which, patch){
      var target = getSideState(which);
      if(!target || !patch) return;
      if(Object.prototype.hasOwnProperty.call(patch, 'url')) target.url = patch.url;
      if(Object.prototype.hasOwnProperty.call(patch, 'status')) target.status = patch.status;
      if(Object.prototype.hasOwnProperty.call(patch, 'loadedUrl')) target.loadedUrl = patch.loadedUrl;
      if(Object.prototype.hasOwnProperty.call(patch, 'img')) target.img = patch.img;
      if(Object.prototype.hasOwnProperty.call(patch, 'err')) target.err = patch.err;
      kbLog('load-state-' + which, { status:target.status, url:target.url, loadedUrl:target.loadedUrl || '', err:target.err ? String(target.err && target.err.message ? target.err.message : target.err) : '' });
      renderDebugPanel();
    }

    var scheduleRenderCount = 0;
    var lastRenderDurationMs = 0;
    var stageTapState = {};
    var mobileLockObserver = null;
    var builderInView = false;
    var digitSymbolsReadyPromise = null;
    var digitSymbolsReady = false;
    var numberCommitDebounced = null;
    var mobileOverlaySyncTimer = 0;

    function isMobileViewport(){
      return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    }

    function isOverlayMobileViewport(){
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function isMobileKB(){
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function syncKBMobileClass(){
      document.documentElement.classList.toggle('msh-kb-mobile', !!isMobileKB());
    }

    function syncMobileBodyLock(){
      var shouldLock = false;
      document.body.classList.toggle('kb-mobile-lock', shouldLock);
    }

    function setupMobileBodyLock(){
      builderInView = true;
      syncMobileBodyLock();
    }

    function syncAppModeScrollLock(){
      if(!sectionRoot) return;
      var lightboxOpen = !!(lightbox && !lightbox.hidden);
      sectionRoot.classList.toggle('kb-lightbox-open', lightboxOpen);
    }

    function renderDebugPanel(){
      if(!debugPanel) return;
      if(!isDebugEnabled()){
        debugPanel.hidden = true;
        return;
      }
      debugPanel.hidden = false;
      debugPanel.textContent = [
        'KB debug mode enabled',
        'colour: ' + (state && state.selectedColour ? state.selectedColour : '(none)'),
        'selected urls: front=' + (state && state.selectedMockupUrls ? (state.selectedMockupUrls.front || '(none)') : '(none)') + ' | back=' + (state && state.selectedMockupUrls ? (state.selectedMockupUrls.back || '(none)') : '(none)'),
        'front: [' + frontState.status + '] selected=' + (frontState.url || '(none)') + ' loaded=' + (frontState.loadedUrl || '(none)') + (frontState.err ? ('\n  err: ' + String(frontState.err && frontState.err.message ? frontState.err.message : frontState.err)) : ''),
        'back:  [' + backState.status + '] selected=' + (backState.url || '(none)') + ' loaded=' + (backState.loadedUrl || '(none)') + (backState.err ? ('\n  err: ' + String(backState.err && backState.err.message ? backState.err.message : backState.err)) : ''),
        'render: reason=' + lastRenderReason + ' token=' + renderToken + ' queued=' + (!!rafId) + ' inProgress=' + renderInProgress + ' scheduleHits=' + scheduleHits.length + ' totalSchedules=' + scheduleRenderCount + ' lastDurationMs=' + lastRenderDurationMs + ' loopTripped=' + loopTripped
      ].join('\n');
    }

    var imgCache = new Map();
    function loadImageElementWithTimeout(img, url, timeoutMs, label){
      var finalTimeout = (typeof timeoutMs === 'number' ? timeoutMs : IMAGE_LOAD_TIMEOUT_MS);
      return new Promise(function(resolve, reject){
        var settled = false;
        var timer = null;

        function settle(ok, err){
          if(settled) return;
          settled = true;
          if(timer) clearTimeout(timer);
          img.onload = null;
          img.onerror = null;
          if(ok){
            resolve(img);
            return;
          }
          reject(err);
        }

        img.onload = function(){ settle(true); };
        img.onerror = function(){ settle(false, new Error((label || 'Image') + ' load error: ' + url)); };
        timer = setTimeout(function(){
          settle(false, new Error((label || 'Image') + ' load timed out after ' + finalTimeout + 'ms: ' + url));
        }, finalTimeout);

        img.src = url;
        if(img.complete && img.naturalWidth > 0){
          settle(true);
        }

        if(typeof img.decode === 'function'){
          img.decode().catch(function(){});
        }
      });
    }

    function loadImageWithTimeout(url, timeoutMs){
      var finalTimeout = (typeof timeoutMs === 'number' ? timeoutMs : IMAGE_LOAD_TIMEOUT_MS);
      if(!url) return Promise.reject(new Error('Missing image URL'));

      var cached = imgCache.get(url);
      if(cached && cached.status === 'ok' && cached.img){
        kbLog('load-cache-hit-ok', { url:url });
        return Promise.resolve(cached.img);
      }
      if(cached && cached.status === 'loading' && cached.promise){
        kbLog('load-cache-hit-loading', { url:url });
        return cached.promise;
      }

      var t0 = nowMs();
      var img = new Image();
      var entry = { status:'loading', img:null, promise:null, t0:t0 };
      var promise = new Promise(function(resolve, reject){
        var settled = false;

        function settle(kind, err){
          if(settled) return;
          settled = true;
          var elapsed = Math.round(nowMs() - t0);

          if(kind === 'ok'){
            entry.status = 'ok';
            entry.img = img;
            entry.promise = null;
            imgCache.set(url, entry);
            kbLog('load ok', { url:url, elapsedMs:elapsed });
            resolve(img);
            return;
          }

          entry.status = 'error';
          entry.img = null;
          entry.promise = null;
          imgCache.delete(url);
          kbLog(kind === 'timeout' ? 'load timeout' : 'load error', { url:url, elapsedMs:elapsed, error:String(err && err.message ? err.message : err) });
          reject(err);
        }

        kbLog('load start', { url:url, timeoutMs:finalTimeout });
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        loadImageElementWithTimeout(img, url, finalTimeout, 'Mockup').then(function(){
          settle('ok');
        }).catch(function(err){
          if(err && err.message && err.message.indexOf('timed out') !== -1){
            settle('timeout', err);
            return;
          }
          settle('error', err || new Error('Could not load image: ' + url));
        });
      });

      entry.promise = promise;
      imgCache.set(url, entry);
      return promise;
    }

    function setSvgImageHref(imgEl, href){
      var next = href || '';
      if((imgEl.getAttribute('href') || '') === next) return;
      imgEl.setAttribute('href', next);
      imgEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', next);
    }

    var retryBtn = null;

    function setLoadingUI(side, isLoading, message){
      var target = side === 'front' ? loadingFront : loadingBack;
      if(!target) return;
      if(typeof message === 'string') target.textContent = message || 'Loading…';
      target.hidden = !isLoading;
      target.style.display = isLoading ? 'flex' : 'none';
      renderDebugPanel();
    }

    function shouldShowLoadingForSide(side){
      var sideState = getSideState(side);
      if(!sideState) return false;
      var selectedUrl = state && state.selectedMockupUrls ? (state.selectedMockupUrls[side] || '') : '';
      return sideState.status === 'loading' && !!sideState.url && sideState.url === selectedUrl && !sideState.img;
    }

    function updateLoadingIndicators(){
      var frontLoading = frontState && frontState.status === 'loading' && !frontState.img;
      var backLoading = backState && backState.status === 'loading' && !backState.img;
      setLoadingUI('front', !!frontLoading, 'Loading…');
      setLoadingUI('back', !!backLoading, 'Loading…');
    }

    function ensureRetryButton(){
      if(retryBtn || !elErr || !elErr.parentNode) return;
      retryBtn = document.createElement('button');
      retryBtn.type = 'button';
      retryBtn.className = 'msh-kb__btn';
      retryBtn.textContent = 'Retry mockups';
      retryBtn.style.marginTop = '8px';
      retryBtn.hidden = true;
      retryBtn.addEventListener('click', function(){
        if(frontState.url) imgCache.delete(frontState.url);
        if(backState.url) imgCache.delete(backState.url);
        if(state.selectedColour) setColour(state.selectedColour);
      });
      elErr.parentNode.appendChild(retryBtn);
    }

    function setRetryVisible(show){
      ensureRetryButton();
      if(retryBtn) retryBtn.hidden = !show;
    }

    function normalizeBuilderProduct(raw){
      if(!raw || typeof raw !== 'object') return null;

      var mediaItems = [];
      var sourceMedia = Array.isArray(raw.media) ? raw.media : [];
      for(var i = 0; i < sourceMedia.length; i++){
        var item = sourceMedia[i] || {};
        var src = item.src || (item.preview_image && item.preview_image.src) || '';
        if(!src) continue;
        mediaItems.push({
          id: item.id || null,
          alt: item.alt == null ? null : String(item.alt),
          src: src
        });
      }

      if(!mediaItems.length && Array.isArray(raw.images)){
        for(var j = 0; j < raw.images.length; j++){
          var imageSrc = String(raw.images[j] || '').trim();
          if(!imageSrc) continue;
          mediaItems.push({
            id: null,
            alt: null,
            src: imageSrc
          });
        }
      }

      var options = [];
      if(Array.isArray(raw.options)){
        for(var k = 0; k < raw.options.length; k++){
          var option = raw.options[k];
          options.push(typeof option === 'string' ? option : String(option && option.name ? option.name : ''));
        }
      }

      var variants = Array.isArray(raw.variants) ? raw.variants.map(function(variant){
        variant = variant || {};
        return {
          id: variant.id || null,
          title: variant.title || '',
          option1: variant.option1 || '',
          option2: variant.option2 || '',
          option3: variant.option3 || ''
        };
      }) : [];

      return {
        handle: raw.handle || '',
        title: raw.title || '',
        options: options,
        variants: variants,
        media: mediaItems
      };
    }

    async function fetchBuilderProductData(handle){
      var encodedHandle = encodeURIComponent(handle);
      var productDataUrl = '/products/' + encodedHandle + '?view=kb-product-data';
      var fallbackUrl = '/products/' + encodedHandle + '.js';

      try{
        var primaryRes = await fetch(productDataUrl, { credentials:'same-origin' });
        if(primaryRes.ok){
          var primaryPayload = await primaryRes.json();
          var primaryNormalized = normalizeBuilderProduct(primaryPayload);
          if(primaryNormalized) return primaryNormalized;
          console.error('[MSH Kit Builder] Primary product payload was not usable:', productDataUrl, primaryPayload);
        }else{
          console.error('[MSH Kit Builder] Primary product fetch failed:', productDataUrl, 'status', primaryRes.status);
        }
      }catch(primaryErr){
        console.error('[MSH Kit Builder] Primary product fetch error:', productDataUrl, primaryErr);
      }

      try{
        var fallbackRes = await fetch(fallbackUrl, { credentials:'same-origin' });
        if(!fallbackRes.ok){
          throw new Error('Fallback product fetch failed with status ' + fallbackRes.status);
        }
        var fallbackPayload = await fallbackRes.json();
        var fallbackNormalized = normalizeBuilderProduct(fallbackPayload);
        if(fallbackNormalized) return fallbackNormalized;
        throw new Error('Fallback product payload was not usable');
      }catch(fallbackErr){
        console.error('[MSH Kit Builder] Fallback product fetch error:', fallbackUrl, fallbackErr);
        throw new Error('Failed to load product handle "' + handle + '" from kb endpoint and fallback endpoint.');
      }
    }

    async function loadProductByHandle(handle){
      builderFetchStatus = 'fetching…';
      builderFetchFailStatus = '';
      renderDebugStrip();
      var product;
      try{
        product = await fetchBuilderProductData(handle);
      }catch(loadErr){
        builderFetchStatus = 'failed';
        builderFetchFailStatus = loadErr && loadErr.message ? loadErr.message : 'unknown error';
        renderDebugStrip();
        loadErr.handle = handle;
        throw loadErr;
      }
      builderFetchStatus = 'success';
      builderFetchFailStatus = '';
      builderLoadedTitle = String(product && product.title ? product.title : '');
      renderDebugStrip();
      return product;
    }

    async function findProductHandleByExactTitle(title){
      var wanted = norm(title);
      if(!wanted) return '';

      for(var page = 1; page <= 10; page++){
        var url = '/products.json?limit=250&page=' + page;
        var res = await fetch(url, { credentials:'same-origin' });
        if(!res.ok) break;
        var data = await res.json();
        var items = (data && data.products) ? data.products : [];
        if(!items.length) break;

        for(var i = 0; i < items.length; i++){
          var p = items[i] || {};
          if(norm(p.title) === wanted && p.handle){
            return String(p.handle);
          }
        }

        if(items.length < 250) break;
      }
      return '';
    }

    async function resolveSelectedBuilderProduct(){
      var modelName = getSelectedModelName();
      var candidateHandle = getSelectedHandle();

      if(candidateHandle){
        return {
          modelName: modelName,
          handle: candidateHandle,
          product: await loadProductByHandle(candidateHandle)
        };
      }

      return null;
    }

    function detectColourOptionIndex(product){
      var opts = (product && product.options) ? product.options : [];
      var targets = ['colour','color','colourway','colorway','colours','colors'];
      for(var i=0;i<opts.length;i++){
        var o = norm(opts[i]);
        for(var t=0;t<targets.length;t++){
          if(o === targets[t]) return i;
        }
      }
      return 0;
    }

    function buildColourList(product, idx){
      var set = {};
      (product.variants || []).forEach(function(v){
        var name = (idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3) || '';
        name = String(name).trim();
        if(name) set[name] = true;
      });
      return Object.keys(set).sort(function(a,b){ return a.localeCompare(b); });
    }

    function parseColourwayAlt(altRaw){
      var raw = String(altRaw || '').trim();
      if(!raw) return null;

      var parts = raw.split('|');
      if(parts.length !== 3) return null;

      var model = String(parts[0] || '').trim();
      var colourName = String(parts[1] || '').trim();
      var sideLabel = String(parts[2] || '').trim();
      if(!model || !colourName || !sideLabel) return null;

      var sideNorm = norm(sideLabel).replace(/\s+/g, '');
      var side = '';
      if(sideNorm === 'front') side = 'front';
      else if(sideNorm === 'back') side = 'back';
      else return null;

      return {
        model: model,
        modelNorm: norm(model),
        colourName: colourName,
        colourNorm: norm(colourName),
        side: side
      };
    }

    function cleanModelTitleForFallback(title){
      return String(title || '')
        .replace(/\(\s*builder\s*\)/ig, '')
        .replace(/\bshirt\b/ig, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    function deriveModelKey(product){
      var override = String(namespaceOverride || '').trim();
      if(override) return override;

      var media = (product && product.media) ? product.media : [];
      var counts = {};
      for(var i = 0; i < media.length; i++){
        var alt = String(media[i] && media[i].alt ? media[i].alt : '').trim();
        if(!alt || alt.indexOf('|') === -1) continue;
        var firstPart = String(alt.split('|')[0] || '').trim();
        if(!firstPart) continue;
        counts[firstPart] = (counts[firstPart] || 0) + 1;
      }

      var topKey = '';
      var topCount = 0;
      var keys = Object.keys(counts);
      for(var j = 0; j < keys.length; j++){
        var key = keys[j];
        if(counts[key] > topCount){
          topKey = key;
          topCount = counts[key];
        }
      }
      if(topKey) return topKey;

      return cleanModelTitleForFallback(product && product.title ? product.title : '');
    }

    function buildColourwaysFromMediaAlt(product, modelKey){
      var media = (product && product.media) ? product.media : [];
      var grouped = {};
      var namespaceNorm = norm(modelKey || '');

      function sourceBasename(src){
        var clean = String(src || '').split('?')[0].split('#')[0];
        var parts = clean.split('/');
        return String(parts[parts.length - 1] || '').trim();
      }

      function normalizeMockName(src){
        var base = sourceBasename(src)
          .toLowerCase()
          .replace(/\.[a-z0-9]+$/i, '')
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if(!base) return '';
        var filtered = base.split(' ').filter(function(token){
          return token && token !== 'front' && token !== 'back' && token !== 'f' && token !== 'b' && token !== 'mock' && token !== 'mockup';
        }).join('');
        return filtered.trim();
      }

      function commonPrefixLength(a, b){
        var max = Math.min(a.length, b.length);
        var idx = 0;
        while(idx < max && a.charAt(idx) === b.charAt(idx)) idx++;
        return idx;
      }

      function longestCommonSubstringLength(a, b){
        if(!a || !b) return 0;
        var prev = [];
        var best = 0;
        for(var bi = 0; bi <= b.length; bi++) prev[bi] = 0;
        for(var ai = 1; ai <= a.length; ai++){
          var curr = [0];
          for(var bj = 1; bj <= b.length; bj++){
            if(a.charAt(ai - 1) === b.charAt(bj - 1)){
              curr[bj] = (prev[bj - 1] || 0) + 1;
              if(curr[bj] > best) best = curr[bj];
            }else{
              curr[bj] = 0;
            }
          }
          prev = curr;
        }
        return best;
      }

      function scoreFrontAgainstBack(frontSrc, backSrc){
        var frontNorm = normalizeMockName(frontSrc);
        var backNorm = normalizeMockName(backSrc);
        if(!frontNorm || !backNorm) return 0;
        var prefixScore = commonPrefixLength(frontNorm, backNorm);
        var substringScore = longestCommonSubstringLength(frontNorm, backNorm);
        return Math.max(prefixScore, substringScore);
      }

      for(var i = 0; i < media.length; i++){
        var item = media[i] || {};
        var parsed = parseColourwayAlt(item.alt);
        var src = item.src || (item.preview_image && item.preview_image.src) || '';
        if(!parsed || !src) continue;
        if(namespaceNorm && parsed.modelNorm !== namespaceNorm) continue;

        var key = parsed.modelNorm + '::' + parsed.colourNorm;
        if(!grouped[key]){
          grouped[key] = {
            name: parsed.colourName,
            frontSrc: '',
            backSrc: '',
            frontCandidates: [],
            backCandidates: []
          };
        }

        if(parsed.side === 'front') grouped[key].frontCandidates.push(src);
        if(parsed.side === 'back') grouped[key].backCandidates.push(src);
      }

      var colourways = [];
      var keys = Object.keys(grouped);
      keys.sort(function(a, b){
        return grouped[a].name.localeCompare(grouped[b].name);
      });

      for(var j = 0; j < keys.length; j++){
        var colourway = grouped[keys[j]];
        var frontCandidates = colourway.frontCandidates || [];
        var backCandidates = colourway.backCandidates || [];
        var chosenBack = backCandidates.length ? backCandidates[0] : '';
        var chosenFront = frontCandidates.length ? frontCandidates[0] : '';

        if(chosenBack && frontCandidates.length > 1){
          var bestFront = frontCandidates[0];
          var bestScore = scoreFrontAgainstBack(bestFront, chosenBack);
          for(var k = 1; k < frontCandidates.length; k++){
            var frontCandidate = frontCandidates[k];
            var score = scoreFrontAgainstBack(frontCandidate, chosenBack);
            if(score > bestScore){
              bestScore = score;
              bestFront = frontCandidate;
            }
          }
          chosenFront = bestFront;
        }

        if(!chosenBack && chosenFront) chosenBack = chosenFront;
        if(!chosenFront && chosenBack) chosenFront = chosenBack;
        if(!chosenFront && !chosenBack) continue;

        colourways.push({
          name: colourway.name,
          frontSrc: chosenFront,
          backSrc: chosenBack
        });
      }

      return colourways;
    }

    function deriveColourways(product, modelKey){
      var fromAlt = buildColourwaysFromMediaAlt(product, modelKey);
      if(fromAlt.length) return fromAlt;

      var colourIdx = detectColourOptionIndex(product);
      var fallbackNames = buildColourList(product, colourIdx).filter(function(name){
        return norm(name) !== 'default title';
      });
      return fallbackNames.map(function(name){
        return { name: name, frontSrc: '', backSrc: '' };
      });
    }

    function deriveColourwayState(product){
      var modelKey = deriveModelKey(product);
      return {
        modelKey: modelKey,
        colourways: deriveColourways(product, modelKey)
      };
    }

    function getColourwayByName(colour){
      var list = state && state.colourways ? state.colourways : [];
      for(var i = 0; i < list.length; i++){
        if(list[i] && list[i].name === colour) return list[i];
      }
      return null;
    }

    function matchMockupUrls(product, colour){
      var colourway = getColourwayByName(colour);
      if(colourway){
        return {
          front: colourway.frontSrc || '',
          back: colourway.backSrc || ''
        };
      }
      return { front: '', back: '' };
    }

    async function readFileAsDataURL(file){
      return await new Promise(function(resolve, reject){
        var fr = new FileReader();
        fr.onload = function(){ resolve(fr.result); };
        fr.onerror = function(){ reject(new Error('Could not read file')); };
        fr.readAsDataURL(file);
      });
    }

    async function readImageAspectFromFile(file){
      return await new Promise(function(resolve, reject){
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function(){
          URL.revokeObjectURL(url);
          var w = img.naturalWidth || img.width || 1;
          var h = img.naturalHeight || img.height || 1;
          if(!w || !h) return reject(new Error('Could not detect image dimensions'));
          resolve(w / h);
        };
        img.onerror = function(){
          URL.revokeObjectURL(url);
          reject(new Error('Could not load image dimensions'));
        };
        img.src = url;
      });
    }

    async function fetchSvgText(url){
      var res = await fetch(url, { mode:'cors' });
      var txt = await res.text();
      if(txt.trim().charAt(0) !== '<') throw new Error('Not SVG at ' + url);
      return txt;
    }

    function extractSvgInner(svgText){
      var vb = '0 0 1024 1024';
      var m = svgText.match(/viewBox="([^"]+)"/i);
      if(m && m[1]) vb = m[1];
      var inner = svgText.replace(/^[\s\S]*?<svg[^>]*>/i,'').replace(/<\/svg>\s*$/i,'');
      return { viewBox: vb, inner: inner };
    }

    function parseSvgRoot(svgText){
      var parser = new DOMParser();
      var doc = parser.parseFromString(svgText, 'image/svg+xml');
      if(!doc || !doc.documentElement) throw new Error('Invalid SVG XML');

      var rootEl = doc.documentElement;
      var rootTag = (rootEl.tagName || '').toLowerCase();
      if(rootTag !== 'svg') throw new Error('SVG root element missing');

      if(doc.getElementsByTagName('parsererror').length){
        throw new Error('SVG parser error');
      }

      return rootEl;
    }

    function getBadgeSlotFromDigitSvg(svgText){
      var doc = new DOMParser().parseFromString(svgText || '', 'image/svg+xml');
      if(!doc || !doc.documentElement || String(doc.documentElement.tagName || '').toLowerCase() !== 'svg') return null;

      var svgEl = doc.documentElement;
      var vb = parseSvgViewBoxMetric(svgEl);
      if(!vb) return null;

      var slot = doc.querySelector('rect#badge-slot');
      if(!slot) slot = doc.querySelector('rect[id*="badge" i]');
      if(!slot){
        var noneRects = Array.prototype.slice.call(doc.querySelectorAll('rect')).filter(function(rectEl){
          var fillVal = (rectEl.getAttribute('fill') || '').trim().toLowerCase();
          return fillVal === 'none';
        });
        if(noneRects.length) slot = noneRects[noneRects.length - 1];
      }
      if(!slot) return null;

      var x = parseFloat(slot.getAttribute('x'));
      var y = parseFloat(slot.getAttribute('y'));
      var width = parseFloat(slot.getAttribute('width'));
      var height = parseFloat(slot.getAttribute('height'));
      if(!isFinite(x) || !isFinite(y) || !isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) return null;

      return {
        x: x,
        y: y,
        width: width,
        height: height,
        viewBox: { minX:vb.x, minY:vb.y, w:vb.w, h:vb.h }
      };
    }

    function parseSvgViewBoxMetric(svgEl){
      if(!svgEl) return null;
      var vb = String(svgEl.getAttribute('viewBox') || '').trim().split(/\s+/).map(function(v){ return parseFloat(v); });
      if(vb.length !== 4 || !isFinite(vb[2]) || !isFinite(vb[3]) || vb[2] <= 0 || vb[3] <= 0) return null;
      return {
        x: isFinite(vb[0]) ? vb[0] : 0,
        y: isFinite(vb[1]) ? vb[1] : 0,
        w: vb[2],
        h: vb[3]
      };
    }


    function colorToken(v){
      return String(v || '').trim().toLowerCase().replace(/\s+/g, '');
    }

    function classifyDigitNodeLayer(node){
      var style = parseStyleMap(node.getAttribute('style'));
      var fill = colorToken(node.getAttribute('fill') || style.fill || '');
      var stroke = colorToken(node.getAttribute('stroke') || style.stroke || '');
      if(fill === 'white' || fill === '#fff' || fill === '#ffffff' || fill === 'rgb(255,255,255)') return 'fill';
      if(fill === '#999' || fill === '#999999' || fill === 'rgb(153,153,153)') return 'outline';
      if(stroke && !isNoPaintValue(stroke)) return 'outline';
      return 'fill';
    }

    function recolorLeafNode(node, color){
      var style = parseStyleMap(node.getAttribute('style'));
      var fill = colorToken(node.getAttribute('fill') || style.fill || '');
      var stroke = colorToken(node.getAttribute('stroke') || style.stroke || '');

      if(fill && !isNoPaintValue(fill) && !hasPaintServerRef(fill)) node.setAttribute('fill', color);
      if(stroke && !isNoPaintValue(stroke) && !hasPaintServerRef(stroke)) node.setAttribute('stroke', color);

      if(typeof style.fill !== 'undefined' && !isNoPaintValue(style.fill) && !hasPaintServerRef(style.fill)) style.fill = color;
      if(typeof style.stroke !== 'undefined' && !isNoPaintValue(style.stroke) && !hasPaintServerRef(style.stroke)) style.stroke = color;
      var nextStyle = styleMapToString(style);
      if(nextStyle) node.setAttribute('style', nextStyle); else node.removeAttribute('style');
    }

    function encodeSvgDataUrl(svgText){
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgText);
    }

    function getBadgeCacheToken(badgeDataUrl){
      var raw = String(badgeDataUrl || '');
      if(!raw) return 'none';
      return raw.slice(0, 96) + '|len:' + raw.length;
    }

    function findDigitOutlineAnchor(svgEl){
      if(!svgEl) return null;

      var directAnchor = svgEl.querySelector('.kb-outline, [data-kb="outline"], #outline, .outline');
      if(directAnchor) return directAnchor;

      var nodes = svgEl.querySelectorAll('*');
      for(var i=nodes.length - 1; i>=0; i--){
        var node = nodes[i];
        if(String(node.tagName || '').toLowerCase() === 'defs') continue;
        var styleMap = parseStyleMap(node.getAttribute('style'));
        var stroke = node.getAttribute('stroke') || styleMap.stroke || '';
        if(stroke && !isNoPaintValue(stroke)) return node;
      }
      return null;
    }

    function buildDigitComposedSvgText(digitChar, badgeDataUrl){
      var sourceText = state.digitSvgSource[digitChar] || '';
      if(!sourceText) return '';

      try{
        var parsedDoc = new DOMParser().parseFromString(sourceText, 'image/svg+xml');
        if(!parsedDoc || !parsedDoc.documentElement || String(parsedDoc.documentElement.tagName || '').toLowerCase() !== 'svg'){
          return sourceText;
        }

        var parsedRoot = parsedDoc.documentElement;
        var originalViewBox = parsedRoot.getAttribute('viewBox') || '0 0 1024 1024';

        var composedDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', null);
        var svgEl = composedDoc.documentElement;
        svgEl.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svgEl.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        svgEl.setAttribute('viewBox', originalViewBox);
        svgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet');

        var defsEl = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'defs');
        var wrapper = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'g');
        wrapper.setAttribute('id', 'kb-digit-root');

        var kids = parsedRoot.childNodes;
        for(var k=0; k<kids.length; k++){
          var kid = kids[k];
          if(kid.nodeType === 1 && String(kid.tagName || '').toLowerCase() === 'defs'){
            var defKids = kid.childNodes;
            for(var dk=0; dk<defKids.length; dk++) defsEl.appendChild(composedDoc.importNode(defKids[dk], true));
            continue;
          }
          wrapper.appendChild(composedDoc.importNode(kid, true));
        }

        var slotNode = wrapper.querySelector('rect#badge-slot');
        var slotGeometry = null;
        if(slotNode){
          var slotX = parseFloat(slotNode.getAttribute('x'));
          var slotY = parseFloat(slotNode.getAttribute('y'));
          var slotW = parseFloat(slotNode.getAttribute('width'));
          var slotH = parseFloat(slotNode.getAttribute('height'));
          if(isFinite(slotX) && isFinite(slotY) && isFinite(slotW) && isFinite(slotH) && slotW > 0 && slotH > 0){
            slotGeometry = { x:slotX, y:slotY, w:slotW, h:slotH };
          }
          slotNode.setAttribute('fill', 'none');
          slotNode.setAttribute('stroke', 'none');
          slotNode.setAttribute('opacity', '0');
          slotNode.setAttribute('pointer-events', 'none');
        }

        var existingLayer = wrapper.querySelector('#kb-badge-layer');
        if(existingLayer && existingLayer.parentNode) existingLayer.parentNode.removeChild(existingLayer);
        var existingClip = defsEl.querySelector('#kb-badge-clip');
        if(existingClip && existingClip.parentNode) existingClip.parentNode.removeChild(existingClip);
        var clipUsers = wrapper.querySelectorAll('[clip-path="url(#kb-badge-clip)"]');
        for(var cu=0; cu<clipUsers.length; cu++) clipUsers[cu].removeAttribute('clip-path');

        if(badgeDataUrl && slotGeometry){
          var padding = 0.90;
          var paddedW = slotGeometry.w * padding;
          var paddedH = slotGeometry.h * padding;
          var paddedX = slotGeometry.x + ((slotGeometry.w - paddedW) * 0.5);
          var paddedY = slotGeometry.y + ((slotGeometry.h - paddedH) * 0.5);

          var clipId = 'kb-badge-clip';
          var clipPathEl = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
          clipPathEl.setAttribute('id', clipId);
          var clipRect = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'rect');
          clipRect.setAttribute('x', String(paddedX));
          clipRect.setAttribute('y', String(paddedY));
          clipRect.setAttribute('width', String(paddedW));
          clipRect.setAttribute('height', String(paddedH));
          clipPathEl.appendChild(clipRect);
          defsEl.appendChild(clipPathEl);

          var badgeLayer = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'g');
          badgeLayer.setAttribute('id', 'kb-badge-layer');
          var badgeImage = composedDoc.createElementNS('http://www.w3.org/2000/svg', 'image');
          badgeImage.setAttribute('href', badgeDataUrl);
          badgeImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', badgeDataUrl);
          badgeImage.setAttribute('x', String(paddedX));
          badgeImage.setAttribute('y', String(paddedY));
          badgeImage.setAttribute('width', String(paddedW));
          badgeImage.setAttribute('height', String(paddedH));
          badgeImage.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          badgeImage.setAttribute('clip-path', 'url(#' + clipId + ')');
          badgeLayer.appendChild(badgeImage);

          var outlineAnchor = findDigitOutlineAnchor(wrapper);
          if(outlineAnchor && outlineAnchor.parentNode) outlineAnchor.parentNode.insertBefore(badgeLayer, outlineAnchor);
          else wrapper.appendChild(badgeLayer);
        }

        svgEl.appendChild(defsEl);
        svgEl.appendChild(wrapper);
        return new XMLSerializer().serializeToString(svgEl);
      }catch(e){
        return sourceText;
      }
    }

    function buildDigitRenderLayers(digitChar, badgeDataUrl){
      var cacheKey = digitChar + '|' + getBadgeCacheToken(badgeDataUrl);
      if(state.digitLayerRenderCache[cacheKey]) return state.digitLayerRenderCache[cacheKey];

      var sourceText = state.digitSvgSource[digitChar] || '';
      if(!sourceText) return null;
      var builtSvg = buildDigitComposedSvgText(digitChar, badgeDataUrl);

      var out = {
        composedDataUrl: encodeSvgDataUrl(builtSvg)
      };
      state.digitLayerRenderCache[cacheKey] = out;
      return out;
    }

    function appendDigitInstanceWithBadge(numberLayer, digitChar, digitBox, badgeDataUrl, badgeUid){
      if(!numberLayer || !digitBox) return;
      var symbolId = 'kb-digit-' + digitChar;
      var symbol = defsBack ? defsBack.querySelector('#' + symbolId) : null;
      if(!symbol) return;

      var viewBoxParts = String(symbol.getAttribute('viewBox') || '0 0 1024 1024').trim().split(/\s+/).map(function(v){ return parseFloat(v); });
      var symbolViewBox = (viewBoxParts.length === 4 && isFinite(viewBoxParts[2]) && isFinite(viewBoxParts[3]) && viewBoxParts[2] > 0 && viewBoxParts[3] > 0)
        ? { x:viewBoxParts[0] || 0, y:viewBoxParts[1] || 0, w:viewBoxParts[2], h:viewBoxParts[3] }
        : { x:0, y:0, w:1024, h:1024 };

      var digitRoot = createSvgElement('g');

      var symbolChildren = symbol.childNodes;
      for(var si=0; si<symbolChildren.length; si++){
        digitRoot.appendChild(symbolChildren[si].cloneNode(true));
      }

      var nestedSvgs = digitRoot.querySelectorAll('svg');
      for(var ns=0; ns<nestedSvgs.length; ns++){
        nestedSvgs[ns].setAttribute('preserveAspectRatio', 'xMidYMid meet');
      }

      var uniformScale = digitBox.h / symbolViewBox.h;
      var tx = digitBox.x - (symbolViewBox.x * uniformScale);
      var ty = digitBox.y - (symbolViewBox.y * uniformScale);
      digitRoot.setAttribute('transform', 'translate(' + tx + ' ' + ty + ') scale(' + uniformScale + ')');

      var oldLayers = digitRoot.querySelectorAll('#kb-badge-layer');
      for(var ol=0; ol<oldLayers.length; ol++){
        if(oldLayers[ol] && oldLayers[ol].parentNode) oldLayers[ol].parentNode.removeChild(oldLayers[ol]);
      }
      var oldBadgeDefs = digitRoot.querySelectorAll('clipPath[id^="kb-badge-clip-"]');
      for(var obd=0; obd<oldBadgeDefs.length; obd++){
        if(oldBadgeDefs[obd] && oldBadgeDefs[obd].parentNode) oldBadgeDefs[obd].parentNode.removeChild(oldBadgeDefs[obd]);
      }
      var oldBadgeClipUsers = digitRoot.querySelectorAll('[clip-path^="url(#kb-badge-clip-"]');
      for(var obu=0; obu<oldBadgeClipUsers.length; obu++) oldBadgeClipUsers[obu].removeAttribute('clip-path');

      var slotNode = digitRoot.querySelector('rect#badge-slot');
      if(slotNode){
        slotNode.setAttribute('fill', 'none');
        slotNode.setAttribute('stroke', 'none');
        slotNode.setAttribute('opacity', '0');
        slotNode.setAttribute('pointer-events', 'none');
      }

      if(slotNode && badgeDataUrl){
        var slotX = parseFloat(slotNode.getAttribute('x'));
        var slotY = parseFloat(slotNode.getAttribute('y'));
        var slotW = parseFloat(slotNode.getAttribute('width'));
        var slotH = parseFloat(slotNode.getAttribute('height'));
        if(isFinite(slotX) && isFinite(slotY) && isFinite(slotW) && isFinite(slotH) && slotW > 0 && slotH > 0){
          var defsNode = digitRoot.querySelector('defs');
          if(!defsNode){
            defsNode = createSvgElement('defs');
            digitRoot.insertBefore(defsNode, digitRoot.firstChild);
          }

          var clipId = 'kb-badge-clip-' + badgeUid;
          var clipPathEl = createSvgElement('clipPath');
          clipPathEl.setAttribute('id', clipId);

          var padding = 0.90;
          var paddedW = slotW * padding;
          var paddedH = slotH * padding;
          var paddedX = slotX + ((slotW - paddedW) * 0.5);
          var paddedY = slotY + ((slotH - paddedH) * 0.5);

          var clipRect = createSvgElement('rect');
          clipRect.setAttribute('x', String(paddedX));
          clipRect.setAttribute('y', String(paddedY));
          clipRect.setAttribute('width', String(paddedW));
          clipRect.setAttribute('height', String(paddedH));
          clipPathEl.appendChild(clipRect);
          defsNode.appendChild(clipPathEl);

          var badgeLayer = createSvgElement('g');
          badgeLayer.setAttribute('id', 'kb-badge-layer');
          var badgeImage = createSvgElement('image');
          badgeImage.setAttribute('href', badgeDataUrl);
          badgeImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', badgeDataUrl);
          badgeImage.setAttribute('x', String(paddedX));
          badgeImage.setAttribute('y', String(paddedY));
          badgeImage.setAttribute('width', String(paddedW));
          badgeImage.setAttribute('height', String(paddedH));
          badgeImage.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          badgeImage.setAttribute('clip-path', 'url(#' + clipId + ')');
          badgeLayer.appendChild(badgeImage);

          var outlineAnchor = findDigitOutlineAnchor(digitRoot);
          if(outlineAnchor && outlineAnchor.parentNode) outlineAnchor.parentNode.insertBefore(badgeLayer, outlineAnchor);
          else digitRoot.appendChild(badgeLayer);
        }
      }

      numberLayer.appendChild(digitRoot);
    }

    function clearNode(el){ while(el.firstChild) el.removeChild(el.firstChild); }
    function createSvgElement(tag){ return document.createElementNS('http://www.w3.org/2000/svg', tag); }

    function parseStyleMap(style){
      var map = {};
      var parts = String(style || '').split(';');
      for(var i=0; i<parts.length; i++){
        var p = parts[i];
        if(!p) continue;
        var idx = p.indexOf(':');
        if(idx === -1) continue;
        var key = p.slice(0, idx).trim().toLowerCase();
        var value = p.slice(idx + 1).trim();
        if(key) map[key] = value;
      }
      return map;
    }
    function styleMapToString(map){
      var out = [];
      var keys = Object.keys(map || {});
      for(var i=0; i<keys.length; i++){
        var key = keys[i];
        if(!key) continue;
        out.push(key + ':' + map[key]);
      }
      return out.join('; ');
    }
    function isNoPaintValue(v){
      return /^(none|transparent)$/i.test(String(v || '').trim());
    }
    function hasPaintServerRef(v){
      return /^url\(\s*#.+\)$/i.test(String(v || '').trim());
    }
    function isInsideSvgContainer(el, containerTag){
      var node = el;
      var wanted = String(containerTag || '').toLowerCase();
      while(node && node.nodeType === 1){
        if((node.tagName || '').toLowerCase() === wanted) return true;
        node = node.parentNode;
      }
      return false;
    }

    function shouldSkipDigitElement(el){
      if(!el || el.nodeType !== 1) return true;

      if(isInsideSvgContainer(el, 'defs')) return true;
      if(isInsideSvgContainer(el, 'clippath')) return true;
      if(isInsideSvgContainer(el, 'mask')) return true;

      return false;
    }

    function parseOpacity(v){
      if(v === null || typeof v === 'undefined' || String(v).trim() === '') return null;
      var n = parseFloat(String(v).trim());
      if(!isFinite(n)) return null;
      return n;
    }

    function getComputedPaintInfo(el, computed, type){
      var styleMap = parseStyleMap(el.getAttribute('style'));
      var attrVal = el.getAttribute(type);
      var styleVal = styleMap[type];
      var computedVal = computed ? computed.getPropertyValue(type) : '';
      var opacityAttr = el.getAttribute(type + '-opacity');
      var opacityStyle = styleMap[type + '-opacity'];
      var computedOpacity = computed ? computed.getPropertyValue(type + '-opacity') : '';

      var opacity = parseOpacity(opacityAttr);
      if(opacity === null) opacity = parseOpacity(opacityStyle);
      if(opacity === null) opacity = parseOpacity(computedOpacity);

      return {
        attrVal: attrVal,
        styleVal: styleVal,
        computedVal: computedVal,
        hasExplicit: attrVal !== null || typeof styleVal !== 'undefined',
        isNone: isNoPaintValue(attrVal) || isNoPaintValue(styleVal) || isNoPaintValue(computedVal),
        isZeroOpacity: opacity !== null && opacity <= 0,
        usesPaintServer: hasPaintServerRef(attrVal) || hasPaintServerRef(styleVal) || hasPaintServerRef(computedVal)
      };
    }

    function hasVisiblePaint(el, type, computed){
      var info = getComputedPaintInfo(el, computed, type);
      if(info.isNone || info.isZeroOpacity || info.usesPaintServer) return false;
      return true;
    }

    function parseRgbComponents(v){
      var val = String(v || '').trim();
      if(!val) return null;

      var hex = val.match(/^#([0-9a-f]{3,8})$/i);
      if(hex){
        var raw = hex[1];
        if(raw.length === 3 || raw.length === 4){
          return {
            r: parseInt(raw.charAt(0) + raw.charAt(0), 16),
            g: parseInt(raw.charAt(1) + raw.charAt(1), 16),
            b: parseInt(raw.charAt(2) + raw.charAt(2), 16)
          };
        }
        if(raw.length === 6 || raw.length === 8){
          return {
            r: parseInt(raw.slice(0,2), 16),
            g: parseInt(raw.slice(2,4), 16),
            b: parseInt(raw.slice(4,6), 16)
          };
        }
      }

      var rgb = val.match(/^rgba?\(\s*([\d.]+)\s*[, ]\s*([\d.]+)\s*[, ]\s*([\d.]+)/i);
      if(rgb){
        return {
          r: Math.max(0, Math.min(255, parseFloat(rgb[1]))),
          g: Math.max(0, Math.min(255, parseFloat(rgb[2]))),
          b: Math.max(0, Math.min(255, parseFloat(rgb[3])))
        };
      }

      return null;
    }

    function luminanceForPaint(v){
      var rgb = parseRgbComponents(v);
      if(!rgb) return null;
      return (0.2126 * rgb.r) + (0.7152 * rgb.g) + (0.0722 * rgb.b);
    }

    function classifyDigitPaintTarget(paintInfo){
      var l = luminanceForPaint(paintInfo && paintInfo.computedVal);
      if(l === null){
        l = luminanceForPaint(paintInfo && paintInfo.styleVal);
      }
      if(l === null){
        l = luminanceForPaint(paintInfo && paintInfo.attrVal);
      }

      if(l === null) return null;
      return l >= 200 ? 'fill' : 'stroke';
    }

    function writePaintValue(el, type, value){
      if(!el || el.nodeType !== 1) return;

      var styleMap = parseStyleMap(el.getAttribute('style'));
      if(typeof styleMap[type] !== 'undefined'){
        styleMap[type] = value;
        var rebuilt = styleMapToString(styleMap);
        if(rebuilt) el.setAttribute('style', rebuilt);
        else el.removeAttribute('style');
      }

      if(el.hasAttribute(type) || typeof styleMap[type] === 'undefined'){
        el.setAttribute(type, value);
      }
    }

    function forceDigitColours(node, digitKey){
      if(!node) return;

      var debugDigitRewrite = window && window.MSH_DIGIT_REWRITE_DEBUG === true;

      var paintable = {
        path: true,
        rect: true,
        circle: true,
        ellipse: true,
        polygon: true,
        polyline: true,
        line: true,
        text: true
      };

      var sandbox = createSvgElement('g');
      sandbox.setAttribute('opacity', '0');
      sandbox.setAttribute('pointer-events', 'none');
      sandbox.setAttribute('aria-hidden', 'true');
      sandbox.appendChild(node);
      svgBack.appendChild(sandbox);

      var recolouredCount = 0;

      try{
        var all = node.querySelectorAll('*');
        for(var i=0; i<all.length; i++){
          var el = all[i];
          var tag = (el.tagName || '').toLowerCase();
          if(!paintable[tag]) continue;

          if(shouldSkipDigitElement(el)){
            if(debugDigitRewrite) console.log('[MSH KB digit rewrite] skipped', tag, el);
            continue;
          }

          var computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
          var fillInfo = getComputedPaintInfo(el, computed, 'fill');
          var strokeInfo = getComputedPaintInfo(el, computed, 'stroke');
          var hasFill = hasVisiblePaint(el, 'fill', computed);
          var hasStroke = hasVisiblePaint(el, 'stroke', computed);
          var fillTarget = hasFill ? classifyDigitPaintTarget(fillInfo) : null;
          var strokeTarget = hasStroke ? classifyDigitPaintTarget(strokeInfo) : null;

          if(!fillTarget && !strokeTarget){
            if(debugDigitRewrite) console.log('[MSH KB digit rewrite] no-op', tag, el);
            continue;
          }

          if(fillTarget === 'fill') writePaintValue(el, 'fill', 'var(--kb-fill)');
          if(fillTarget === 'stroke') writePaintValue(el, 'fill', 'var(--kb-stroke)');
          if(strokeTarget === 'fill') writePaintValue(el, 'stroke', 'var(--kb-fill)');
          if(strokeTarget === 'stroke') writePaintValue(el, 'stroke', 'var(--kb-stroke)');

          recolouredCount += 1;

          if(debugDigitRewrite){
            console.log('[MSH KB digit rewrite] recoloured', {
              tag: tag,
              fill: fillTarget,
              stroke: strokeTarget,
              element: el
            });
          }
        }
      }finally{
        svgBack.removeChild(sandbox);
      }

      if(!recolouredCount){
        throw new Error('Digit ' + digitKey + ' has no paintable shapes after recolour.');
      }
    }

    function normalizeManualColor(value){
      var v = String(value || '').trim();
      if(!v || /^transparent$/i.test(v) || /^none$/i.test(v)) return '';
      return v;
    }

    function normalizeHexColor(value){
      var v = String(value || '').trim();
      if(!v) return '';
      var m = v.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
      if(!m) return '';
      var hex = m[1].toLowerCase();
      if(hex.length === 3) hex = hex.split('').map(function(ch){ return ch + ch; }).join('');
      return '#' + hex;
    }

    function paintNapeNode(node, color){
      if(!node || node.nodeType !== 1 || !color) return;
      var styleMap = parseStyleMap(node.getAttribute('style'));
      if(typeof styleMap.fill !== 'undefined') styleMap.fill = color;
      if(typeof styleMap.stroke !== 'undefined') styleMap.stroke = color;
      var rebuiltStyle = styleMapToString(styleMap);
      if(rebuiltStyle) node.setAttribute('style', rebuiltStyle);
      else if(node.hasAttribute('style')) node.removeAttribute('style');
      if(node.hasAttribute('fill')) node.setAttribute('fill', color);
      if(node.hasAttribute('stroke')) node.setAttribute('stroke', color);
      var tag = String(node.tagName || '').toLowerCase();
      var paintable = { path:true, rect:true, circle:true, ellipse:true, polygon:true, polyline:true, line:true, text:true };
      if(paintable[tag]){
        node.setAttribute('fill', color);
        node.setAttribute('stroke', color);
      }
    }

    function markNapeParts(rootNode){
      if(!rootNode || rootNode.nodeType !== 1) return;

      function findByName(parts){
        var all = rootNode.querySelectorAll('*');
        for(var i=0; i<all.length; i++){
          var node = all[i];
          var id = String(node.getAttribute('id') || '').toLowerCase();
          var cls = String(node.getAttribute('class') || '').toLowerCase();
          for(var j=0; j<parts.length; j++){
            if(id.indexOf(parts[j]) !== -1 || cls.indexOf(parts[j]) !== -1) return node;
          }
        }
        return null;
      }

      var idWordmark = findByName(['wordmark', 'macron', 'wording']);
      var idSquares = findByName(['social', 'squares', 'square', 'icons', 'icon']);
      if(idWordmark || idSquares){
        if(idWordmark) idWordmark.setAttribute('data-kb-nape-part', 'wording');
        if(idSquares) idSquares.setAttribute('data-kb-nape-part', 'squares');
        return;
      }

      var paintNodes = rootNode.querySelectorAll('path, rect, circle, ellipse, polygon, polyline, line, text, g');
      for(var i=0; i<paintNodes.length; i++){
        var node = paintNodes[i];
        if(node.hasAttribute('data-kb-nape-part')) continue;
        var bb = null;
        try{ bb = typeof node.getBBox === 'function' ? node.getBBox() : null; }catch(_bbErr){ bb = null; }
        if(bb && isFinite(bb.x) && isFinite(bb.width) && bb.width > 0){
          var centerX = bb.x + (bb.width / 2);
          node.setAttribute('data-kb-nape-part', centerX < 820 ? 'squares' : 'wording');
          continue;
        }
        var fillAttr = String(node.getAttribute('fill') || '').toLowerCase();
        node.setAttribute('data-kb-nape-part', fillAttr === '#999999' ? 'squares' : 'wording');
      }
    }

    function recolorNapeSvg(svgText, textColor, squaresColor){
      if(!svgText) return svgText;

      var parsedRoot = parseSvgRoot(svgText);
      markNapeParts(parsedRoot);

      var all = parsedRoot.querySelectorAll('[data-kb-nape-part]');
      for(var i=0; i<all.length; i++){
        var el = all[i];
        var role = el.getAttribute('data-kb-nape-part');
        var color = role === 'squares' ? squaresColor : textColor;
        paintNapeNode(el, color);
      }

      var serializer = new XMLSerializer();
      return serializer.serializeToString(parsedRoot);
    }

    function parseStrokeWidthPx(v){
      if(v === null || typeof v === 'undefined') return 0;
      var n = parseFloat(String(v).replace('px', '').trim());
      if(!isFinite(n) || n < 0) return 0;
      return n;
    }

    function getSymbolStrokeInflation(symbolEl){
      if(!symbolEl) return 0;
      var maxStroke = 0;
      var nodes = symbolEl.querySelectorAll('*');
      for(var i=0;i<nodes.length;i++){
        var sw = parseStrokeWidthPx(nodes[i].getAttribute('stroke-width'));
        if(sw > maxStroke) maxStroke = sw;
        var styleMap = parseStyleMap(nodes[i].getAttribute('style'));
        var styleStroke = parseStrokeWidthPx(styleMap['stroke-width']);
        if(styleStroke > maxStroke) maxStroke = styleStroke;
      }
      return maxStroke * 0.5;
    }

    async function rasterAnalyzeDigit(symbolMarkup, symbolId, sourceBox){
      var deadline = nowMs() + DIGIT_RASTER_BUDGET_MS;
      function checkBudget(){
        if(nowMs() > deadline){
          var timeoutErr = new Error('Raster metrics exceeded budget (' + DIGIT_RASTER_BUDGET_MS + 'ms)');
          timeoutErr.code = 'KB_METRICS_TIMEOUT';
          throw timeoutErr;
        }
      }

      checkBudget();
      var sample = 240;
      var svgText = '' +
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ' +
        'viewBox="' + sourceBox.x + ' ' + sourceBox.y + ' ' + sourceBox.w + ' ' + sourceBox.h + '">' +
        '<defs>' + symbolMarkup + '</defs>' +
        '<rect x="' + sourceBox.x + '" y="' + sourceBox.y + '" width="' + sourceBox.w + '" height="' + sourceBox.h + '" fill="transparent" />' +
        '<g style="--kb-fill:#ffffff;--kb-stroke:#ffffff;">' +
        '<use href="#' + symbolId + '" xlink:href="#' + symbolId + '" />' +
        '</g>' +
        '</svg>';

      var blob = new Blob([svgText], { type:'image/svg+xml;charset=utf-8' });
      var url = URL.createObjectURL(blob);

      try{
        var img = new Image();
        img.crossOrigin = 'anonymous';
        await loadImageElementWithTimeout(img, url, IMAGE_LOAD_TIMEOUT_MS, 'Digit raster probe');
        checkBudget();

        var c = document.createElement('canvas');
        c.width = sample;
        c.height = sample;
        var ctx = c.getContext('2d');
        ctx.clearRect(0,0,sample,sample);
        ctx.drawImage(img, 0,0,sample,sample);

        var data = ctx.getImageData(0,0,sample,sample).data;
        var total = sample * sample;
        var opaque = new Uint8Array(total);
        var alphaThreshold = 10;
        var minX = sample, minY = sample, maxX = -1, maxY = -1;

        for(var y=0;y<sample;y++){
          if((y % 8) === 0) checkBudget();
          for(var x=0;x<sample;x++){
            var idx = (y*sample + x);
            var a = data[(idx*4)+3];
            if(a > alphaThreshold){
              opaque[idx] = 1;
              if(x < minX) minX = x;
              if(x > maxX) maxX = x;
              if(y < minY) minY = y;
              if(y > maxY) maxY = y;
            }
          }
        }

        if(maxX < minX || maxY < minY){
          return null;
        }

        var visited = new Uint8Array(total);
        var qx = new Int16Array(total);
        var qy = new Int16Array(total);

        function keyAt(x,y){ return (y*sample + x); }
        function visitRegion(startX, startY){
          var head = 0;
          var tail = 0;
          qx[tail] = startX;
          qy[tail] = startY;
          tail += 1;
          var area = 0;
          var touchesEdge = false;
          var rx0 = sample, ry0 = sample, rx1 = -1, ry1 = -1;

          while(head < tail){
            if((head % 512) === 0) checkBudget();
            var cx = qx[head];
            var cy = qy[head];
            head += 1;
            if(cx < 0 || cy < 0 || cx >= sample || cy >= sample) continue;
            var idx2 = keyAt(cx, cy);
            if(visited[idx2]) continue;
            visited[idx2] = 1;
            if(opaque[idx2]) continue;

            area += 1;
            if(cx === 0 || cy === 0 || cx === sample-1 || cy === sample-1) touchesEdge = true;
            if(cx < rx0) rx0 = cx;
            if(cx > rx1) rx1 = cx;
            if(cy < ry0) ry0 = cy;
            if(cy > ry1) ry1 = cy;

            qx[tail] = cx+1; qy[tail] = cy; tail += 1;
            qx[tail] = cx-1; qy[tail] = cy; tail += 1;
            qx[tail] = cx; qy[tail] = cy+1; tail += 1;
            qx[tail] = cx; qy[tail] = cy-1; tail += 1;
          }

          return { area: area, touchesEdge: touchesEdge, x0:rx0, y0:ry0, x1:rx1, y1:ry1 };
        }

        var bestHole = null;
        for(var yy=0;yy<sample;yy++){
          if((yy % 8) === 0) checkBudget();
          for(var xx=0;xx<sample;xx++){
            var idx3 = keyAt(xx,yy);
            if(visited[idx3] || opaque[idx3]) continue;
            var region = visitRegion(xx, yy);
            if(!region || !region.area || region.touchesEdge) continue;
            if(region.area < 40) continue;
            if(!bestHole || region.area > bestHole.area) bestHole = region;
          }
        }

        function rasterToSourceX(px){ return sourceBox.x + ((px / sample) * sourceBox.w); }
        function rasterToSourceY(py){ return sourceBox.y + ((py / sample) * sourceBox.h); }

        var alphaBounds = {
          x: rasterToSourceX(minX),
          y: rasterToSourceY(minY),
          w: Math.max(0.0001, rasterToSourceX(maxX + 1) - rasterToSourceX(minX)),
          h: Math.max(0.0001, rasterToSourceY(maxY + 1) - rasterToSourceY(minY))
        };

        var holeBounds = null;
        if(bestHole){
          holeBounds = {
            x: rasterToSourceX(bestHole.x0),
            y: rasterToSourceY(bestHole.y0),
            w: Math.max(0.0001, rasterToSourceX(bestHole.x1 + 1) - rasterToSourceX(bestHole.x0)),
            h: Math.max(0.0001, rasterToSourceY(bestHole.y1 + 1) - rasterToSourceY(bestHole.y0))
          };
        }

        return {
          alphaBounds: alphaBounds,
          holeBounds: holeBounds
        };
      }finally{
        URL.revokeObjectURL(url);
      }
    }

    function fallbackInnerBoxForDigit(digitChar, bbox){
      var a = DIGIT_SAFE_ANCHOR_BOX[digitChar] || { x:0.3, y:0.64, w:0.4, h:0.24 };
      return {
        x: bbox.x + (bbox.w * a.x),
        y: bbox.y + (bbox.h * a.y),
        w: bbox.w * a.w,
        h: bbox.h * a.h,
        source: 'anchor'
      };
    }

    function buildDigitInnerBox(digitChar, bbox, holeBounds){
      if(holeBounds && isFinite(holeBounds.w) && isFinite(holeBounds.h) && holeBounds.w > 0 && holeBounds.h > 0){
        var pad = 0.12;
        return {
          x: holeBounds.x + (holeBounds.w * pad),
          y: holeBounds.y + (holeBounds.h * pad),
          w: holeBounds.w * (1 - (pad*2)),
          h: holeBounds.h * (1 - (pad*2)),
          source: 'hole'
        };
      }
      return fallbackInnerBoxForDigit(digitChar, bbox);
    }

    function getDigitWidthAndScale(digitChar, heightPx){
      if(!KB_METRICS){
        var vb = state.digitViewBox[digitChar];
        if(vb && vb.w > 0 && vb.h > 0){
          var viewBoxRatio = clamp(vb.w / vb.h, 0.35, 1.20);
          return {
            width: heightPx * viewBoxRatio,
            scale: heightPx / vb.h
          };
        }
      }
      var bb = state.digitBBox[digitChar];
      if(!bb || !bb.h){
        return {
          width: heightPx * 0.7,
          scale: 1
        };
      }
      var ratio = clamp(bb.w / bb.h, 0.35, 1.20);
      return {
        width: heightPx * ratio,
        scale: heightPx / bb.h
      };
    }

    function getFallbackKerningPx(){
      var heightPx = LOCK_BACK.size * CANVAS;
      return Math.max(2, heightPx * 0.02);
    }

    function computeDesiredGapPx(leftVisual, rightVisual, leftScale, rightScale){
      var outlinePadPx = Math.max(
        (leftVisual && leftVisual.strokeHalf ? leftVisual.strokeHalf * leftScale : 0),
        (rightVisual && rightVisual.strokeHalf ? rightVisual.strokeHalf * rightScale : 0)
      );
      return DIGIT_KERNING_BASE_PADDING_PX + (outlinePadPx * DIGIT_KERNING_OUTLINE_FACTOR);
    }

    function computePairKerningPx(pair){
      if(!KB_METRICS) return getFallbackKerningPx();
      if(!pair || pair.length !== 2) return getFallbackKerningPx();
      var leftDigit = pair.charAt(0);
      var rightDigit = pair.charAt(1);
      var heightPx = LOCK_BACK.size * CANVAS;
      var left = getDigitWidthAndScale(leftDigit, heightPx);
      var right = getDigitWidthAndScale(rightDigit, heightPx);
      var leftVisual = state.digitVisualMetrics[leftDigit] || null;
      var rightVisual = state.digitVisualMetrics[rightDigit] || null;

      var leftInsetRight = leftVisual ? (leftVisual.insetRight || 0) * left.scale : 0;
      var rightInsetLeft = rightVisual ? (rightVisual.insetLeft || 0) * right.scale : 0;
      var desiredGapPx = computeDesiredGapPx(leftVisual, rightVisual, left.scale, right.scale);
      var kernPx = desiredGapPx - (leftInsetRight + rightInsetLeft);

      if(!isFinite(kernPx)) kernPx = getFallbackKerningPx();
      kernPx = clamp(kernPx, getFallbackKerningPx(), DIGIT_KERNING_MAX_EXTRA_PX);
      return kernPx;
    }

    function buildPairKerningLookup(){
      var lookup = {};
      for(var n=0;n<=99;n++){
        var pair = String(n).padStart(2, '0');
        lookup[pair] = computePairKerningPx(pair);
      }
      PAIR_KERNING = lookup;
      state.pairKerning = lookup;
      return lookup;
    }

    function getPairKerningPx(pair){
      if(!pair || pair.length !== 2) return getFallbackKerningPx();
      var pairMap = (state.pairKerning && Object.keys(state.pairKerning).length) ? state.pairKerning : PAIR_KERNING;
      return isFinite(pairMap[pair]) ? pairMap[pair] : getFallbackKerningPx();
    }

    function getDigitLogoBoxForRect(digitChar, rect){
      var inner = state.digitInnerBox[digitChar];
      if(!inner){
        inner = fallbackInnerBoxForDigit(digitChar, { x:0, y:0, w:1, h:1 });
      }

      var bb = state.digitBBox[digitChar];
      if(!bb || !bb.w || !bb.h){
        return {
          x: rect.x + (rect.w * 0.33),
          y: rect.y + (rect.h * 0.66),
          w: rect.w * 0.34,
          h: rect.h * 0.22,
          source: 'fallback-rect'
        };
      }

      var nx = (inner.x - bb.x) / bb.w;
      var ny = (inner.y - bb.y) / bb.h;
      var nw = inner.w / bb.w;
      var nh = inner.h / bb.h;

      return {
        x: rect.x + (rect.w * nx),
        y: rect.y + (rect.h * ny),
        w: Math.max(0.0001, rect.w * nw),
        h: Math.max(0.0001, rect.h * nh),
        source: inner.source || 'unknown'
      };
    }

    function getDigitBadgeSlotBoxForRect(digitChar, digitBox){
      var slot = state.digitBadgeSlot[digitChar];
      if(!slot || !slot.viewBox || !digitBox) return null;

      var vb = slot.viewBox;
      if(!isFinite(vb.w) || !isFinite(vb.h) || vb.w <= 0 || vb.h <= 0) return null;

      var sx = (slot.x - vb.minX) / vb.w;
      var sy = (slot.y - vb.minY) / vb.h;
      var sw = slot.width / vb.w;
      var sh = slot.height / vb.h;

      var slotX = digitBox.x + (sx * digitBox.w);
      var slotY = digitBox.y + (sy * digitBox.h);
      var slotW = sw * digitBox.w;
      var slotH = sh * digitBox.h;
      if(!isFinite(slotX) || !isFinite(slotY) || !isFinite(slotW) || !isFinite(slotH) || slotW <= 0 || slotH <= 0) return null;

      return { x:slotX, y:slotY, w:slotW, h:slotH };
    }

    function validateKerning(){
      var collisions = [];
      var spacingOutliers = [];

      if((!state.pairKerning || !Object.keys(state.pairKerning).length) && !Object.keys(PAIR_KERNING).length){
        buildPairKerningLookup();
      }

      var minFallback = getFallbackKerningPx();
      for(var n=0;n<=99;n++){
        var pair = String(n).padStart(2, '0');
        var leftDigit = pair.charAt(0);
        var rightDigit = pair.charAt(1);
        var heightPx = LOCK_BACK.size * CANVAS;
        var left = getDigitWidthAndScale(leftDigit, heightPx);
        var right = getDigitWidthAndScale(rightDigit, heightPx);
        var leftVisual = state.digitVisualMetrics[leftDigit] || null;
        var rightVisual = state.digitVisualMetrics[rightDigit] || null;
        var kernPx = getPairKerningPx(pair);

        var leftInsetRight = leftVisual ? (leftVisual.insetRight || 0) * left.scale : 0;
        var rightInsetLeft = rightVisual ? (rightVisual.insetLeft || 0) * right.scale : 0;
        var requiredPadding = computeDesiredGapPx(leftVisual, rightVisual, left.scale, right.scale);
        var visualGap = kernPx + leftInsetRight + rightInsetLeft;

        if(visualGap + 0.01 < requiredPadding){
          var deficit = requiredPadding - visualGap;
          kernPx = clamp(kernPx + deficit + 0.25, minFallback, DIGIT_KERNING_MAX_EXTRA_PX);
          state.pairKerning[pair] = kernPx;
          PAIR_KERNING[pair] = kernPx;
          visualGap = kernPx + leftInsetRight + rightInsetLeft;
          collisions.push({ pair:pair, visualGapPx:visualGap, requiredPaddingPx:requiredPadding, clampedKerningPx:kernPx });
          console.warn('Overlap', pair, {
            visualGapPx: visualGap,
            requiredPaddingPx: requiredPadding,
            clampedKerningPx: kernPx,
            leftWidthPx: left.width,
            rightWidthPx: right.width
          });
        }

        if(visualGap > requiredPadding + 10){
          spacingOutliers.push({ pair:pair, visualGapPx:visualGap, requiredPaddingPx:requiredPadding, kerningPx:kernPx });
        }
      }

      console.groupCollapsed('[MSH KB] validateKerning() audit');
      if(collisions.length){
        console.error('Collision-risk pairs found:', collisions.length);
        console.table(collisions);
      }else{
        console.info('No pair collisions across 00-99 with current locked geometry + outline-safe kerning.');
      }
      if(spacingOutliers.length){
        console.warn('Wide-spacing outliers found (for readability review):', spacingOutliers.length);
        console.table(spacingOutliers);
      }else{
        console.info('No wide-spacing outliers detected in 00-99 sweep.');
      }
      console.groupEnd();
      return {
        pairKerning: state.pairKerning,
        collisions: collisions,
        spacingOutliers: spacingOutliers
      };
    }

    // State
    var state = {
      product: null,
      modelKey: '',
      colours: [],
      colourways: [],
      selectedColour: '',
      selectedMockupUrls: { front:'', back:'' },
      baseFrontImage: null,
      baseBackImage: null,
      dragTool: 'badge',
      activeOverlay: null,

      baseFrontData: '',
      baseBackData: '',
      badgeData: '',
      badgeAspect: 1,
      sponsorData: '',
      sponsorAspect: (1 / 0.35),

      digitBBox: {},
      digitViewBox: {},
      digitBadgeSlot: {},
      digitVisualMetrics: {},
      digitInnerBox: {},
      digitMetricsCache: {},
      digitSvgSource: {},
      digitLayerRenderCache: {},
      napeSvgRaw: '',
      pairKerning: {},
      numberDigitRects: [],
      numberSpacingDebug: null,
      napeTextOverride: '',
      napeSquaresOverride: '',
      fillOverride: '',
      strokeOverride: '',
      badgeSlotWarned: {},
      backLayoutProfilesSection: parseJsonObject(sectionBackLayoutProfilesRaw, {}),
      backLayoutProfilesLocal: readBackLayoutProfilesFromStorage(),
      backLayoutActiveTarget: 'nape',
      backLayout: baseBackLayout(),

      placements: {
        badge:   { s:0.12, x:0.30, y:0.255 },
        sponsor: { s:0.44, x:0.50, y:0.41 }
      },
      frontRects: {
        badge: null,
        sponsor: null
      },
      lightboxFrontRects: {
        badge: null,
        sponsor: null
      },
      activeDragTarget: null,
      isDragging: false
    };


    function getMergedBackLayoutProfiles(){
      var merged = {};
      var sectionProfiles = state.backLayoutProfilesSection || {};
      var localProfiles = state.backLayoutProfilesLocal || {};
      var key;
      for(key in sectionProfiles){
        if(Object.prototype.hasOwnProperty.call(sectionProfiles, key)) merged[key] = sectionProfiles[key];
      }
      for(key in localProfiles){
        if(Object.prototype.hasOwnProperty.call(localProfiles, key)) merged[key] = localProfiles[key];
      }
      return merged;
    }

    function getBackLayoutProfileByHandle(handle){
      var cleanHandle = String(handle || '').trim();
      var merged = getMergedBackLayoutProfiles();
      if(cleanHandle && Object.prototype.hasOwnProperty.call(merged, cleanHandle)){
        return normalizeBackLayoutProfile(merged[cleanHandle]);
      }
      return baseBackLayout();
    }

    function applyBackLayoutTransforms(){
      if(napeLayoutGroup) napeLayoutGroup.setAttribute('transform', backLayoutTransform(state.backLayout.nape, LOCK_NAPE));
      if(numberLayoutGroup) numberLayoutGroup.setAttribute('transform', backLayoutTransform(state.backLayout.number, LOCK_BACK));
    }

    function buildBackLayoutExportJson(){
      var cleanHandle = String(productHandle || '').trim();
      if(!cleanHandle) return '{}';
      var merged = getMergedBackLayoutProfiles();
      merged[cleanHandle] = normalizeBackLayoutProfile(state.backLayout);
      return JSON.stringify(merged, null, 2);
    }

    function syncLayoutModeControls(){
      if(!layoutTools) return;
      var isBackMobile = root.getAttribute('data-kb-mobile-side') === 'back';
      layoutTools.hidden = !(layoutModeActive && (!isMobileViewport() || isBackMobile));
      for(var i=0;i<layoutTargetBtns.length;i++){
        var btn = layoutTargetBtns[i];
        var active = btn.getAttribute('data-kb-layout-target') === state.backLayoutActiveTarget;
        btn.setAttribute('data-active', active ? 'true' : 'false');
      }
      var node = state.backLayout[state.backLayoutActiveTarget] || state.backLayout.nape;
      if(layoutScaleInput){
        layoutScaleInput.min = String(LAYOUT_SCALE_MIN);
        layoutScaleInput.max = String(LAYOUT_SCALE_MAX);
        layoutScaleInput.step = String(LAYOUT_SCALE_STEP);
        layoutScaleInput.value = fmtTuneOut(node.s);
      }
      if(layoutScaleOut) layoutScaleOut.textContent = fmtTuneOut(node.s);
      if(layoutJsonOutput) layoutJsonOutput.value = buildBackLayoutExportJson();
      if(napeLayoutGroup) napeLayoutGroup.setAttribute('data-kb-layout-selected', state.backLayoutActiveTarget === 'nape' ? 'true' : 'false');
      if(numberLayoutGroup) numberLayoutGroup.setAttribute('data-kb-layout-selected', state.backLayoutActiveTarget === 'number' ? 'true' : 'false');
    }

    function applyBackLayout(handle){
      state.backLayout = getBackLayoutProfileByHandle(handle);
      applyBackLayoutTransforms();
      syncLayoutModeControls();
      queueMobileOverlaySync();
    }

    function updateBackLayoutTargetPosition(target, xPx, yPx){
      if(target !== 'nape' && target !== 'number') return;
      state.backLayout[target].x = clamp((xPx || 0) / CANVAS, 0, 1);
      state.backLayout[target].y = clamp((yPx || 0) / CANVAS, 0, 1);
      applyBackLayoutTransforms();
      syncLayoutModeControls();
    }

    function updateBackLayoutTargetScale(target, nextScale){
      if(target !== 'nape' && target !== 'number') return;
      state.backLayout[target].s = clamp(nextScale, LAYOUT_SCALE_MIN, LAYOUT_SCALE_MAX);
      applyBackLayoutTransforms();
      syncLayoutModeControls();
    }

    function setLayoutSaveFeedback(message, tone){
      if(!layoutTools) return;
      layoutTools.setAttribute('data-kb-layout-save-state', tone || 'info');
      layoutTools.setAttribute('data-kb-layout-save-msg', String(message || ''));
    }

    function saveBackLayoutForCurrentHandle(){
      var cleanHandle = String(productHandle || '').trim();
      if(!cleanHandle){
        setLayoutSaveFeedback('Select a model before saving layout.', 'error');
        return '';
      }
      var nextLocal = state.backLayoutProfilesLocal || {};
      nextLocal[cleanHandle] = normalizeBackLayoutProfile(state.backLayout);
      state.backLayoutProfilesLocal = nextLocal;
      setLS(BACK_LAYOUT_STORAGE_KEY, JSON.stringify(nextLocal));
      syncLayoutModeControls();
      return buildBackLayoutExportJson();
    }

    function resolveBackLayoutTargetFromPointer(e){
      if(!svgBack || !e) return '';
      var hit = e.target && e.target.closest ? e.target.closest('[data-kb-layout-target]') : null;
      if(hit && svgBack.contains(hit)){
        var directTarget = hit.getAttribute('data-kb-layout-target');
        if(directTarget === 'nape' || directTarget === 'number') return directTarget;
      }
      if(!isFinite(e.clientX) || !isFinite(e.clientY)) return '';
      var candidates = [
        { target:'nape', node:napeLayoutGroup },
        { target:'number', node:numberLayoutGroup }
      ];
      for(var i=0;i<candidates.length;i++){
        var candidate = candidates[i];
        if(!candidate.node || !candidate.node.getBoundingClientRect) continue;
        var rect = candidate.node.getBoundingClientRect();
        if(!rect || rect.width <= 0 || rect.height <= 0) continue;
        if(e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom){
          return candidate.target;
        }
      }
      return '';
    }

    var renderGeneration = 0;
    var rafId = 0;
    var renderInProgress = false;
    var renderToken = 0;
    var lastRenderReason = '';
    var scheduleHits = [];
    var LOOP_WINDOW_MS = 800;
    var LOOP_LIMIT = 12;
    var loopTripped = false;
    var loopCooldownTimer = 0;
    var loopCooldownUntil = 0;
    var suppressUIEvents = false;
    var lastGoodBackRender = null;
    var stageResizeObserver = null;
    var stageResizeObservedEls = [];
    var stageResizeReconnectTimer = 0;
    var stageResizePendingRAF = 0;
    var stageResizePendingChange = false;
    var stageResizeDebounceTimer = 0;
    var viewportResizeDebounceTimer = 0;
    var viewportLastSize = null;
    var onVisualViewportResize = function(){};
    var renderStormDebounceTimer = 0;
    var pendingStormReason = '';
    var scheduleReasonWindowStart = Date.now();
    var scheduleReasonWindowCount = 0;
    var scheduleReasonTail = [];
    var colourwaysPopulated = false;
    var builderReady = false;
    var handleWatchTimer = 0;
    var continueWatchTimer = 0;
    var uiRenderRaf = 0;
    var scrollDebounceTimer = 0;
    var scrollSettled = true;
    var brochurePreviewSyncTimer = 0;
    var brochurePreviewSyncInFlight = false;
    var brochurePreviewSyncQueued = false;

    function disconnectStageResizeObserver(){
      if(stageResizeReconnectTimer){
        clearTimeout(stageResizeReconnectTimer);
        stageResizeReconnectTimer = 0;
      }
      if(stageResizePendingRAF){
        cancelAnimationFrame(stageResizePendingRAF);
        stageResizePendingRAF = 0;
      }
      if(stageResizeDebounceTimer){
        clearTimeout(stageResizeDebounceTimer);
        stageResizeDebounceTimer = 0;
      }
      if(viewportResizeDebounceTimer){
        clearTimeout(viewportResizeDebounceTimer);
        viewportResizeDebounceTimer = 0;
      }
      if(window.visualViewport){
        try{ window.visualViewport.removeEventListener('resize', onVisualViewportResize); }catch(_vvResizeOffErr){}
      }
      stageResizePendingChange = false;
      if(stageResizeObserver){
        try{ stageResizeObserver.disconnect(); }catch(_stageDisconnectErr){}
      }
    }

    function reconnectStageResizeObserver(){
      if(!stageResizeObserver || !stageResizeObservedEls.length) return;
      disconnectStageResizeObserver();
      stageResizeReconnectTimer = setTimeout(function(){
        stageResizeReconnectTimer = 0;
        for(var i=0; i<stageResizeObservedEls.length; i++){
          var el = stageResizeObservedEls[i];
          if(!el) continue;
          try{ stageResizeObserver.observe(el); }catch(_stageObserveErr){}
        }
      }, 120);
    }

    function showErrorUI(message){
      if(loopBanner){
        loopBanner.hidden = false;
        loopBanner.textContent = message || 'Render loop detected — cooling down…';
      }
      showErr(message || 'Render loop detected');
    }

    function hasSignificantResize(prev, next){
      if(!prev || !next) return true;
      return Math.abs((next.w || 0) - (prev.w || 0)) >= 2 || Math.abs((next.h || 0) - (prev.h || 0)) >= 2;
    }

    function isViewportReason(reason){
      return /resize|viewport|scroll/i.test(String(reason || ''));
    }

    function trackScheduleReason(reason){
      if(!isDebugEnabled()) return;
      var now = Date.now();
      if(now - scheduleReasonWindowStart >= 1000){
        scheduleReasonWindowStart = now;
        scheduleReasonWindowCount = 0;
      }
      scheduleReasonWindowCount++;
      scheduleReasonTail.push(String(reason || 'unknown'));
      if(scheduleReasonTail.length > 10) scheduleReasonTail.shift();
      console.log('[KB scheduleRender]', {
        reason: reason || 'unknown',
        perSecond: scheduleReasonWindowCount,
        last10: scheduleReasonTail.slice()
      });
    }

    function startLoopCooldown(reason){
      loopTripped = true;
      loopCooldownUntil = nowMs() + 800;
      scheduleHits = [];
      if(loopCooldownTimer) clearTimeout(loopCooldownTimer);
      showErrorUI('Render loop detected — cooling down…');
      kbLog('Render loop cooldown', { reason:reason, until:loopCooldownUntil });
      if(isDebugEnabled()){
        try{ console.trace('Render loop cooldown trace'); }catch(_loopTraceErr){}
      }
      loopCooldownTimer = setTimeout(function(){
        loopCooldownTimer = 0;
        loopTripped = false;
        loopCooldownUntil = 0;
        if(loopBanner) loopBanner.hidden = true;
        showErr('');
        Render.request('loop-cooldown-resume');
      }, 800);
    }

    var Render = {
      request: function(reason){
      var why = reason || 'unknown';
      trackScheduleReason(why);
      if(loopTripped){
        if(loopCooldownUntil && nowMs() < loopCooldownUntil) return;
        loopTripped = false;
        loopCooldownUntil = 0;
      }
      scheduleRenderCount++;
      var now = nowMs();
      scheduleHits.push(now);
      scheduleHits = scheduleHits.filter(function(t){ return now - t < LOOP_WINDOW_MS; });
      if(scheduleHits.length > LOOP_LIMIT){
        startLoopCooldown(why);
        renderDebugPanel();
        return;
      }

      if(isMobileViewport() && isViewportReason(why)){
        pendingStormReason = 'viewport/resize';
        if(renderStormDebounceTimer) return;
        renderStormDebounceTimer = setTimeout(function(){
          renderStormDebounceTimer = 0;
          pendingStormReason = '';
          Render.request('coalesced-render');
        }, 220);
        return;
      }

      lastRenderReason = why;
      renderToken++;
      kbLog('scheduleRender', { reason:why, token:renderToken, queued:!!rafId, inProgress:renderInProgress, hitCount:scheduleHits.length });
      if(rafId || renderInProgress){
        renderDebugPanel();
        return;
      }
      rafId = requestAnimationFrame(function(){
        var token = renderToken;
        var activeReason = lastRenderReason;
        rafId = 0;
        safeRender(activeReason, token);
      });
      renderDebugPanel();
      }
    };

    /* MOBILE OVERHAUL: perf throttles */

    function safeRender(reason, token){
      if(loopTripped) return;
      if(renderInProgress) return;
      renderInProgress = true;
      var t0 = nowMs();
      try{
        disconnectStageResizeObserver();
        kbLog('render begin', { reason:reason, token:token, front:frontState.status, back:backState.status });
        performRender();
        lastRenderDurationMs = Math.round(nowMs() - t0);
        kbLog('render end', { ms:lastRenderDurationMs, reason:reason, token:token });
      }catch(e){
        kbLog('render exception', e);
        showErrorUI('Render failed');
      }finally{
        reconnectStageResizeObserver();
        renderInProgress = false;
        renderDebugPanel();
      }
    }

    function loadSaved(colour){
      try{
        var raw = localStorage.getItem(lsKey(colour));
        if(!raw) return;
        var s = JSON.parse(raw);
        if(s && s.placements){
          if(s.placements.badge) state.placements.badge = Object.assign({}, state.placements.badge, s.placements.badge);
          if(s.placements.sponsor) state.placements.sponsor = Object.assign({}, state.placements.sponsor, s.placements.sponsor);
        }
        if(s && s.dragTool && (s.dragTool === 'badge' || s.dragTool === 'sponsor')) state.dragTool = s.dragTool;
        if(s && typeof s.badgeData === 'string') state.badgeData = s.badgeData;
        if(s && typeof s.sponsorData === 'string') state.sponsorData = s.sponsorData;
        if(s && isFinite(parseFloat(s.sponsorAspect)) && parseFloat(s.sponsorAspect) > 0) state.sponsorAspect = parseFloat(s.sponsorAspect);
        var savedNapeText = s ? (s.napeTextOverride || s.napeTextColorOverride) : '';
        var savedNapeSquares = s ? (s.napeSquaresOverride || s.napeSquaresColorOverride) : '';
        state.napeTextOverride = normalizeHexColor(savedNapeText) || '';
        state.napeSquaresOverride = normalizeHexColor(savedNapeSquares) || '';
      }catch(e){}
      migrateFrontPlacementsToNormalized();
    }

    function getFrontStageRect(){
      var stageInner = stageInnerNodes.front || (svgFront && svgFront.closest ? svgFront.closest('[data-kb-stage-inner]') : null) || svgFront;
      if(!stageInner || !stageInner.getBoundingClientRect) return null;
      var rect = stageInner.getBoundingClientRect();
      if(!rect || !rect.width || !rect.height) return null;
      return rect;
    }

    function migratePlacementNodeIfPixels(node, rect){
      if(!node || !rect) return false;
      var nextX = parseFloat(node.x);
      var nextY = parseFloat(node.y);
      var nextS = parseFloat(node.s);
      var changed = false;
      if(isFinite(nextX) && nextX > 1.5){
        nextX = nextX / rect.width;
        changed = true;
      }
      if(isFinite(nextY) && nextY > 1.5){
        nextY = nextY / rect.height;
        changed = true;
      }
      if(isFinite(nextS) && nextS > 1.5){
        nextS = nextS / rect.width;
        changed = true;
      }
      if(isFinite(nextX)) node.x = clamp(nextX, 0, 1);
      if(isFinite(nextY)) node.y = clamp(nextY, 0, 1);
      if(isFinite(nextS)) node.s = clamp(nextS, 0.01, 1);
      return changed;
    }

    function migrateFrontPlacementsToNormalized(){
      var rect = getFrontStageRect();
      if(!rect) return;
      var changed = false;
      changed = migratePlacementNodeIfPixels(state.placements.badge, rect) || changed;
      changed = migratePlacementNodeIfPixels(state.placements.sponsor, rect) || changed;
      if(changed){
        syncSliders();
        saveState();
      }
    }

    function saveState(){
      try{
        localStorage.setItem(lsKey(state.selectedColour), JSON.stringify({
          placements: {
            badge: state.placements.badge,
            sponsor: state.placements.sponsor
          },
          dragTool: state.dragTool,
          badgeData: state.badgeData,
          sponsorData: state.sponsorData,
          sponsorAspect: state.sponsorAspect,
          napeTextOverride: state.napeTextOverride,
          napeSquaresOverride: state.napeSquaresOverride
        }));
      }catch(e){}
      trackShirtConfigVersion('saveState');
    }

    function isKbDebugEnabled(){
      try{
        return (new URLSearchParams(window.location.search || '')).get('kbdebug') === '1';
      }catch(_kbDebugErr){
        return false;
      }
    }

    function readPersistedShirtState(){
      try{
        var raw = localStorage.getItem(SHIRT_STATE_STORAGE_KEY);
        if(!raw) return null;
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
      }catch(_shirtStateReadErr){
        return null;
      }
    }

    function buildShirtStatePayload(){
      var numberValue = sanitizeNumber(elNumber && elNumber.value);
      return {
        shirtConfigVersion: shirtConfigVersion,
        modelHandle: String(productHandle || '').trim(),
        modelKey: String(state.modelKey || '').trim(),
        selectedColourway: String(state.selectedColour || '').trim(),
        numberText: numberValue,
        numberColour: normalizeHexColor(state.fillOverride) || '',
        badgeEnabled: !!state.badgeData,
        sponsorEnabled: !!state.sponsorData,
        badgePlacement: {
          x: state.placements.badge.x,
          y: state.placements.badge.y,
          s: state.placements.badge.s
        },
        sponsorPlacement: {
          x: state.placements.sponsor.x,
          y: state.placements.sponsor.y,
          s: state.placements.sponsor.s
        }
      };
    }

    function getShirtStateFingerprint(){
      var payload = buildShirtStatePayload();
      delete payload.shirtConfigVersion;
      return JSON.stringify(payload);
    }

    function persistShirtStatePayload(){
      try{
        localStorage.setItem(SHIRT_STATE_STORAGE_KEY, JSON.stringify(buildShirtStatePayload()));
      }catch(_shirtStatePersistErr){}
    }

    function trackShirtConfigVersion(reason){
      var nextFingerprint = getShirtStateFingerprint();
      if(nextFingerprint === lastShirtConfigFingerprint){
        persistShirtStatePayload();
        return;
      }
      shirtConfigVersion += 1;
      lastShirtConfigFingerprint = nextFingerprint;
      persistShirtStatePayload();
      if(isKbDebugEnabled()){
        kbLog('shirt-config-version++', { version: shirtConfigVersion, reason: reason || 'unknown' });
      }
    }

    function initShirtConfigVersionState(){
      var persisted = readPersistedShirtState();
      shirtConfigVersion = persisted && isFinite(Number(persisted.shirtConfigVersion)) ? Math.max(0, Number(persisted.shirtConfigVersion)) : 0;
      lastShirtConfigFingerprint = getShirtStateFingerprint();
      persistShirtStatePayload();
    }

    function waitForAnimationFrames(count){
      var remaining = Math.max(0, Number(count) || 0);
      return new Promise(function(resolve){
        function step(){
          if(!remaining){ resolve(); return; }
          remaining -= 1;
          window.requestAnimationFrame(step);
        }
        step();
      });
    }

    function canvasLooksPainted(canvas){
      if(!canvas || !canvas.width || !canvas.height) return false;
      var ctx = canvas.getContext && canvas.getContext('2d');
      if(!ctx) return false;
      var samples = [
        [Math.floor(canvas.width * 0.5), Math.floor(canvas.height * 0.5)],
        [Math.floor(canvas.width * 0.2), Math.floor(canvas.height * 0.2)],
        [Math.floor(canvas.width * 0.8), Math.floor(canvas.height * 0.8)]
      ];
      try{
        for(var i = 0; i < samples.length; i++){
          var p = samples[i];
          var data = ctx.getImageData(Math.max(0, Math.min(canvas.width - 1, p[0])), Math.max(0, Math.min(canvas.height - 1, p[1])), 1, 1).data;
          if(data && data[3] > 0) return true;
        }
      }catch(_canvasReadErr){
        return true;
      }
      return false;
    }

    async function awaitRenderComplete(which, timeoutMs){
      var timeoutAt = Date.now() + (typeof timeoutMs === 'number' ? timeoutMs : SHIRT_SNAPSHOT_CAPTURE_TIMEOUT_MS);
      var sourceSvg = which === 'back' ? svgBack : svgFront;
      var canvas = getSidePreviewCanvas(which);
      if(!sourceSvg || !canvas) return false;

      await waitForAnimationFrames(2);
      while(Date.now() < timeoutAt){
        try{
          await paintSvgToPreviewCanvas(sourceSvg, canvas);
          if(canvasLooksPainted(canvas)) return true;
        }catch(_renderWaitErr){}
        await waitForAnimationFrames(1);
      }
      return canvasLooksPainted(canvas);
    }

    function canvasToPreferredDataUrl(canvas){
      if(!canvas) return '';
      try{
        var webp = canvas.toDataURL('image/webp', 0.92);
        if(webp && /^data:image\/webp/i.test(webp)) return webp;
      }catch(_webpErr){}
      return canvas.toDataURL('image/png');
    }

    function openSnapshotsDb(){
      return new Promise(function(resolve, reject){
        if(!window.indexedDB){ reject(new Error('indexedDB unavailable')); return; }
        var req = window.indexedDB.open(SNAPSHOT_DB_NAME, 1);
        req.onupgradeneeded = function(ev){
          var db = ev && ev.target ? ev.target.result : null;
          if(!db) return;
          if(!db.objectStoreNames.contains(SNAPSHOT_STORE_NAME)) db.createObjectStore(SNAPSHOT_STORE_NAME);
        };
        req.onsuccess = function(){ resolve(req.result); };
        req.onerror = function(){ reject(req.error || new Error('Failed to open snapshot db')); };
      });
    }

    function putSnapshotRecord(key, dataUrl, version){
      return openSnapshotsDb().then(function(db){
        return new Promise(function(resolve, reject){
          var tx = db.transaction(SNAPSHOT_STORE_NAME, 'readwrite');
          var store = tx.objectStore(SNAPSHOT_STORE_NAME);
          var record = {
            key: key,
            dataUrl: dataUrl,
            createdAt: Date.now(),
            meta: { version: version }
          };
          store.put(record, key);
          tx.oncomplete = function(){ db.close(); resolve(record); };
          tx.onerror = function(){ db.close(); reject(tx.error || new Error('Snapshot put failed')); };
          tx.onabort = function(){ db.close(); reject(tx.error || new Error('Snapshot tx aborted')); };
        });
      });
    }

    function putShirtSnapshotBundleAtomic(payload){
      return openSnapshotsDb().then(function(db){
        return new Promise(function(resolve, reject){
          var tx = db.transaction(SNAPSHOT_STORE_NAME, 'readwrite');
          var store = tx.objectStore(SNAPSHOT_STORE_NAME);
          var now = Date.now();
          var captureId = String(payload && payload.captureId || '');
          var frontUrl = String(payload && payload.frontDataUrl || '').trim();
          var backUrl = String(payload && payload.backDataUrl || '').trim();
          var meta = payload && payload.meta ? payload.meta : {};

          store.put({ id:'shirt_front', dataUrl: frontUrl, captureId: captureId, createdAt: now }, 'shirt_front');
          store.put({ id:'shirt_back', dataUrl: backUrl, captureId: captureId, createdAt: now }, 'shirt_back');
          store.put({
            id: 'shirt_meta',
            captureId: captureId,
            createdAt: now,
            modelHandle: String(meta.modelHandle || ''),
            colourway: String(meta.colourway || ''),
            band: String(meta.band || ''),
            number: String(meta.number || ''),
            sponsorIncluded: !!meta.sponsorIncluded,
            badgeIncluded: !!meta.badgeIncluded
          }, 'shirt_meta');

          tx.oncomplete = function(){ db.close(); resolve(true); };
          tx.onerror = function(){ db.close(); reject(tx.error || new Error('Snapshot bundle put failed')); };
          tx.onabort = function(){ db.close(); reject(tx.error || new Error('Snapshot bundle tx aborted')); };
        });
      });
    }

    async function captureShirtSnapshotsForContinue(options){
      var opts = options || {};
      var token = ++shirtCaptureToken;
      var capturedVersion = shirtConfigVersion;
      var captureId = String(Date.now()) + '-' + Math.random().toString(16).slice(2);
      if(isKbDebugEnabled()) kbLog('shirt-capture-start', { token: token, version: capturedVersion });

      var selectedColourway = String(opts.colourway || '').trim();
      if(selectedColourway && selectedColourway !== state.selectedColour){
        await setColour(selectedColourway);
      }

      await new Promise(function(resolve){ requestAnimationFrame(function(){ requestAnimationFrame(resolve); }); });

      await Promise.race([
        Promise.all([
          awaitRenderComplete('front', SHIRT_SNAPSHOT_CAPTURE_TIMEOUT_MS),
          awaitRenderComplete('back', SHIRT_SNAPSHOT_CAPTURE_TIMEOUT_MS)
        ]),
        new Promise(function(resolve){ setTimeout(resolve, SHIRT_SNAPSHOT_CAPTURE_TIMEOUT_MS); })
      ]);

      if(token !== shirtCaptureToken || capturedVersion !== shirtConfigVersion){
        if(isKbDebugEnabled()) kbLog('shirt-capture-abort-before-save', { token: token, activeToken: shirtCaptureToken, capturedVersion: capturedVersion, activeVersion: shirtConfigVersion });
        return false;
      }

      var timeoutCapture = function(fetcher){
        return Promise.race([
          fetcher(),
          new Promise(function(resolve){ setTimeout(function(){ resolve(''); }, 900); })
        ]);
      };

      var frontDataUrl = await timeoutCapture(exportFrontDataUrl);
      var backDataUrl = await timeoutCapture(exportBackDataUrl);
      console.log('[MSH Builder Debug] Shirt snapshots generated', {
        context: 'continue-capture',
        captureId: captureId,
        sessionVersion: shirtConfigVersion,
        shirtHandle: String(opts.modelHandle || getContinueShirtHandle() || productHandle || ''),
        colourway: String(selectedColourway || state.selectedColour || ''),
        frontLength: String(frontDataUrl || '').length,
        backLength: String(backDataUrl || '').length,
        timestamp: Date.now()
      });
      var hasFront = /^data:image\//i.test(String(frontDataUrl || '').trim()) && String(frontDataUrl || '').length > 5000;
      var hasBack = /^data:image\//i.test(String(backDataUrl || '').trim()) && String(backDataUrl || '').length > 5000;
      if(!hasFront || !hasBack) return false;

      if(token !== shirtCaptureToken || capturedVersion !== shirtConfigVersion){
        if(isKbDebugEnabled()) kbLog('shirt-capture-abort-token-version-mismatch', { token: token, activeToken: shirtCaptureToken, capturedVersion: capturedVersion, activeVersion: shirtConfigVersion });
        return false;
      }

      await putShirtSnapshotBundleAtomic({
        captureId: captureId,
        frontDataUrl: frontDataUrl,
        backDataUrl: backDataUrl,
        meta: {
          modelHandle: String(opts.modelHandle || getContinueShirtHandle() || ''),
          colourway: String(selectedColourway || state.selectedColour || ''),
          band: String(opts.band || getContinueBand() || ''),
          number: String(opts.number || (elNumber && elNumber.value) || getLS('mshNumber') || getLS('msh_number') || ''),
          sponsorIncluded: !!(state && state.sponsorData),
          badgeIncluded: !!(state && state.badgeData)
        }
      });
      persistBrochurePayload({
        captureId: captureId,
        source: 'continue-capture',
        frontDataUrl: frontDataUrl,
        backDataUrl: backDataUrl,
        generatedAt: Date.now()
      });

      if(isKbDebugEnabled()){
        kbLog('shirt-capture-end', {
          token: token,
          version: capturedVersion,
          captureId: captureId,
          frontLength: hasFront ? frontDataUrl.length : 0,
          backLength: hasBack ? backDataUrl.length : 0
        });
      }
      return true;
    }

    async function getCompositeDataUrl(which){
      if(which === 'front'){
        var frontExportCanvas = document.createElement('canvas');
        frontExportCanvas.width = CANVAS;
        frontExportCanvas.height = CANVAS;
        renderFront({
          ctx: frontExportCanvas.getContext('2d'),
          size: CANVAS,
          rectStore: { badge: null, sponsor: null }
        });
        return frontExportCanvas.toDataURL('image/png');
      }

      renderBack();
      var backCanvas = getSidePreviewCanvas('back');
      await paintSvgToPreviewCanvas(svgBack, backCanvas);
      return backCanvas.toDataURL('image/png');
    }

    function getDefaultChannelColors(){
      return {
        text: '#ffffff',
        squares: '#111827'
      };
    }

    function getNumberChannelColors(renderState){
      var scopedState = renderState || state;
      var defaults = getDefaultChannelColors();
      var fillOverride = normalizeManualColor(scopedState.fillOverride) || '';
      var strokeOverride = normalizeManualColor(scopedState.strokeOverride) || '';
      return {
        fill: normalizeHexColor(fillOverride) || defaults.text,
        stroke: normalizeHexColor(strokeOverride) || defaults.squares
      };
    }

    function getEffectiveNapeColors(renderState){
      var scopedState = renderState || state;
      var numberColors = getNumberChannelColors(scopedState);
      var textOverride = normalizeHexColor(scopedState.napeTextOverride) || '';
      var squaresOverride = normalizeHexColor(scopedState.napeSquaresOverride) || '';
      return {
        text: textOverride || numberColors.fill,
        squares: squaresOverride || numberColors.stroke
      };
    }

    function syncNapeOverrideInputs(){
      if(!elNapeTextOverrideColor || !elNapeTextOverrideHex || !elNapeSquaresOverrideColor || !elNapeSquaresOverrideHex) return;
      var numberColors = getNumberChannelColors();
      setInputValueSilently(elNapeTextOverrideColor, state.napeTextOverride || numberColors.fill);
      setInputValueSilently(elNapeSquaresOverrideColor, state.napeSquaresOverride || numberColors.stroke);
      setInputValueSilently(elNapeTextOverrideHex, state.napeTextOverride || '');
      setInputValueSilently(elNapeSquaresOverrideHex, state.napeSquaresOverride || '');
      syncColourRows();
    }

    function syncNumberColorInputs(){
      if(!elFill || !elStroke) return;
      var numberColors = getNumberChannelColors();
      setInputValueSilently(elFill, numberColors.fill);
      setInputValueSilently(elStroke, numberColors.stroke);
      if(elFillHex) setInputValueSilently(elFillHex, numberColors.fill);
      if(elStrokeHex) setInputValueSilently(elStrokeHex, numberColors.stroke);
      syncColourRows();
    }

    function syncSheetState(open){
      var isOpen = open === true;
      root.setAttribute('data-kb-sheet-open', isOpen ? 'true' : 'false');
      if(sheetToggleBtn){
        sheetToggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        sheetToggleBtn.setAttribute('aria-label', isOpen ? 'Collapse controls sheet' : 'Expand controls sheet');
      }
    }

    function getColorInputForChannel(channel){
      if(channel === 'fill') return elFill;
      if(channel === 'stroke') return elStroke;
      if(channel === 'napeText') return elNapeTextOverrideColor;
      if(channel === 'napeSquares') return elNapeSquaresOverrideColor;
      return null;
    }

    function getColorValueForChannel(channel){
      var input = getColorInputForChannel(channel);
      return normalizeHexColor(input && input.value) || '';
    }

    function buildColorRow(rowEl, channel){
      if(!rowEl) return;
      rowEl.innerHTML = '';
      for(var i=0;i<PALETTE.length;i++){
        var sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'msh-kb__colorSw';
        sw.style.background = PALETTE[i];
        sw.setAttribute('data-kb-color', PALETTE[i]);
        sw.setAttribute('data-kb-color-channel', channel);
        sw.setAttribute('aria-label', PALETTE[i]);
        sw.addEventListener('click', function(e){
          e.preventDefault();
          var value = this.getAttribute('data-kb-color') || '';
          var targetChannel = this.getAttribute('data-kb-color-channel') || '';
          var input = getColorInputForChannel(targetChannel);
          if(!input) return;
          setInputValueSilently(input, value);
          input.dispatchEvent(new Event('input', { bubbles:true }));
        });
        rowEl.appendChild(sw);
      }
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'msh-kb__colorMore';
      more.textContent = 'More…';
      more.addEventListener('click', function(e){
        e.preventDefault();
        var picker = getColorInputForChannel(channel);
        if(picker && typeof picker.click === 'function') picker.click();
      });
      rowEl.appendChild(more);
    }

    function syncColourRows(){
      var buttons = root.querySelectorAll('.msh-kb__colorSw');
      for(var i=0;i<buttons.length;i++){
        var btn = buttons[i];
        var channel = btn.getAttribute('data-kb-color-channel') || '';
        var current = getColorValueForChannel(channel);
        var value = normalizeHexColor(btn.getAttribute('data-kb-color') || '') || '';
        btn.setAttribute('data-active', current === value ? 'true' : 'false');
      }
    }

    function syncResizeOverlayInContext(config){
      if(frontOverlayController && typeof frontOverlayController.sync === 'function'){
        frontOverlayController.sync();
        return;
      }
      var ctx = config || {};
      var overlay = ctx.overlay;
      if(overlay) overlay.hidden = true;
    }

    function syncResizeOverlay(){
      syncResizeOverlayInContext({ overlay:resizeOverlay, box:resizeBox, surface:stageInnerNodes.front, rects:state.frontRects });
    }

    function queueMobileOverlaySync(){
      if(!isOverlayMobileViewport()) return;
      if(mobileOverlaySyncTimer) clearTimeout(mobileOverlaySyncTimer);
      mobileOverlaySyncTimer = setTimeout(function(){
        mobileOverlaySyncTimer = 0;
        syncResizeOverlay();
      }, 90);
    }

    function syncToolChips(){
      for(var i=0;i<toolChips.length;i++){
        var chip = toolChips[i];
        chip.setAttribute('data-active', chip.getAttribute('data-kb-tool') === state.dragTool ? 'true' : 'false');
      }
    }

    /* MOBILE HOTFIX: tabs */
    function setActiveTab(tab){
      var safeTab = tab || 'kit';
      root.setAttribute('data-kb-active-tab', safeTab);
      for(var i=0;i<tabBtns.length;i++){
        var btn = tabBtns[i];
        var btnTab = btn.getAttribute('data-tab') || btn.getAttribute('data-kb-tab') || '';
        var isActiveBtn = btnTab === safeTab;
        btn.setAttribute('data-active', isActiveBtn ? 'true' : 'false');
        if(isActiveBtn) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      }
      for(var p=0;p<tabPanels.length;p++){
        var panel = tabPanels[p];
        var panelTab = panel.getAttribute('data-panel') || panel.getAttribute('data-kb-tab-panel') || '';
        var isActivePanel = panelTab === safeTab;
        panel.setAttribute('data-active', isActivePanel ? 'true' : 'false');
        panel.hidden = !isActivePanel;
      }
      syncResizeOverlay();
      if(isMobileViewport()) syncSheetState(true);
    }

    function setMobileSide(side){
      var safeSide = side === 'back' ? 'back' : 'front';
      root.setAttribute('data-kb-mobile-side', safeSide);
      for(var i=0;i<mobileSideBtns.length;i++){
        var btn = mobileSideBtns[i];
        btn.setAttribute('data-active', btn.getAttribute('data-kb-side') === safeSide ? 'true' : 'false');
      }
      syncLayoutModeControls();
      queueMobileOverlaySync();
    }

    function syncColourSwatches(){
      if(!colourSwatchesHost) return;
      var cards = colourSwatchesHost.querySelectorAll('[data-kb-swatch]');
      for(var i=0;i<cards.length;i++){
        var c = cards[i];
        var selected = c.getAttribute('data-kb-swatch') === state.selectedColour;
        c.setAttribute('data-active', selected ? 'true' : 'false');
        c.setAttribute('aria-selected', selected ? 'true' : 'false');
        var selectedTag = c.querySelector('[data-kb-swatch-selected]');
        if(selectedTag) selectedTag.hidden = !selected;
      }
      syncMobileColourSummary();
    }

    function syncMobileColourSummary(){
      if(!mobileColourSelected) return;
      mobileColourSelected.textContent = 'Selected: ' + (state.selectedColour || '—');
    }

    function setReloadInlineMessage(msg){
      if(!reloadMsg) return;
      var text = String(msg || '').trim();
      reloadMsg.hidden = !text;
      reloadMsg.textContent = text;
    }

    function setInputValueSilently(el, value){
      if(!el) return;
      suppressUIEvents = true;
      el.value = String(value);
      suppressUIEvents = false;
    }

    function syncSliders(){
      setInputValueSilently(sliders.badgeS, state.placements.badge.s);
      setInputValueSilently(sliders.badgeX, state.placements.badge.x);
      setInputValueSilently(sliders.badgeY, state.placements.badge.y);

      setInputValueSilently(sliders.sponsorS, state.placements.sponsor.s);
      setInputValueSilently(sliders.sponsorX, state.placements.sponsor.x);
      setInputValueSilently(sliders.sponsorY, state.placements.sponsor.y);

      for (var k in outs){
        if(outs[k] && sliders[k]) outs[k].textContent = fmtOut(sliders[k].value);
      }
    }

    /* ------------------------------------------------------------
      SCRUBBABLE RANGES (Fixes “dead sliders” in Shopify editor)
      - Makes the whole slider row draggable; updates the <input type=range> value manually
    ------------------------------------------------------------ */
    function makeRangeScrubbable(sl){
      if(!sl || sl.dataset.kbRangeBound === 'true') return;

      var row = sl.closest('.msh-kb__sl') || sl.parentElement;
      if(!row) return;

      var scrub = document.createElement('div');
      scrub.className = 'msh-kb__scrub';
      scrub.setAttribute('data-kb-scrub', '');

      sl.parentNode.insertBefore(scrub, sl);
      scrub.appendChild(sl);

      var dragging = false;
      var activePointerId = null;

      function emitRangeEvents(){
        sl.dispatchEvent(new Event('input', { bubbles:true }));
        sl.dispatchEvent(new Event('change', { bubbles:true }));
      }

      function setFromClientX(clientX){
        var rect = scrub.getBoundingClientRect();
        if(!rect || !rect.width) return;

        var min = parseFloat(sl.min || '0');
        var max = parseFloat(sl.max || '1');
        var step = parseFloat(sl.step || '0');

        var pct = clamp((clientX - rect.left) / rect.width, 0, 1);
        var value = min + pct * (max - min);

        if(step && isFinite(step) && step > 0){
          var places = (String(sl.step || '').split('.')[1] || '').length;
          value = Math.round((value - min) / step) * step + min;
          value = parseFloat(value.toFixed(Math.min(places + 2, 8)));
        }

        value = clamp(value, min, max);
        sl.value = String(value);
        emitRangeEvents();
      }

      function getClientX(evt){
        if(evt.touches && evt.touches[0]) return evt.touches[0].clientX;
        if(evt.changedTouches && evt.changedTouches[0]) return evt.changedTouches[0].clientX;
        return evt.clientX;
      }

      function startScrub(evt){
        dragging = true;
        activePointerId = typeof evt.pointerId === 'number' ? evt.pointerId : null;
        if(typeof evt.pointerId === 'number' && scrub.setPointerCapture){
          try{ scrub.setPointerCapture(evt.pointerId); }catch(_e){}
        }
        setFromClientX(getClientX(evt));
        evt.preventDefault();
        evt.stopPropagation();
      }

      function moveScrub(evt){
        if(!dragging) return;
        if(activePointerId !== null && typeof evt.pointerId === 'number' && evt.pointerId !== activePointerId) return;
        setFromClientX(getClientX(evt));
        evt.preventDefault();
        evt.stopPropagation();
      }

      function endScrub(evt){
        if(!dragging) return;
        if(activePointerId !== null && evt && typeof evt.pointerId === 'number' && evt.pointerId !== activePointerId) return;
        dragging = false;
        if(activePointerId !== null && scrub.releasePointerCapture){
          try{ scrub.releasePointerCapture(activePointerId); }catch(_e2){}
        }
        activePointerId = null;
      }

      scrub.addEventListener('pointerdown', startScrub, true);
      scrub.addEventListener('pointermove', moveScrub, true);
      scrub.addEventListener('pointerup', endScrub, true);
      scrub.addEventListener('pointercancel', endScrub, true);
      scrub.addEventListener('mousedown', startScrub, true);
      scrub.addEventListener('mousemove', moveScrub, true);
      scrub.addEventListener('mouseup', endScrub, true);
      scrub.addEventListener('touchstart', startScrub, { capture:true, passive:false });
      scrub.addEventListener('touchmove', moveScrub, { capture:true, passive:false });
      scrub.addEventListener('touchend', endScrub, { capture:true, passive:false });
      scrub.addEventListener('touchcancel', endScrub, { capture:true, passive:false });
      window.addEventListener('mouseup', endScrub, true);
      window.addEventListener('touchend', endScrub, true);
      window.addEventListener('touchcancel', endScrub, true);
      window.addEventListener('pointerup', endScrub, true);
      window.addEventListener('pointercancel', endScrub, true);

      sl.dataset.kbRangeBound = 'true';
    }

    function bindRange(sl, outEl, getter, setter){
      if(!sl) return;

      // Make it draggable even when native slider drag is blocked
      makeRangeScrubbable(sl);

      function apply(){
        if(suppressUIEvents) return;
        var v = parseFloat(sl.value);
        if(!isFinite(v)) v = 0;
        setter(v);
        if(outEl) outEl.textContent = fmtOut(v);
        saveState();
        render();
      }

      // init
      sl.value = String(getter());
      if(outEl) outEl.textContent = fmtOut(sl.value);

      // stop editor / theme scripts from hijacking
      sl.addEventListener('pointerdown', function(e){ e.stopPropagation(); }, true);
      sl.addEventListener('mousedown', function(e){ e.stopPropagation(); }, true);
      sl.addEventListener('touchstart', function(e){ e.stopPropagation(); }, { capture:true, passive:true });
      sl.addEventListener('pointermove', function(e){ e.stopPropagation(); }, true);

      // capture so we win
      sl.addEventListener('input', apply, true);
      sl.addEventListener('change', apply, true);
      sl.addEventListener('pointerup', apply, true);
      sl.addEventListener('touchend', apply, true);
    }

    function setImageCentered(imgEl, cx, cy, sizeW, sizeH){
      var x = cx - sizeW/2;
      var y = cy - sizeH/2;
      imgEl.setAttribute('x', String(x));
      imgEl.setAttribute('y', String(y));
      imgEl.setAttribute('width', String(sizeW));
      imgEl.setAttribute('height', String(sizeH));
    }

    function hideImage(imgEl){
      if(!imgEl) return;
      imgEl.setAttribute('href', '');
      imgEl.setAttribute('width', '0');
      imgEl.setAttribute('height', '0');
    }

    function syncBackLockDebug(){
      if(!backLockDebug) return;
      if(!adminModeEnabled){
        backLockDebug.hidden = true;
        backLockDebug.textContent = '';
        return;
      }
      backLockDebug.hidden = false;
      backLockDebug.textContent = 'Locked Back: size=' + fmtOut(LOCK_BACK.size) + ', x=' + fmtOut(LOCK_BACK.x) + ', y=' + fmtOut(LOCK_BACK.y) + ', gap=' + fmtOut(LOCK_BACK.gap);
    }

    async function computeDigitMetrics(digitChar, digitUrl, measGroup){
      var cached = state.digitMetricsCache[digitChar];
      if(cached){
        var cachedWrap = createSvgElement('svg');
        cachedWrap.innerHTML = cached.symbolMarkup;
        var cachedSym = cachedWrap.firstElementChild;
        if(cachedSym) defsBack.appendChild(cachedSym.cloneNode(true));
        return cached.metric;
      }

      var txt = await fetchSvgText(digitUrl);
      state.digitSvgSource[digitChar] = txt;
      var badgeSlotMetric = getBadgeSlotFromDigitSvg(txt);
      var sym = createSvgElement('symbol');
      sym.setAttribute('id', 'kb-digit-' + digitChar);
      var viewBoxRaw = '0 0 1024 1024';

      var holder = createSvgElement('g');
      try{
        var parsedRoot = parseSvgRoot(txt);
        viewBoxRaw = parsedRoot.getAttribute('viewBox') || '0 0 1024 1024';
        sym.setAttribute('viewBox', viewBoxRaw);
        sym.setAttribute('preserveAspectRatio', 'xMidYMid meet');

        var rootFillRule = parsedRoot.getAttribute('fill-rule');
        var rootClipRule = parsedRoot.getAttribute('clip-rule');
        if(rootFillRule) holder.setAttribute('fill-rule', rootFillRule);
        if(rootClipRule) holder.setAttribute('clip-rule', rootClipRule);

        var kids = parsedRoot.childNodes;
        for(var k=0; k<kids.length; k++){
          holder.appendChild(document.importNode(kids[k], true));
        }

        forceDigitColours(holder, digitChar);
      }catch(rewriteErr){
        console.warn('[MSH KB digit rewrite] failed', digitChar, rewriteErr);
        throw new Error('Digit rewrite failed for ' + digitChar + ': ' + (rewriteErr && rewriteErr.message ? rewriteErr.message : rewriteErr));
      }

      sym.appendChild(holder);
      defsBack.appendChild(sym);

      var use = createSvgElement('use');
      use.setAttribute('href', '#kb-digit-' + digitChar);
      use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#kb-digit-' + digitChar);
      use.setAttribute('class', 'kb-digit');
      measGroup.appendChild(use);

      try{
        await new Promise(function(r){ requestAnimationFrame(r); });

        var bb = use.getBBox();
        if(!bb || !isFinite(bb.width) || !isFinite(bb.height) || bb.width <= 0 || bb.height <= 0){
          console.warn('[MSH KB digit rewrite] empty measured bbox', digitChar, bb);
          throw new Error('Digit ' + digitChar + ' rendered empty after recolour.');
        }

        var strokeInflation = getSymbolStrokeInflation(sym);
        var viewBoxParts = String(viewBoxRaw).trim().split(/\s+/).map(function(v){ return parseFloat(v); });
        var viewBoxMetric = {
          x: 0,
          y: 0,
          w: 1024,
          h: 1024
        };
        if(viewBoxParts.length === 4 && isFinite(viewBoxParts[2]) && isFinite(viewBoxParts[3]) && viewBoxParts[2] > 0 && viewBoxParts[3] > 0){
          viewBoxMetric = {
            x: isFinite(viewBoxParts[0]) ? viewBoxParts[0] : 0,
            y: isFinite(viewBoxParts[1]) ? viewBoxParts[1] : 0,
            w: viewBoxParts[2],
            h: viewBoxParts[3]
          };
        }

        var safeBox = {
          x: bb.x - strokeInflation,
          y: bb.y - strokeInflation,
          w: bb.width + (strokeInflation * 2),
          h: bb.height + (strokeInflation * 2)
        };

        var rasterProbe = null;
        if(KB_METRICS){
          try{
            rasterProbe = await rasterAnalyzeDigit(sym.outerHTML, 'kb-digit-' + digitChar, safeBox);
          }catch(rasterErr){
            if(rasterErr && rasterErr.code === 'KB_METRICS_TIMEOUT'){
              if(isDebugEnabled()) console.warn('[MSH KB digit raster probe] timed out; using fallback spacing', digitChar, rasterErr);
            }else{
              console.warn('[MSH KB digit raster probe] failed', digitChar, rasterErr);
            }
          }
        }

        var alphaBounds = rasterProbe && rasterProbe.alphaBounds ? rasterProbe.alphaBounds : safeBox;
        var insetLeft = Math.max(0, alphaBounds.x - safeBox.x);
        var insetRight = Math.max(0, (safeBox.x + safeBox.w) - (alphaBounds.x + alphaBounds.w));
        var metric = {
          viewBox: viewBoxMetric,
          badgeSlot: badgeSlotMetric,
          bbox: { x: safeBox.x, y: safeBox.y, w: safeBox.w, h: safeBox.h },
          visual: {
            insetLeft: insetLeft,
            insetRight: insetRight,
            strokeHalf: strokeInflation,
            strokeMax: strokeInflation * 2
          },
          innerBox: buildDigitInnerBox(digitChar, safeBox, rasterProbe && rasterProbe.holeBounds ? rasterProbe.holeBounds : null)
        };

        state.digitMetricsCache[digitChar] = {
          metric: metric,
          symbolMarkup: sym.outerHTML
        };
        return metric;
      }finally{
        measGroup.removeChild(use);
      }
    }

    async function installDigitsAndNape(){
      var digitUrls = {
        "0": String((config.digitAssets && config.digitAssets['0']) || ''),
        "1": String((config.digitAssets && config.digitAssets['1']) || ''),
        "2": String((config.digitAssets && config.digitAssets['2']) || ''),
        "3": String((config.digitAssets && config.digitAssets['3']) || ''),
        "4": String((config.digitAssets && config.digitAssets['4']) || ''),
        "5": String((config.digitAssets && config.digitAssets['5']) || ''),
        "6": String((config.digitAssets && config.digitAssets['6']) || ''),
        "7": String((config.digitAssets && config.digitAssets['7']) || ''),
        "8": String((config.digitAssets && config.digitAssets['8']) || ''),
        "9": String((config.digitAssets && config.digitAssets['9']) || '')
      };

      clearNode(defsBack);

      // temp measure group
      var measGroup = createSvgElement('g');
      measGroup.setAttribute('opacity', '0');
      measGroup.setAttribute('pointer-events', 'none');
      svgBack.appendChild(measGroup);

      try{
        state.digitBBox = {};
        state.digitViewBox = {};
        state.digitBadgeSlot = {};
        state.digitVisualMetrics = {};
        state.digitInnerBox = {};
        state.digitSvgSource = {};
        state.digitLayerRenderCache = {};
        state.pairKerning = {};
        PAIR_KERNING = Object.create(null);

        for(var d=0; d<=9; d++){
          var key = String(d);
          // eslint-disable-next-line no-await-in-loop
          var metric = await computeDigitMetrics(key, digitUrls[key], measGroup);
          state.digitBBox[key] = metric.bbox;
          state.digitViewBox[key] = metric.viewBox;
          state.digitBadgeSlot[key] = metric.badgeSlot || null;
          state.digitVisualMetrics[key] = metric.visual;
          state.digitInnerBox[key] = metric.innerBox;
        }
      }catch(e){
        throw new Error('Digit SVGs failed to load/measure. Check assets digit-0.svg … digit-9.svg.\n\n' + (e && e.message ? e.message : e));
      }finally{
        svgBack.removeChild(measGroup);
      }

      showDigitRewriteErr('');

      buildPairKerningLookup();

      // Nape (slightly smaller)
      try{
        var napeTxt = await fetchSvgText(String(config.napeAsset || ""));
        state.napeSvgRaw = napeTxt;
        var napeEx = extractSvgInner(napeTxt);

        clearNode(napeHolder);

        var napeSvg = createSvgElement('svg');
        napeSvg.setAttribute('viewBox', napeEx.viewBox);
        napeSvg.setAttribute('width', '1');
        napeSvg.setAttribute('height', '1');
        napeSvg.innerHTML = napeEx.inner;

        var w = LOCK_NAPE.size * CANVAS;
        var x = LOCK_NAPE.x * CANVAS - w/2;
        var y = LOCK_NAPE.y * CANVAS - w/2;

        var g = createSvgElement('g');
        g.setAttribute('class', 'kb-hit');
        g.setAttribute('data-kb-layout-target', 'nape');
        g.setAttribute('transform', 'translate(' + x + ' ' + y + ') scale(' + w + ')');
        g.appendChild(napeSvg);

        napeHolder.appendChild(g);
      }catch(e2){
        console.warn('Nape SVG failed', e2);
      }
    }

    function applyNapeRecolour(){
      try{
        if(!state.napeSvgRaw) return;

        var napeColors = getEffectiveNapeColors();

        var napeSvg = napeHolder.querySelector('svg');
        if(!napeSvg) return;

        var recolored = recolorNapeSvg(state.napeSvgRaw, napeColors.text, napeColors.squares);
        var recoloredInner = extractSvgInner(recolored);
        napeSvg.innerHTML = recoloredInner.inner;
      }catch(e){}
    }

    function getCachedOverlayImage(kind, src){
      var cache = overlayImageCache[kind];
      if(!cache) return null;
      if(!src) return null;
      if(cache.src === src && cache.img) return cache.img;
      var img = new Image();
      img.onload = function(){ Render.request(kind + ' overlay-loaded'); };
      img.src = src;
      cache.src = src;
      cache.img = img;
      return img;
    }

    function getOverlayAspect(kind, img, fallbackAspect){
      var naturalW = img && img.naturalWidth ? img.naturalWidth : 0;
      var naturalH = img && img.naturalHeight ? img.naturalHeight : 0;
      if(naturalW > 0 && naturalH > 0){
        var measured = naturalW / naturalH;
        if(isFinite(measured) && measured > 0){
          if(kind === 'sponsor') state.sponsorAspect = measured;
          if(kind === 'badge') state.badgeAspect = measured;
          return measured;
        }
      }
      var fallback = parseFloat(fallbackAspect);
      if(isFinite(fallback) && fallback > 0) return fallback;
      return 1;
    }

    function renderFrontToCanvas(ctx, size, rectStore){
      if(!ctx) return;
      var canvasSize = size || CANVAS;
      var rects = rectStore || { badge:null, sponsor:null };
      ctx.clearRect(0, 0, canvasSize, canvasSize);

      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      if(state.baseFrontImage){
        ctx.drawImage(state.baseFrontImage, 0, 0, canvasSize, canvasSize);
      }

      if(state.badgeData){
        var b = state.placements.badge;
        var badgeSize = b.s * canvasSize;
        var badgeX = b.x * canvasSize;
        var badgeY = b.y * canvasSize;
        rects.badge = {
          x: badgeX - badgeSize/2,
          y: badgeY - badgeSize/2,
          w: badgeSize,
          h: badgeSize
        };
        var badgeImg = getCachedOverlayImage('badge', state.badgeData);
        if(badgeImg && badgeImg.complete && badgeImg.naturalWidth){
          ctx.drawImage(badgeImg, rects.badge.x, rects.badge.y, rects.badge.w, rects.badge.h);
        }
      }else{
        rects.badge = null;
      }

      if(state.sponsorData){
        var sp = state.placements.sponsor;
        var sponsorImg = getCachedOverlayImage('sponsor', state.sponsorData);
        var sponsorAspect = getOverlayAspect('sponsor', sponsorImg, state.sponsorAspect);
        var w = sp.s * canvasSize;
        var h = w / sponsorAspect;
        var sponsorX = sp.x * canvasSize;
        var sponsorY = sp.y * canvasSize;
        rects.sponsor = {
          x: sponsorX - w/2,
          y: sponsorY - h/2,
          w: w,
          h: h
        };
        if(sponsorImg && sponsorImg.complete && sponsorImg.naturalWidth){
          ctx.drawImage(sponsorImg, rects.sponsor.x, rects.sponsor.y, rects.sponsor.w, rects.sponsor.h);
        }
      }else{
        rects.sponsor = null;
      }
    }

    function assertSvgImageUnits(imageEl, label){
      if(!imageEl) return;
      var w = imageEl.getAttribute('width') || '';
      var h = imageEl.getAttribute('height') || '';
      if(/px$/i.test(w) || /px$/i.test(h)){
        imageEl.setAttribute('width', String(parseFloat(w) || 0));
        imageEl.setAttribute('height', String(parseFloat(h) || 0));
        console.warn('[MSH KB] ' + label + ' used CSS px units; normalized to SVG units.');
      }
    }

    function renderFront(opts){
      migrateFrontPlacementsToNormalized();
      var options = opts || {};
      var rectStore = options.rectStore || state.frontRects;
      setSvgImageHref(baseFront, state.baseFrontData || '');
      rectStore.badge = null;
      rectStore.sponsor = null;

      if(state.badgeData){
        setSvgImageHref(frontBadge, state.badgeData);
        var b = state.placements.badge;
        var size = b.s * CANVAS;
        var badgeX = b.x * CANVAS;
        var badgeY = b.y * CANVAS;
        rectStore.badge = {
          x: badgeX - size/2,
          y: badgeY - size/2,
          w: size,
          h: size
        };
        setImageCentered(frontBadge, badgeX, badgeY, size, size);
        assertSvgImageUnits(frontBadge, 'badge');
      }else{
        hideImage(frontBadge);
      }

      if(state.sponsorData){
        setSvgImageHref(frontSponsor, state.sponsorData);
        var sp = state.placements.sponsor;
        var sponsorImg = getCachedOverlayImage('sponsor', state.sponsorData);
        var sponsorAspect = getOverlayAspect('sponsor', sponsorImg, state.sponsorAspect);
        var w = sp.s * CANVAS;
        var h = w / sponsorAspect;
        var sponsorX = sp.x * CANVAS;
        var sponsorY = sp.y * CANVAS;
        rectStore.sponsor = {
          x: sponsorX - w/2,
          y: sponsorY - h/2,
          w: w,
          h: h
        };
        setImageCentered(frontSponsor, sponsorX, sponsorY, w, h);
        assertSvgImageUnits(frontSponsor, 'sponsor');
      }else{
        hideImage(frontSponsor);
      }

      if(options.ctx){
        renderFrontToCanvas(options.ctx, options.size || CANVAS, rectStore);
      }
    }

    /* MOBILE ONLY: number input debounce + symbol caching */
    async function ensureDigitsReady(opts){
      var options = opts || {};
      var force = !!(options === true || options.force);
      if(digitSymbolsReady && !force) return;
      if(digitSymbolsReadyPromise){
        if(!force) return digitSymbolsReadyPromise;
        try{ await digitSymbolsReadyPromise; }catch(_e){}
      }
      digitSymbolsReadyPromise = installDigitsAndNape().then(function(){
        digitSymbolsReady = true;
        if(reloadDigitsBtn) reloadDigitsBtn.hidden = true;
      }).catch(function(err){
        if(reloadDigitsBtn) reloadDigitsBtn.hidden = false;
        throw err;
      }).finally(function(){
        digitSymbolsReadyPromise = null;
      });
      return digitSymbolsReadyPromise;
    }

    function renderBack(){
      var backHref = state.baseBackData || (backState && backState.loadedUrl ? backState.loadedUrl : '');
      if(backHref) setSvgImageHref(baseBack, backHref);

      if(defsBack && !defsBack.querySelector('#kb-digit-0')){
        if(reloadDigitsBtn) reloadDigitsBtn.hidden = false;
        return;
      }

      var previousBackRender = {
        numberHtml: numberGroup ? numberGroup.innerHTML : '',
        strokeHtml: numberStrokeGroup ? numberStrokeGroup.innerHTML : ''
      };

      try{
        applyBackLayoutTransforms();
        var numberColors = getNumberChannelColors(state);
        svgBack.style.setProperty('--kb-fill', numberColors.fill);
        svgBack.style.setProperty('--kb-stroke', numberColors.stroke);
        if(numberGroup){
          numberGroup.style.setProperty('--kb-fill', numberColors.fill);
          numberGroup.style.setProperty('--kb-stroke', numberColors.stroke);
        }
        applyNapeRecolour();
        clearNode(numberGroup);
        clearNode(numberStrokeGroup);

        var raw = sanitizeNumber(elNumber.value);
        elNumber.value = raw;
        var num = raw || '0';
        var digits = num.split('').slice(0,2);

        var heightPx = LOCK_BACK.size * CANVAS;
        var widths = digits.map(function(d){
          var vb = state.digitViewBox[d];
          if(!vb || !vb.h) return heightPx * 0.7;
          var ratio = vb.w / vb.h;
          ratio = clamp(ratio, 0.35, 1.20);
          return heightPx * ratio;
        });

        const numberValue = raw;
        const isTen = String(numberValue).trim() === '10';
        const digitGap = isTen ? 0.000 : LOCK_BACK.gap;

        var pairKey = digits.length === 2 ? (digits[0] + digits[1]) : '';
        var lockedGapPx = digitGap * heightPx;
        var pairKerningPx = digits.length === 2 ? getPairKerningPx(pairKey) : 0;
        var gapPx = digits.length > 1 ? (pairKerningPx + lockedGapPx) : 0;

        state.numberSpacingDebug = {
          number: digits.join(''),
          lockedGapPx: lockedGapPx,
          pairKerningPx: pairKerningPx,
          appliedGapPx: gapPx
        };

        var groupW = widths.reduce(function(a,b){ return a+b; }, 0) + (digits.length>1 ? gapPx : 0);
        var gx = LOCK_BACK.x*CANVAS - groupW/2;
        var gy = LOCK_BACK.y*CANVAS - heightPx/2;

        var digitBoxes = new Array(digits.length);
        if(digits.length > 1){
          var leftDigitX = gx;
          var rightDigitX = gx + widths[0] + gapPx;
          digitBoxes[0] = { x: leftDigitX, y: gy, w: widths[0], h: heightPx };
          digitBoxes[1] = { x: rightDigitX, y: gy, w: widths[1], h: heightPx };
        }else{
          digitBoxes[0] = { x: gx, y: gy, w: widths[0], h: heightPx };
        }

        state.numberDigitRects = digitBoxes;

        [numLogo, numLogoL, numLogoR].forEach(function(layer){ hideImage(layer); });
        if(numLogoDebug) clearNode(numLogoDebug);

        for(var digitIndex=0; digitIndex<digits.length; digitIndex++){
          var digitChar = digits[digitIndex];
          var digitBox = digitBoxes[digitIndex];
          if(!digitBox) continue;

          if(isDebugEnabled()){
            console.log('[MSH KB DEBUG] digit compose', {
              digitChar: digitChar,
              hasSlot: !!state.digitBadgeSlot[digitChar],
              badgeAdded: !!(state.badgeData && state.digitBadgeSlot[digitChar])
            });
          }
          if(!state.digitBadgeSlot[digitChar] && !state.badgeSlotWarned[digitChar]){
            state.badgeSlotWarned[digitChar] = true;
            console.warn('[MSH KB] badge-slot missing for digit', digitChar);
          }

          appendDigitInstanceWithBadge(numberGroup, digitChar, digitBox, state.badgeData || '', digitChar + '-' + digitIndex);
        }

        lastGoodBackRender = {
          numberHtml: numberGroup ? numberGroup.innerHTML : '',
          strokeHtml: numberStrokeGroup ? numberStrokeGroup.innerHTML : ''
        };
      }catch(backRenderErr){
        kbLog('renderBack exception', backRenderErr);
        if(isDebugEnabled()) console.error('[MSH KB] back render failed', backRenderErr);
        showErr('Back preview had a rendering issue; keeping the last good preview.');

        var fallback = lastGoodBackRender || previousBackRender;
        if(fallback){
          if(numberGroup) numberGroup.innerHTML = fallback.numberHtml || '';
          if(numberStrokeGroup) numberStrokeGroup.innerHTML = fallback.strokeHtml || '';
          [numLogo, numLogoL, numLogoR].forEach(function(layer){ hideImage(layer); });
        }
      }
    }

    function performRender(){
      updateLoadingIndicators();
      showErr('');

      state.baseFrontImage = frontState.img;
      state.baseBackImage = backState.img;
      state.baseFrontData = frontState.loadedUrl || '';
      state.baseBackData = backState.loadedUrl || '';

      if(frontState.status === 'error' || backState.status === 'error'){
        var frontErr = frontState.err ? String(frontState.err && frontState.err.message ? frontState.err.message : frontState.err) : '';
        var backErr = backState.err ? String(backState.err && backState.err.message ? backState.err.message : backState.err) : '';
        var errMsg = 'Mockup failed to load.';
        if(frontErr || backErr){
          errMsg += '\n\nFront: ' + (frontErr || frontState.status) + '\nBack: ' + (backErr || backState.status);
        }
        showErr(errMsg);
      }

      setRetryVisible(frontState.status === 'error' || backState.status === 'error');

      if(!frontState.img || !backState.img){
        kbLog('render-skip-base-image-missing', {
          frontStatus: frontState.status,
          backStatus: backState.status,
          frontLoaded: !!frontState.img,
          backLoaded: !!backState.img
        });
        if(frontState.img){ renderFront(); syncResizeOverlay(); }
        if(backState.img) renderBack();
        syncBackLockDebug();
        return;
      }

      setLoadingUI('front', false);
      setLoadingUI('back', false);
      renderFront();
      syncResizeOverlay();
      renderBack();
      queueBrochurePreviewStorageSync();
      if(frontState.status === 'ok' || frontState.img) setLoadingUI('front', false);
      if(backState.status === 'ok' || backState.img) setLoadingUI('back', false);
      syncBackLockDebug();
    }

    function queueUIRender(reason){
      if(loopTripped) return;
      if(uiRenderRaf) return;
      uiRenderRaf = requestAnimationFrame(function(){
        uiRenderRaf = 0;
        if(!scrollSettled){
          if(scrollDebounceTimer) clearTimeout(scrollDebounceTimer);
          scrollDebounceTimer = setTimeout(function(){
            scrollDebounceTimer = 0;
            queueUIRender(reason || 'ui-scroll-settled');
          }, 120);
          return;
        }
        Render.request(reason || 'ui');
      });
    }

    function render(reason){
      queueUIRender(reason || 'render()');
    }

    function loadMockupSide(which, url, generation){
      var side = getSideState(which);
      if(!side) return;
      var prevUrl = side.url;
      kbLog('loadMockupSide-start', { side:which, url:url, prevUrl:prevUrl || '', generation:generation, currentGeneration:renderGeneration });
      if(!url){
        setSideState(which, { url:'', status:'error', img:null, err:new Error('Missing mockup URL') });
        return;
      }

      if(prevUrl === url && side.img && side.status === 'ok'){
        kbLog('load-skip-unchanged-' + which, { url:url });
        Render.request(which + ' img cached');
        return;
      }

      setSideState(which, { url:url, status:'loading', img:side.img || null, loadedUrl:side.loadedUrl || '', err:null });
      setLoadingUI(which, !side.img, 'Loading…');
      Render.request(which + ' loading');

      loadImageWithTimeout(url, IMAGE_LOAD_TIMEOUT_MS).then(function(img){
        if(generation !== renderGeneration){
          kbLog('stale-generation-ignore', { expected:renderGeneration, got:generation, side:which });
          return;
        }
        var live = getSideState(which);
        if(!live || live.url !== url){
          kbLog('stale-url-ignore', { side:which, url:url, liveUrl:live ? live.url : '' });
          return;
        }
        kbLog('loadMockupSide-settle-ok', { side:which, url:url, generation:generation });
        setSideState(which, { status:'ok', loadedUrl:url, img:img, err:null });
        setLoadingUI(which, false);
        Render.request(which + ' img ok');
      }).catch(function(err){
        if(generation !== renderGeneration){
          kbLog('stale-generation-ignore', { expected:renderGeneration, got:generation, side:which });
          return;
        }
        var live = getSideState(which);
        if(!live || live.url !== url){
          kbLog('stale-url-ignore', { side:which, url:url, liveUrl:live ? live.url : '' });
          return;
        }
        kbLog('loadMockupSide-settle-error', { side:which, url:url, generation:generation, error:String(err && err.message ? err.message : err) });
        setSideState(which, { status:'error', img:live && live.img ? live.img : null, loadedUrl:live && live.loadedUrl ? live.loadedUrl : '', err:err });
        setLoadingUI(which, false);
        Render.request(which + ' img error');
      });
    }

    async function setColour(colour){
      state.selectedColour = colour;
      setLS('mshColourway', colour || '');
      trackShirtConfigVersion('colourway-change');
      applyBackLayout(productHandle);
      var generation = ++renderGeneration;
      kbLog('render-generation-change', { generation:generation, colour:colour });

      loadSaved(colour);
      syncToolChips();
      syncSliders();
      syncNapeOverrideInputs();
      syncNumberColorInputs();
      syncColourSwatches();

      var urls = matchMockupUrls(state.product, colour);
      kbLog('selected-urls', { colour:colour, front:urls.front || '', back:urls.back || '' });
      state.selectedMockupUrls = { front: urls.front || '', back: urls.back || '' };

      if(!urls.front || !urls.back){
        frontState = { url:urls.front || '', loadedUrl:'', status:urls.front ? 'idle' : 'error', img:null, err:urls.front ? null : new Error('Missing front mockup ALT match') };
        backState = { url:urls.back || '', loadedUrl:'', status:urls.back ? 'idle' : 'error', img:null, err:urls.back ? null : new Error('Missing back mockup ALT match') };
        setLoadingUI('front', false);
        setLoadingUI('back', false);
        var modelKeyForAlt = String(state.modelKey || namespaceOverride || '').trim();
        showErr(
          'Could not find front/back mockups for "' + colour + '".\n\n' +
          'ALT must be:\n' +
          '  "' + modelKeyForAlt + ' | ' + colour + ' | front"\n' +
          '  "' + modelKeyForAlt + ' | ' + colour + ' | back"\n'
        );
        render('colour-change-missing-mockups');
        return;
      }

      showErr('');
      loadMockupSide('front', urls.front, generation);
      loadMockupSide('back', urls.back, generation);
      syncContinueToShortsState();
    }

    function getContinueShirtHandle(){
      var fromUrl = String(getParam('handle') || '').trim();
      if(fromUrl) return fromUrl;
      return String(
        getLS('mshModelHandle') ||
        getLS('mshShirtHandle') ||
        getLS('msh_last_model') ||
        productHandle ||
        ''
      ).trim();
    }

    function getContinueShirtColourway(){
      return String(
        state.selectedColour ||
        getLS('mshShirtColourway') ||
        getLS('mshColourway') ||
        (elColour && elColour.value) ||
        ''
      ).trim();
    }

    function syncContinueToShortsState(){
      if(!continueToShortsBtn) return;
      var hasHandle = !!getContinueShirtHandle();
      var hasColourway = !!getContinueShirtColourway();
      var canContinue = hasHandle && hasColourway;
      continueToShortsBtn.disabled = !canContinue;
      continueToShortsBtn.setAttribute('aria-disabled', canContinue ? 'false' : 'true');
    }

    function getContinueKitType(){
      return String(
        getParam('kit') ||
        getLS('mshKitType') ||
        getLS('msh_mode') ||
        ''
      ).trim();
    }

    function getContinueBand(){
      return normalizeAudience(
        getParam('band') ||
        getParam('aud') ||
        getLS('mshAgeBand') ||
        getLS('msh_audience') ||
        'snr'
      );
    }

    function buildContinueToShortsUrl(selectedHandle){
      var params = new URLSearchParams('');
      params.set('from', 'shirt');
      params.set('handle', selectedHandle);

      var kit = getContinueKitType();
      var band = getContinueBand();
      if(kit) params.set('kit', kit);
      if(band) params.set('band', band);

      return '/pages/kit-shorts?' + params.toString();
    }

    function setupContinueToShorts(){
      if(!continueToShortsBtn) return;

      continueToShortsBtn.addEventListener('click', async function(){
        if(continueToShortsBtn.disabled) return;

        var selectedHandle = getContinueShirtHandle();
        var selectedColourway = getContinueShirtColourway();
        if(!selectedHandle || !selectedColourway){
          syncContinueToShortsState();
          return;
        }

        setLS('mshModelHandle', selectedHandle);
        setLS('mshColourway', selectedColourway);

        var selectedKitType = getContinueKitType();
        var selectedBand = getContinueBand();
        if(selectedKitType) setLS('mshKitType', selectedKitType);
        if(selectedBand){
          setLS('mshAgeBand', selectedBand);
          setLS('msh_audience', selectedBand);
        }

        var originalLabel = continueToShortsBtn.textContent;
        continueToShortsBtn.disabled = true;
        continueToShortsBtn.setAttribute('aria-disabled', 'true');
        continueToShortsBtn.setAttribute('aria-busy', 'true');
        continueToShortsBtn.textContent = 'Continuing…';

        var nextUrl = buildContinueToShortsUrl(selectedHandle);
        try{
          await captureShirtSnapshotsForContinue({
            modelHandle: selectedHandle,
            colourway: selectedColourway,
            band: selectedBand,
            number: (elNumber && elNumber.value) || ''
          });
        }catch(captureErr){
          if(isKbDebugEnabled()) kbLog('shirt-capture-continue-error', String(captureErr && captureErr.message ? captureErr.message : captureErr));
        }
        window.location.assign(nextUrl);

        window.setTimeout(function(){
          if(continueToShortsBtn && document.contains(continueToShortsBtn)){
            continueToShortsBtn.textContent = originalLabel;
            continueToShortsBtn.removeAttribute('aria-busy');
            syncContinueToShortsState();
          }
        }, 1200);
      });

      syncContinueToShortsState();
      if(continueWatchTimer) clearInterval(continueWatchTimer);
      continueWatchTimer = window.setInterval(syncContinueToShortsState, 400);
      window.addEventListener('pagehide', function(){
        if(continueWatchTimer){
          clearInterval(continueWatchTimer);
          continueWatchTimer = 0;
        }
      });
      window.addEventListener('storage', function(ev){
        if(!ev) return;
        if(
          ev.key === 'mshModelHandle' ||
          ev.key === 'msh_last_model' ||
          ev.key === 'mshShirtHandle' ||
          ev.key === 'mshColourway' ||
          ev.key === 'mshShirtColourway'
        ){
          syncContinueToShortsState();
        }
      });
    }

    function setDragTool(tool, options){
      state.dragTool = (tool === 'sponsor') ? 'sponsor' : 'badge';
      state.activeOverlay = state.dragTool;
      syncToolChips();
      syncResizeOverlay();
      if(!(options && options.skipPersist)) saveState();
    }

    function isEditModeActive(){
      var activeTab = root.querySelector('[data-kb-tab][data-active="true"]');
      if(!activeTab) return false;
      return activeTab.getAttribute('data-kb-tab') === 'logos';
    }

    function FrontOverlayController(options){
      var cfg = options || {};
      var badgeEl = cfg.badgeEl;
      var sponsorEl = cfg.sponsorEl;
      var overlay = cfg.overlay;
      var box = cfg.box;
      var handles = cfg.handles || [];
      var stageEl = cfg.stage;
      var stageInner = cfg.stageInner;
      var stateRef = cfg.state;
      var slidersRef = cfg.sliders;
      var outsRef = cfg.outs;
      var getIsEditMode = cfg.getIsEditMode;
      var onCommit = cfg.onCommit;
      var onToolChange = cfg.onToolChange;

      var activeInteraction = null;
      var pendingEvent = null;
      var moveRAF = 0;
      var overlayResizeObserver = null;

      function getRect(){
        var rect = stageInner && stageInner.getBoundingClientRect ? stageInner.getBoundingClientRect() : null;
        if(!rect || !rect.width || !rect.height) return null;
        var offsetW = stageInner && stageInner.offsetWidth ? stageInner.offsetWidth : 0;
        var offsetH = stageInner && stageInner.offsetHeight ? stageInner.offsetHeight : 0;
        var scaleX = offsetW > 0 ? rect.width / offsetW : 1;
        var scaleY = offsetH > 0 ? rect.height / offsetH : 1;
        if(!(scaleX > 0)) scaleX = 1;
        if(!(scaleY > 0)) scaleY = 1;
        return {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height,
          scaleX: scaleX,
          scaleY: scaleY
        };
      }

      function getToolAssetData(tool){
        return tool === 'sponsor' ? stateRef.sponsorData : stateRef.badgeData;
      }

      function getToolRect(tool){
        var p = stateRef.placements[tool] || { x:0.5, y:0.5, s:0.2 };
        var width = p.s * CANVAS;
        var height = width;
        if(tool === 'sponsor'){
          var sponsorImg = getCachedOverlayImage('sponsor', stateRef.sponsorData);
          var sponsorAspect = getOverlayAspect('sponsor', sponsorImg, stateRef.sponsorAspect);
          height = width / sponsorAspect;
        }
        return {
          x: p.x * CANVAS - width / 2,
          y: p.y * CANVAS - height / 2,
          w: width,
          h: height
        };
      }

      function getToolElement(tool){
        return tool === 'sponsor' ? sponsorEl : badgeEl;
      }

      function getRenderedToolBoundsPx(tool){
        var stage = stageEl || stageInner;
        var targetEl = getToolElement(tool);
        if(!stage || !targetEl || !stage.getBoundingClientRect || !targetEl.getBoundingClientRect) return null;
        var stageRect = stage.getBoundingClientRect();
        var targetRect = targetEl.getBoundingClientRect();
        if(!stageRect || !targetRect || !(stageRect.width > 0) || !(stageRect.height > 0) || !(targetRect.width > 0) || !(targetRect.height > 0)) return null;

        var left = (targetRect.left - stageRect.left) - FRONT_SELECTION_PADDING_PX;
        var top = (targetRect.top - stageRect.top) - FRONT_SELECTION_PADDING_PX;
        var right = (targetRect.right - stageRect.left) + FRONT_SELECTION_PADDING_PX;
        var bottom = (targetRect.bottom - stageRect.top) + FRONT_SELECTION_PADDING_PX;

        return {
          left: clamp(left, 0, stageRect.width),
          top: clamp(top, 0, stageRect.height),
          right: clamp(right, 0, stageRect.width),
          bottom: clamp(bottom, 0, stageRect.height)
        };
      }

      function applyToolToSvg(tool){
        var el = tool === 'sponsor' ? sponsorEl : badgeEl;
        if(!el) return;
        var rect = getToolRect(tool);
        setImageCentered(el, rect.x + rect.w / 2, rect.y + rect.h / 2, rect.w, rect.h);
        stateRef.frontRects[tool] = rect;
      }

      function syncOverlayBox(){
        var canShowFrontResize = layoutModeActive || !!(getIsEditMode && getIsEditMode());
        if(!overlay || !box){
          return;
        }
        if(!canShowFrontResize){
          overlay.hidden = true;
          overlay.classList.remove('kb-selected');
          return;
        }
        var activeTool = stateRef.activeOverlay === 'sponsor' ? 'sponsor' : (stateRef.activeOverlay === 'badge' ? 'badge' : null);
        if(!activeTool){
          overlay.hidden = true;
          overlay.classList.remove('kb-selected');
          return;
        }
        var hasAsset = !!getToolAssetData(activeTool);
        if(!hasAsset){
          overlay.hidden = true;
          overlay.classList.remove('kb-selected');
          return;
        }
        var renderedBounds = getRenderedToolBoundsPx(activeTool);
        if(!renderedBounds){
          overlay.hidden = true;
          overlay.classList.remove('kb-selected');
          return;
        }
        box.style.left = renderedBounds.left + 'px';
        box.style.top = renderedBounds.top + 'px';
        box.style.width = Math.max(0, renderedBounds.right - renderedBounds.left) + 'px';
        box.style.height = Math.max(0, renderedBounds.bottom - renderedBounds.top) + 'px';
        overlay.hidden = false;
        overlay.classList.add('kb-selected');
      }

      function syncToolOutputs(tool){
        var p = stateRef.placements[tool];
        if(!p) return;
        if(tool === 'badge'){
          setInputValueSilently(slidersRef.badgeX, p.x);
          setInputValueSilently(slidersRef.badgeY, p.y);
          setInputValueSilently(slidersRef.badgeS, p.s);
          if(outsRef.badgeX) outsRef.badgeX.textContent = fmtOut(p.x);
          if(outsRef.badgeY) outsRef.badgeY.textContent = fmtOut(p.y);
          if(outsRef.badgeS) outsRef.badgeS.textContent = fmtOut(p.s);
        }else{
          setInputValueSilently(slidersRef.sponsorX, p.x);
          setInputValueSilently(slidersRef.sponsorY, p.y);
          setInputValueSilently(slidersRef.sponsorS, p.s);
          if(outsRef.sponsorX) outsRef.sponsorX.textContent = fmtOut(p.x);
          if(outsRef.sponsorY) outsRef.sponsorY.textContent = fmtOut(p.y);
          if(outsRef.sponsorS) outsRef.sponsorS.textContent = fmtOut(p.s);
        }
      }

      function setDraggingClass(active){
        if(sectionRoot) sectionRoot.classList.toggle('kb-dragging', !!active);
        if(activeInteraction && activeInteraction.targetEl){
          activeInteraction.targetEl.classList.toggle('kb-dragging', !!active);
        }
      }

      function queueMove(e){
        pendingEvent = e;
        if(moveRAF) return;
        moveRAF = requestAnimationFrame(flushMove);
      }

      function flushMove(){
        moveRAF = 0;
        if(!activeInteraction || !pendingEvent) return;
        var evt = pendingEvent;
        pendingEvent = null;
        if(activeInteraction.pointerId !== null && isFinite(evt.pointerId) && evt.pointerId !== activeInteraction.pointerId) return;
        var rect = getRect();
        if(!rect) return;
        var pointerNx = clamp((evt.clientX - rect.left) / rect.width, 0, 1);
        var pointerNy = clamp((evt.clientY - rect.top) / rect.height, 0, 1);
        var tool = activeInteraction.tool;
        var p = stateRef.placements[tool];
        if(!p) return;

        if(activeInteraction.mode === 'drag'){
          p.x = clamp(pointerNx + activeInteraction.offsetNx, 0, 1);
          p.y = clamp(pointerNy + activeInteraction.offsetNy, 0, 1);
        }else if(activeInteraction.mode === 'resize'){
          var dx = (pointerNx - p.x) * rect.width;
          var dy = (pointerNy - p.y) * rect.height;
          var radial = Math.max(8, Math.hypot(dx, dy));
          var minS = activeInteraction.minS;
          var maxS = activeInteraction.maxS;
          p.s = clamp(activeInteraction.startS * (radial / activeInteraction.startRadius), minS, maxS);
        }

        syncToolOutputs(tool);
        applyToolToSvg(tool);
        syncOverlayBox();
      }

      function endInteraction(e){
        if(!activeInteraction) return;
        if(activeInteraction.pointerId !== null && e && isFinite(e.pointerId) && e.pointerId !== activeInteraction.pointerId) return;
        if(pendingEvent) flushMove();
        if(moveRAF){
          cancelAnimationFrame(moveRAF);
          moveRAF = 0;
        }
        var targetEl = activeInteraction.targetEl;
        var pointerId = activeInteraction.pointerId;
        if(targetEl && pointerId !== null && targetEl.releasePointerCapture){
          try{ targetEl.releasePointerCapture(pointerId); }catch(_frontReleaseErr){}
        }
        activeInteraction = null;
        pendingEvent = null;
        stateRef.activeDragTarget = null;
        stateRef.isDragging = false;
        setDraggingClass(false);
        if(typeof onCommit === 'function') onCommit();
      }

      function startDrag(tool, e, targetEl){
        if(e.button !== undefined && e.button !== 0) return;
        if(!getToolAssetData(tool)) return;
        migrateFrontPlacementsToNormalized();
        var rect = getRect();
        if(!rect) return;
        var placement = stateRef.placements[tool];
        var pointerNx = clamp((e.clientX - rect.left) / rect.width, 0, 1);
        var pointerNy = clamp((e.clientY - rect.top) / rect.height, 0, 1);
        activeInteraction = {
          mode: 'drag',
          tool: tool,
          targetEl: targetEl,
          pointerId: isFinite(e.pointerId) ? e.pointerId : null,
          offsetNx: placement.x - pointerNx,
          offsetNy: placement.y - pointerNy
        };
        pendingEvent = null;
        stateRef.activeOverlay = tool;
        stateRef.activeDragTarget = tool;
        stateRef.isDragging = true;
        if(targetEl && activeInteraction.pointerId !== null && targetEl.setPointerCapture){
          try{ targetEl.setPointerCapture(activeInteraction.pointerId); }catch(_frontCaptureErr){}
        }
        if(typeof onToolChange === 'function') onToolChange(tool);
        if(document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
        setDraggingClass(true);
        e.preventDefault();
        e.stopPropagation();
      }

      function startResize(handle, e){
        if(e.button !== undefined && e.button !== 0) return;
        var tool = stateRef.dragTool === 'sponsor' ? 'sponsor' : 'badge';
        if(!getToolAssetData(tool)) return;
        migrateFrontPlacementsToNormalized();
        var rect = getRect();
        if(!rect) return;
        var p = stateRef.placements[tool];
        var pointerNx = clamp((e.clientX - rect.left) / rect.width, 0, 1);
        var pointerNy = clamp((e.clientY - rect.top) / rect.height, 0, 1);
        var startDx = (pointerNx - p.x) * rect.width;
        var startDy = (pointerNy - p.y) * rect.height;
        var slider = tool === 'badge' ? slidersRef.badgeS : slidersRef.sponsorS;
        var minS = slider ? parseFloat(slider.min || '0') : 0;
        var maxS = slider ? parseFloat(slider.max || '1') : 1;
        activeInteraction = {
          mode: 'resize',
          tool: tool,
          targetEl: handle,
          pointerId: isFinite(e.pointerId) ? e.pointerId : null,
          startRadius: Math.max(8, Math.hypot(startDx, startDy)),
          startS: p.s,
          minS: isFinite(minS) ? minS : 0,
          maxS: isFinite(maxS) ? maxS : 1
        };
        pendingEvent = null;
        stateRef.activeOverlay = tool;
        stateRef.activeDragTarget = tool;
        stateRef.isDragging = true;
        if(activeInteraction.pointerId !== null && handle.setPointerCapture){
          try{ handle.setPointerCapture(activeInteraction.pointerId); }catch(_resizeCaptureErr){}
        }
        if(typeof onToolChange === 'function') onToolChange(tool);
        setDraggingClass(true);
        e.preventDefault();
        e.stopPropagation();
      }

      function bindStageDeselect(){
        if(!stageInner) return;
        stageInner.addEventListener('pointerdown', function(e){
          if(activeInteraction) return;
          var target = e.target;
          if(target && target.closest && target.closest('.kb-front-overlay-target, [data-kb-resize-handle], [data-kb-front-badge], [data-kb-front-sponsor]')) return;
          if(stateRef.activeOverlay !== null){
            stateRef.activeOverlay = null;
            syncOverlayBox();
          }
        }, { passive:true });
      }

      function bindImage(tool, el){
        if(!el) return;
        el.classList.add('kb-front-overlay-target');
        el.addEventListener('pointerdown', function(e){ startDrag(tool, e, el); }, { passive:false });
        el.addEventListener('pointermove', function(e){
          if(!activeInteraction) return;
          if(activeInteraction.mode !== 'drag' || activeInteraction.tool !== tool) return;
          queueMove(e);
          e.preventDefault();
          e.stopPropagation();
        }, { passive:false });
        el.addEventListener('pointerup', endInteraction);
        el.addEventListener('pointercancel', endInteraction);
      }

      function bindHandle(handle){
        handle.addEventListener('pointerdown', function(e){ startResize(handle, e); }, { passive:false });
        handle.addEventListener('pointermove', function(e){
          if(!activeInteraction || activeInteraction.mode !== 'resize') return;
          queueMove(e);
          e.preventDefault();
          e.stopPropagation();
        }, { passive:false });
        handle.addEventListener('pointerup', endInteraction);
        handle.addEventListener('pointercancel', endInteraction);
        handle.addEventListener('click', function(e){ e.stopPropagation(); });
      }

      function bindBox(){
        if(!box) return;
        box.classList.add('kb-front-overlay-target');
        box.addEventListener('pointerdown', function(e){
          if(e.target && e.target.closest && e.target.closest('[data-kb-resize-handle]')) return;
          var tool = stateRef.dragTool === 'sponsor' ? 'sponsor' : 'badge';
          startDrag(tool, e, box);
        }, { passive:false });
        box.addEventListener('pointermove', function(e){
          if(!activeInteraction || activeInteraction.mode !== 'drag') return;
          queueMove(e);
          e.preventDefault();
          e.stopPropagation();
        }, { passive:false });
        box.addEventListener('pointerup', endInteraction);
        box.addEventListener('pointercancel', endInteraction);
      }

      bindImage('badge', badgeEl);
      bindImage('sponsor', sponsorEl);
      for(var i=0; i<handles.length; i++) bindHandle(handles[i]);
      bindBox();
      bindStageDeselect();

      if(typeof ResizeObserver === 'function'){
        overlayResizeObserver = new ResizeObserver(function(){ syncOverlayBox(); });
        if(stageEl) overlayResizeObserver.observe(stageEl);
        else if(stageInner) overlayResizeObserver.observe(stageInner);
        if(badgeEl) overlayResizeObserver.observe(badgeEl);
        if(sponsorEl) overlayResizeObserver.observe(sponsorEl);
      }
      window.addEventListener('resize', syncOverlayBox, { passive:true });
      window.addEventListener('orientationchange', syncOverlayBox, { passive:true });

      return {
        sync: function(){ syncOverlayBox(); },
        refreshTool: function(tool){
          if(tool !== 'badge' && tool !== 'sponsor') return;
          applyToolToSvg(tool);
          syncOverlayBox();
        }
      };
    }

    function getNormalizedPoint(surfaceEl, e){
      if(!surfaceEl) return { x:0, y:0, rect:null };
      var src = (e.touches && e.touches[0]) ? e.touches[0] : e;
      var rect = surfaceEl.getBoundingClientRect();
      if(!rect || !rect.width || !rect.height) return { x:0, y:0, rect:rect || null };
      return {
        x: clamp((src.clientX - rect.left) / rect.width, 0, 1),
        y: clamp((src.clientY - rect.top) / rect.height, 0, 1),
        rect: rect
      };
    }

    function canvasPointFromPointer(surfaceEl, e, size){
      var canvasSize = size || CANVAS;
      var normalized = getNormalizedPoint(surfaceEl, e);
      return {
        x: normalized.x * canvasSize,
        y: normalized.y * canvasSize
      };
    }

    function pointHitsRect(point, rect){
      if(!point || !rect) return false;
      if(!isFinite(rect.w) || !isFinite(rect.h) || rect.w <= 0 || rect.h <= 0) return false;
      return point.x >= rect.x && point.x <= (rect.x + rect.w) && point.y >= rect.y && point.y <= (rect.y + rect.h);
    }

    var frontOverlayController = null;

    function bindStageResizeObserver(){
      if(typeof ResizeObserver !== 'function') return;

      var observed = [];
      if(appShell) observed.push(appShell);
      else if(root) observed.push(root);
      var lastRectByEl = new WeakMap();

      function queueResizeRender(){
        if(stageResizeDebounceTimer) return;
        stageResizeDebounceTimer = setTimeout(function(){
          stageResizeDebounceTimer = 0;
          if(renderInProgress || loopTripped || state.isDragging) return;
          if(!stageResizePendingChange) return;
          stageResizePendingChange = false;
          Render.request('viewport/resize');
        }, 100);
      }

      function markResizeChange(nextSize){
        if(!hasSignificantResize(viewportLastSize, nextSize)) return;
        viewportLastSize = { w: nextSize.w || 0, h: nextSize.h || 0 };
        stageResizePendingChange = true;
        queueResizeRender();
      }

      function onVisualViewportResizeInternal(){
        if(!window.visualViewport) return;
        if(viewportResizeDebounceTimer) clearTimeout(viewportResizeDebounceTimer);
        viewportResizeDebounceTimer = setTimeout(function(){
          viewportResizeDebounceTimer = 0;
          if(renderInProgress || loopTripped || state.isDragging) return;
          markResizeChange({
            w: window.visualViewport.width || 0,
            h: window.visualViewport.height || 0
          });
        }, 100);
      }
      onVisualViewportResize = onVisualViewportResizeInternal;

      stageResizeObserver = new ResizeObserver(function(entries){
        if(renderInProgress || loopTripped || state.isDragging) return;

        for(var i=0; i<entries.length; i++){
          var entry = entries[i];
          var box = entry.contentRect;
          if(!box) continue;

          var prev = lastRectByEl.get(entry.target);
          var current = { w: box.width || 0, h: box.height || 0 };
          lastRectByEl.set(entry.target, current);

          if(!prev) continue;
          if(!hasSignificantResize(prev, current)) continue;
          markResizeChange(current);
        }
      });

      stageResizeObservedEls = [];
      for(var j=0; j<observed.length; j++){
        var el = observed[j];
        if(!el) continue;
        stageResizeObservedEls.push(el);
        stageResizeObserver.observe(el);
      }

      if(window.visualViewport){
        viewportLastSize = {
          w: window.visualViewport.width || 0,
          h: window.visualViewport.height || 0
        };
        try{ window.visualViewport.addEventListener('resize', onVisualViewportResize, { passive:true }); }catch(_vvResizeOnErr){}
      }
    }

    function getHrefAttr(imageEl){
      if(!imageEl) return '';
      return imageEl.getAttribute('href') || imageEl.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '';
    }

    function setHrefAttr(imageEl, value){
      if(!imageEl) return;
      imageEl.setAttribute('href', value || '');
      imageEl.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', value || '');
    }

    async function toDataUrlFromUrl(url){
      if(!url || /^data:/i.test(url)) return url || '';
      var res = await fetch(url, { mode:'cors' });
      if(!res.ok) throw new Error('Image fetch failed (' + res.status + ') for ' + url);
      var blob = await res.blob();
      return await new Promise(function(resolve, reject){
        var reader = new FileReader();
        reader.onload = function(){ resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    async function inlineSvgImages(svgEl){
      if(!svgEl) return;
      var imageEls = svgEl.querySelectorAll('image');
      for(var i=0; i<imageEls.length; i++){
        var imageEl = imageEls[i];
        var href = getHrefAttr(imageEl);
        if(!href || /^data:/i.test(href)) continue;
        // eslint-disable-next-line no-await-in-loop
        var inlinedHref = await toDataUrlFromUrl(href);
        setHrefAttr(imageEl, inlinedHref);
      }
    }

    async function paintSvgToPreviewCanvas(svgEl, canvasEl, size){
      if(!svgEl || !canvasEl) throw new Error('Preview canvas is unavailable.');
      var outputSize = size || CANVAS;

      var clone = svgEl.cloneNode(true);
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      var cloneImages = clone.querySelectorAll('image');
      for(var ci=0; ci<cloneImages.length; ci++){
        cloneImages[ci].setAttribute('preserveAspectRatio', 'xMidYMid meet');
      }
      await inlineSvgImages(clone);

      var xml = new XMLSerializer().serializeToString(clone);
      if(!xml.match(/^<svg[^>]+xmlns=/)) xml = xml.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');

      var blob = new Blob([xml], { type: 'image/svg+xml;charset=utf-8' });
      var url = URL.createObjectURL(blob);

      var img = new Image();
      img.crossOrigin = 'anonymous';
      await loadImageElementWithTimeout(img, url, IMAGE_LOAD_TIMEOUT_MS, 'SVG export rasterizer');
      URL.revokeObjectURL(url);

      canvasEl.width = outputSize;
      canvasEl.height = outputSize;
      var g = canvasEl.getContext('2d');
      g.clearRect(0,0,outputSize,outputSize);
      g.imageSmoothingEnabled = true;
      g.imageSmoothingQuality = 'high';
      g.drawImage(img, 0,0,outputSize,outputSize);

      return canvasEl;
    }

    function getSidePreviewCanvas(which){
      return which === 'back' ? backCanvasEl : frontCanvasEl;
    }

    function setStageZoom(side, zoomed){
      var stage = stageNodes[side];
      if(!stage) return;
      stage.setAttribute('data-kb-stage-zoomed', zoomed ? 'true' : 'false');
      var toggle = root.querySelector('[data-kb-zoom-toggle="' + side + '"]');
      if(toggle) toggle.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    }

    function toggleStageZoom(side){
      var stage = stageNodes[side];
      if(!stage) return;
      var isZoomed = stage.getAttribute('data-kb-stage-zoomed') === 'true';
      setStageZoom(side, !isZoomed);
      syncResizeOverlay();
    }

    function moveStageToLightbox(side){
      var stage = stageNodes[side];
      if(!stage || !lightboxStageHost) return;
      if(!stagePlaceholders[side]){
        stagePlaceholders[side] = document.createComment('kb-stage-home-' + side);
      }
      var home = stageHomes[side] || stage.parentElement;
      if(home && stage.parentElement === home){
        home.insertBefore(stagePlaceholders[side], stage);
      }
      lightboxStageHost.appendChild(stage);
      setStageZoom(side, false);
    }

    function restoreStageFromLightbox(side){
      var stage = stageNodes[side];
      var marker = stagePlaceholders[side];
      if(!stage || !marker || !marker.parentNode) return;
      marker.parentNode.insertBefore(stage, marker);
      marker.parentNode.removeChild(marker);
      stagePlaceholders[side] = null;
      setStageZoom(side, false);
    }

    async function sidePreviewDataUrl(which){
      var targetSvg = which === 'back' ? svgBack : svgFront;
      var targetCanvasEl = getSidePreviewCanvas(which);
      await paintSvgToPreviewCanvas(targetSvg, targetCanvasEl);
      var pngDataUrl = targetCanvasEl.toDataURL('image/png');
      var validPngDataUrl = /^data:image\//i.test(String(pngDataUrl || '').trim());
      try{
        if(which === 'back' && validPngDataUrl){
          localStorage.setItem('mshRenderBackPng', pngDataUrl);
          localStorage.setItem('mshBrochureShirtBackPng', pngDataUrl);
        }else if(which !== 'back' && validPngDataUrl){
          localStorage.setItem('mshRenderFrontPng', pngDataUrl);
          localStorage.setItem('mshBrochureShirtFrontPng', pngDataUrl);
        }
      }catch(_renderStoreErr){}
      return pngDataUrl;
    }

    function buildActiveBrochurePayload(input){
      var payload = input || {};
      var now = Date.now();
      var captureId = String(payload.captureId || (now + '-' + Math.random().toString(16).slice(2))).trim();
      var frontDataUrl = String(payload.frontDataUrl || '').trim();
      var backDataUrl = String(payload.backDataUrl || '').trim();
      return {
        version: 1,
        key: ACTIVE_BROCHURE_PAYLOAD_KEY,
        source: String(payload.source || 'builder-render-sync'),
        generatedAt: Number(payload.generatedAt || now),
        savedAt: now,
        captureId: captureId,
        shirtHandle: String(productHandle || '').trim(),
        colourway: String(state.selectedColour || '').trim(),
        band: String(getContinueBand() || '').trim(),
        number: sanitizeNumber(elNumber && elNumber.value),
        fill: normalizeHexColor(state.fillOverride) || '',
        badgeIncluded: !!state.badgeData,
        sponsorIncluded: !!state.sponsorData,
        badgeData: String(state.badgeData || ''),
        sponsorData: String(state.sponsorData || ''),
        shirtConfigVersion: Number(shirtConfigVersion || 0),
        images: {
          shirtFront: frontDataUrl,
          shirtBack: backDataUrl
        }
      };
    }

    function persistBrochurePayload(input){
      var payload = buildActiveBrochurePayload(input);
      try{
        localStorage.setItem(ACTIVE_BROCHURE_PAYLOAD_KEY, JSON.stringify(payload));
      }catch(_brochurePayloadStoreErr){}
      console.log('[MSH Builder Debug] Brochure payload saved', {
        key: ACTIVE_BROCHURE_PAYLOAD_KEY,
        source: payload.source,
        captureId: payload.captureId,
        shirtHandle: payload.shirtHandle,
        colourway: payload.colourway,
        version: payload.shirtConfigVersion,
        timestamp: payload.savedAt,
        frontLength: String(payload.images && payload.images.shirtFront || '').length,
        backLength: String(payload.images && payload.images.shirtBack || '').length,
        sameCapture: !!(payload.captureId && payload.images && payload.images.shirtFront && payload.images.shirtBack)
      });
      return payload;
    }

    function queueBrochurePreviewStorageSync(){
      if(brochurePreviewSyncTimer) clearTimeout(brochurePreviewSyncTimer);
      brochurePreviewSyncTimer = setTimeout(function(){
        brochurePreviewSyncTimer = 0;
        syncBrochurePreviewStorage();
      }, 120);
    }

    async function syncBrochurePreviewStorage(){
      if(brochurePreviewSyncInFlight){
        brochurePreviewSyncQueued = true;
        return;
      }
      if(!frontState.img || !backState.img) return;

      brochurePreviewSyncInFlight = true;
      try{
        var captureId = String(Date.now()) + '-' + Math.random().toString(16).slice(2);
        var snapshots = await Promise.all([
          sidePreviewDataUrl('front'),
          sidePreviewDataUrl('back')
        ]);
        console.log('[MSH Builder Debug] Shirt snapshots generated', {
          context: 'render-sync',
          captureId: captureId,
          shirtHandle: String(productHandle || ''),
          colourway: String(state.selectedColour || ''),
          sessionVersion: shirtConfigVersion,
          frontLength: String(snapshots[0] || '').length,
          backLength: String(snapshots[1] || '').length,
          timestamp: Date.now()
        });
        persistBrochurePayload({
          captureId: captureId,
          source: 'builder-render-sync',
          frontDataUrl: snapshots[0],
          backDataUrl: snapshots[1],
          generatedAt: Date.now()
        });
      }catch(syncErr){
        kbLog('brochure-preview-sync-failed', syncErr);
      }finally{
        brochurePreviewSyncInFlight = false;
        if(brochurePreviewSyncQueued){
          brochurePreviewSyncQueued = false;
          queueBrochurePreviewStorageSync();
        }
      }
    }

    async function exportSideToPng(which, filename){
      try{
        var pngUrl = which === 'back'
          ? await exportBackDataUrl()
          : await exportFrontDataUrl();

        var a = document.createElement('a');
        a.download = filename;
        a.href = pngUrl;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }catch(e){
        showErr('Download failed:\n' + (e && e.message ? e.message : e));
      }
    }

    async function exportFrontDataUrl(){
      var dataUrl = await getCompositeDataUrl('front');
      if(/^data:image\//i.test(String(dataUrl || '').trim())){
        try{
          localStorage.setItem('mshRenderFrontPng', dataUrl);
          localStorage.setItem('mshBrochureShirtFrontPng', dataUrl);
        }catch(_frontRenderStoreErr){}
      }
      return dataUrl;
    }

    async function exportBackDataUrl(){
      var dataUrl = await getCompositeDataUrl('back');
      if(/^data:image\//i.test(String(dataUrl || '').trim())){
        try{
          localStorage.setItem('mshRenderBackPng', dataUrl);
          localStorage.setItem('mshBrochureShirtBackPng', dataUrl);
        }catch(_backRenderStoreErr){}
      }
      return dataUrl;
    }

    function closeLightbox(){
      if(!lightbox) return;
      if(lightboxSide) restoreStageFromLightbox(lightboxSide);
      lightbox.hidden = true;
      lightboxSide = '';
      lightboxMode = '';
      if(scrollDebounceTimer){ clearTimeout(scrollDebounceTimer); scrollDebounceTimer = 0; }
      if(uiRenderRaf){ cancelAnimationFrame(uiRenderRaf); uiRenderRaf = 0; }
      if(sectionRoot) sectionRoot.classList.remove('kb-dragging');
      syncAppModeScrollLock();
    }

    async function openLightbox(which){
      if(!lightbox || !lightboxStageHost) return;
      try{
        if(lightboxSide && lightboxSide !== which) restoreStageFromLightbox(lightboxSide);
        lightboxSide = which;
        lightboxMode = which;
        moveStageToLightbox(which);
        lightbox.hidden = false;
        syncAppModeScrollLock();
        syncResizeOverlay();
      }catch(e){
        showErr('Fullscreen preview failed:\n' + (e && e.message ? e.message : e));
      }
    }

    window.validateKerning = validateKerning;
    window.validateKerning00to99 = validateKerning;

    function ensurePreviewMounted(){
      var appPreview = root.querySelector('.kb-app__preview .msh-kb__previews') || root.querySelector('.msh-kb__previews');
      if(!appPreview) return false;
      var frontPreview = root.querySelector('[data-kb-preview="front"]');
      var backPreview = root.querySelector('[data-kb-preview="back"]');
      if(frontPreview && frontPreview.parentElement !== appPreview) appPreview.appendChild(frontPreview);
      if(backPreview && backPreview.parentElement !== appPreview) appPreview.appendChild(backPreview);
      svgFront = root.querySelector('[data-kb-preview="front"] [data-kb-svg="front"]');
      svgBack  = root.querySelector('[data-kb-preview="back"] [data-kb-svg="back"]');
      frontCanvasEl = root.querySelector('[data-kb-preview="front"] [data-kb-canvas="front"]');
      backCanvasEl = root.querySelector('[data-kb-preview="back"] [data-kb-canvas="back"]');
      baseFront = root.querySelector('[data-kb-base-front]');
      baseBack  = root.querySelector('[data-kb-base-back]');
      return !!(svgFront && svgBack && frontCanvasEl && backCanvasEl && baseFront && baseBack);
    }

    function populateColourways(){
      if(!state.colours || !state.colours.length) return;
      elColour.innerHTML = '';
      if(colourSwatchesHost) colourSwatchesHost.innerHTML = '';
      state.colourways.forEach(function(colourway){
        var c = colourway.name;
        var opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        elColour.appendChild(opt);

        if(colourSwatchesHost){
          var urls = { front: colourway.frontSrc || '', back: colourway.backSrc || '' };
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'msh-kb__swatch kb-colour-tile kb-swatch';
          card.setAttribute('data-kb-colourway-tile', '');
          card.setAttribute('data-kb-swatch', c);
          card.setAttribute('data-active', 'false');
          card.setAttribute('aria-selected', 'false');

          var thumb = document.createElement('span');
          thumb.className = 'msh-kb__swatchThumbs kb-colour-thumb kb-swatch__thumb';
          thumb.setAttribute('data-kb-colourway-thumbs', '');

          function makeSideThumb(side, src){
            var sideWrap = document.createElement('span');
            sideWrap.className = 'kb-sw-thumb kb-sw-thumb--' + side;
            sideWrap.setAttribute('data-kb-side-thumb', side);

            var sideImg = document.createElement('img');
            sideImg.className = 'kb-swatch__img';
            sideImg.src = src || '';
            sideImg.alt = c + ' ' + side;
            sideImg.loading = 'lazy';

            sideImg.onerror = function(){
              sideWrap.classList.add('is-broken');
              sideImg.hidden = true;
            };

            if(!src){
              sideWrap.classList.add('is-broken');
              sideImg.hidden = true;
            }

            sideWrap.appendChild(sideImg);
            thumb.appendChild(sideWrap);
          }

          var frontSrc = urls.front || '';
          var backSrc = urls.back || urls.front || '';
          makeSideThumb('front', frontSrc);
          makeSideThumb('back', backSrc);

          var name = document.createElement('span');
          name.className = 'msh-kb__swatchName kb-colour-label kb-swatch__label';
          name.setAttribute('data-kb-colourway-label', '');
          name.textContent = c;

          card.appendChild(thumb);
          card.appendChild(name);
          card.addEventListener('click', function(){
            setInputValueSilently(elColour, c);
            setColour(c);
          });
          colourSwatchesHost.appendChild(card);
        }
      });
      colourwaysPopulated = true;
    }

    function setColourwayStatus(message, isError){
      if(!elColourStatus) return;
      var msg = String(message || '').trim();
      elColourStatus.hidden = !msg;
      elColourStatus.textContent = msg;
      elColourStatus.style.color = isError ? '#9f1239' : '';
    }

    function setColourwayDropdownState(stateKey){
      if(!elColour) return;
      if(stateKey === 'loading'){
        elColour.innerHTML = '<option value="">Loading colourways…</option>';
        elColour.disabled = true;
        setColourwayStatus('', false);
        return;
      }

      if(stateKey === 'error'){
        elColour.innerHTML = '<option value="">Failed to load colourways</option>';
        elColour.value = '';
        elColour.disabled = true;
        setColourwayStatus('Failed to load colourways. Please refresh or try another model.', true);
        return;
      }

      if(stateKey === 'empty'){
        elColour.innerHTML = '<option value="">No colourways found for this model</option>';
        elColour.value = '';
        elColour.disabled = true;
        setColourwayStatus('No colourways found for this model.', false);
        return;
      }

      elColour.disabled = false;
      setColourwayStatus('', false);
    }

    function resetColourwaysUI(){
      colourwaysPopulated = false;
      if(elColour) elColour.innerHTML = '';
      if(colourSwatchesHost) colourSwatchesHost.innerHTML = '';
      setColourwayStatus('', false);
    }

    function applyDerivedColourways(product){
      var derivedState = deriveColourwayState(product);
      state.modelKey = derivedState.modelKey || '';
      state.colourways = derivedState.colourways || [];
      state.colours = state.colourways.map(function(colourway){ return colourway.name; });
      return state.colourways;
    }

    async function reloadForHandleChange(nextHandle){
      var normalizedHandle = String(nextHandle || '').trim();
      if(!builderReady || !normalizedHandle || normalizedHandle === productHandle) return;

      setColourwayDropdownState('loading');
      try{
        var nextProduct = await loadProductByHandle(normalizedHandle);
        productHandle = normalizedHandle;
        resolvedHandleForDebug = normalizedHandle;
        state.product = nextProduct;
        applyBackLayout(productHandle);
        updateBuilderHeadingFromProduct(state.product);

        setLS('msh_last_model', normalizedHandle);
        setLS('mshModelHandle', normalizedHandle);

        resetColourwaysUI();
        applyDerivedColourways(state.product);
        if(!state.colourways.length){
          setColourwayDropdownState('empty');
          showErr('No colourways found for this model.');
          return;
        }

        populateColourways();
        setColourwayDropdownState('ready');
        setInputValueSilently(elColour, state.colours[0]);
        await setColour(state.colours[0]);
      }catch(reloadErr){
        setColourwayDropdownState('error');
        showProductLoadError(normalizedHandle, (reloadErr && reloadErr.message ? reloadErr.message : reloadErr));
      }
    }

    async function init(){
      // URL params win on entry, then localStorage becomes canonical state.
      syncUrlSelectionToStorage();
      runSelectionPreflight();
      syncKBMobileClass();
      renderDebugStrip();

      var selectedMode = getSelectedMode();
      var selectedAudience = getSelectedAudience();
      setColourwayDropdownState('loading');
      var selectedHandle = String(window.__MSH_SELECTED_HANDLE || '').trim();
      resolvedHandleForDebug = selectedHandle;
      renderDebugStrip();
      var resolvedSelection = null;
      var preflightReloadAttempted = false;
      try{
        resolvedSelection = await resolveSelectedBuilderProduct();
        if(selectedHandle && resolvedSelection && resolvedSelection.handle !== selectedHandle && !preflightReloadAttempted){
          preflightReloadAttempted = true;
          resolvedSelection.handle = selectedHandle;
          resolvedSelection.product = await loadProductByHandle(selectedHandle);
        }
      }catch(e){
        setColourwayDropdownState('error');
        showProductLoadError(selectedHandle || getSelectedHandle() || getSelectedModelName() || 'selected model', (e && e.message ? e.message : e));
        return;
      }

      if(!resolvedSelection || !resolvedSelection.handle){
        setColourwayDropdownState('error');
        showSelectionMissingError();
        return;
      }

      productHandle = resolvedSelection.handle || fallbackProductHandle;
      resolvedHandleForDebug = productHandle;
      state.product = resolvedSelection.product || null;
      initShirtConfigVersionState();
      applyBackLayout(productHandle);
      var selectedModelName = stripBuilderSuffix(resolvedSelection.modelName || '');
      var previousHandle = String(getLS('mshModelHandle') || '').trim();

      if(!selectedModelName && state.product){
        selectedModelName = stripBuilderSuffix(state.product.title || '');
      }

      if(previousHandle && previousHandle !== productHandle){
        try{
          localStorage.removeItem('mshColourway');
          localStorage.removeItem('mshRenderFront');
          localStorage.removeItem('mshRenderBack');
        }catch(_clearRenderErr){}
      }

      setLS('msh_last_model', productHandle);
      setLS('msh_mode', selectedMode);
      setLS('msh_audience', selectedAudience);
      setLS('mshModelHandle', productHandle);
      if(selectedModelName) setLS('mshModelName', selectedModelName);
      setLS('mshKitType', selectedMode === 'goalkeeper' ? 'gk' : 'match');
      setLS('mshAgeBand', selectedAudience);

      if(!state.product){
        try{
          state.product = await loadProductByHandle(productHandle);
        }catch(e){
          setColourwayDropdownState('error');
          showProductLoadError(productHandle, (e && e.message ? e.message : e));
          return;
        }
      }
      if(!state.product){
        setColourwayDropdownState('error');
        showProductLoadError(productHandle, 'Could not load selected product.');
        return;
      }
      updateBuilderHeadingFromProduct(state.product);
      window.MSH_SELECTED = {
        handle: productHandle,
        mode: selectedMode,
        aud: selectedAudience,
        audience: selectedAudience,
        productJson: state.product
      };

      resetColourwaysUI();
      applyDerivedColourways(state.product);
      if(!state.colourways.length){
        setColourwayDropdownState('empty');
        showErr('No colourways found for this model.');
        return;
      }

      loadInsideBadgePresets();
      setupMobileBodyLock();
      syncAppModeScrollLock();
      syncMobileBodyLock();
      window.addEventListener('resize', function(){ syncKBMobileClass(); syncAppModeScrollLock(); syncMobileBodyLock(); queueMobileOverlaySync(); }, { passive:true });
      window.addEventListener('orientationchange', function(){ syncAppModeScrollLock(); syncMobileBodyLock(); queueMobileOverlaySync(); }, { passive:true });
      window.addEventListener('pagehide', function(){
        if(mobileLockObserver){ mobileLockObserver.disconnect(); mobileLockObserver = null; }
        document.body.classList.remove('kb-mobile-lock');
        if(sectionRoot) sectionRoot.classList.remove('kb-dragging');
      });
      syncInsideTunePanel();
      syncSheetState(!isMobileViewport());
      buildColorRow(fillRow, 'fill');
      buildColorRow(strokeRow, 'stroke');
      buildColorRow(napeTextRow, 'napeText');
      buildColorRow(napeSquaresRow, 'napeSquares');

      if(sheetToggleBtn){
        sheetToggleBtn.addEventListener('click', function(){
          var open = root.getAttribute('data-kb-sheet-open') !== 'true';
          syncSheetState(open);
        });
        var sheetStartY = null;
        sheetToggleBtn.addEventListener('pointerdown', function(e){ sheetStartY = e.clientY; }, { passive:true });
        sheetToggleBtn.addEventListener('pointerup', function(e){
          if(sheetStartY === null) return;
          var dy = (e.clientY || 0) - sheetStartY;
          if(Math.abs(dy) > 24) syncSheetState(dy < 0);
          sheetStartY = null;
        }, { passive:true });
        sheetToggleBtn.addEventListener('pointercancel', function(){ sheetStartY = null; }, { passive:true });
      }

      for(var i=0;i<toolChips.length;i++){
        (function(chip){
          chip.addEventListener('click', function(){
            setDragTool(chip.getAttribute('data-kb-tool'));
          });
        })(toolChips[i]);
      }

      setActiveTab('kit');

      if(reloadDigitsBtn){
        reloadDigitsBtn.addEventListener('click', function(){
          if(reloadDigitsBtn.getAttribute('data-loading') === 'true') return;
          var originalLabel = reloadDigitsBtn.textContent;
          setReloadInlineMessage('');
          reloadDigitsBtn.setAttribute('data-loading', 'true');
          reloadDigitsBtn.textContent = 'Reloading…';

          digitSymbolsReady = false;
          ensureDigitsReady({ force:true }).then(function(){
            Render.request('digits reloaded');
          }).catch(function(){
            setReloadInlineMessage('Could not reload numbers. Please try again.');
          }).finally(function(){
            reloadDigitsBtn.removeAttribute('data-loading');
            reloadDigitsBtn.textContent = originalLabel || 'Reload numbers';
          });
        });
      }
      setMobileSide('front');

      if(mobileColourOpenBtn){
        mobileColourOpenBtn.addEventListener('click', function(){
          const isMobile = window.matchMedia('(max-width: 989px)').matches;
          if(!isMobile || !elColour) return;
          if(typeof elColour.showPicker === 'function'){
            try{ elColour.showPicker(); return; }catch(_pickerErr){}
          }
          elColour.focus({ preventScroll:true });
          elColour.click();
        });
      }

      window.addEventListener('scroll', function(){
        scrollSettled = false;
        if(scrollDebounceTimer) clearTimeout(scrollDebounceTimer);
        scrollDebounceTimer = setTimeout(function(){
          scrollDebounceTimer = 0;
          scrollSettled = true;
        }, 120);
      }, { passive:true });

      var tabBar = root.querySelector('[data-kb-tabbar]');
      if(tabBar){
        tabBar.addEventListener('click', function(e){
          var tabBtn = e.target && e.target.closest ? e.target.closest('[data-kb-tab], [data-tab], [data-kb-send-link]') : null;
          if(!tabBtn || !tabBar.contains(tabBtn)) return;
          var tabLink = tabBtn.getAttribute('data-kb-send-link');
          if(tabLink){
            window.location.href = tabLink;
            return;
          }
          setActiveTab(tabBtn.getAttribute('data-tab') || tabBtn.getAttribute('data-kb-tab'));
        });
      }

      for(var ms=0; ms<mobileSideBtns.length; ms++){
        (function(sideBtn){
          sideBtn.addEventListener('click', function(){
            setMobileSide(sideBtn.getAttribute('data-kb-side'));
          });
        })(mobileSideBtns[ms]);
      }

      for(var pb=0; pb<presetBtns.length; pb++){
        (function(btn){
          btn.addEventListener('click', function(){
            var target = btn.getAttribute('data-kb-preset');
            var raw = parseFloat(btn.getAttribute('data-kb-preset-value'));
            if(!isFinite(raw)) return;
            if(target === 'badge-s') state.placements.badge.s = raw;
            if(target === 'sponsor-s') state.placements.sponsor.s = raw;
            syncSliders();
            saveState();
            render();
          });
        })(presetBtns[pb]);
      }

      // Bind ALL sliders (same method)
      bindRange(sliders.badgeS, outs.badgeS, function(){ return state.placements.badge.s; }, function(v){ state.placements.badge.s = v; });
      bindRange(sliders.badgeX, outs.badgeX, function(){ return state.placements.badge.x; }, function(v){ state.placements.badge.x = v; });
      bindRange(sliders.badgeY, outs.badgeY, function(){ return state.placements.badge.y; }, function(v){ state.placements.badge.y = v; });

      bindRange(sliders.sponsorS, outs.sponsorS, function(){ return state.placements.sponsor.s; }, function(v){ state.placements.sponsor.s = v; });
      bindRange(sliders.sponsorX, outs.sponsorX, function(){ return state.placements.sponsor.x; }, function(v){ state.placements.sponsor.x = v; });
      bindRange(sliders.sponsorY, outs.sponsorY, function(){ return state.placements.sponsor.y; }, function(v){ state.placements.sponsor.y = v; });


      frontOverlayController = FrontOverlayController({
        badgeEl: frontBadge,
        sponsorEl: frontSponsor,
        overlay: resizeOverlay,
        box: resizeBox,
        handles: resizeHandles,
        stage: stageNodes.front,
        stageInner: stageInnerNodes.front,
        state: state,
        sliders: sliders,
        outs: outs,
        getIsEditMode: isEditModeActive,
        onCommit: function(){ saveState(); },
        onToolChange: function(tool){ setDragTool(tool, { skipPersist:true }); }
      });

      if(layoutModeActive && svgBack){
        var layoutDrag = null;
        svgBack.addEventListener('pointerdown', function(e){
          var target = resolveBackLayoutTargetFromPointer(e);
          if(target !== 'nape' && target !== 'number') return;
          var p = canvasPointFromPointer(svgBack, e, CANVAS);
          var node = state.backLayout[target];
          layoutDrag = {
            pointerId: isFinite(e.pointerId) ? e.pointerId : null,
            target: target,
            startPointer: p,
            startNode: { x:node.x, y:node.y }
          };
          state.backLayoutActiveTarget = target;
          syncLayoutModeControls();
          if(svgBack.setPointerCapture && layoutDrag.pointerId !== null){
            try{ svgBack.setPointerCapture(layoutDrag.pointerId); }catch(_layoutCaptureErr){}
          }
          e.preventDefault();
          e.stopPropagation();
        });
        svgBack.addEventListener('pointermove', function(e){
          if(!layoutDrag) return;
          if(layoutDrag.pointerId !== null && isFinite(e.pointerId) && e.pointerId !== layoutDrag.pointerId) return;
          var p = canvasPointFromPointer(svgBack, e, CANVAS);
          var startX = layoutDrag.startNode.x * CANVAS;
          var startY = layoutDrag.startNode.y * CANVAS;
          var nextX = startX + (p.x - layoutDrag.startPointer.x);
          var nextY = startY + (p.y - layoutDrag.startPointer.y);
          updateBackLayoutTargetPosition(layoutDrag.target, nextX, nextY);
          e.preventDefault();
          e.stopPropagation();
        });
        var onLayoutPointerEnd = function(e){
          if(!layoutDrag) return;
          if(layoutDrag.pointerId !== null && e && isFinite(e.pointerId) && e.pointerId !== layoutDrag.pointerId) return;
          layoutDrag = null;
        };
        svgBack.addEventListener('pointerup', onLayoutPointerEnd);
        svgBack.addEventListener('pointercancel', onLayoutPointerEnd);
      }

      if(layoutModeActive){
        if(layoutTools) layoutTools.hidden = false;
        for(var lb=0; lb<layoutTargetBtns.length; lb++){
          (function(btn){
            btn.addEventListener('click', function(){
              var target = btn.getAttribute('data-kb-layout-target');
              if(target !== 'nape' && target !== 'number') return;
              state.backLayoutActiveTarget = target;
              syncLayoutModeControls();
            });
          })(layoutTargetBtns[lb]);
        }
        if(layoutScaleInput){
          layoutScaleInput.addEventListener('input', function(){
            var nextScale = parseFloat(layoutScaleInput.value);
            updateBackLayoutTargetScale(state.backLayoutActiveTarget, isFinite(nextScale) ? nextScale : 1);
          });
        }
        if(layoutScaleDownBtn){
          layoutScaleDownBtn.addEventListener('click', function(){
            var current = state.backLayout[state.backLayoutActiveTarget].s;
            updateBackLayoutTargetScale(state.backLayoutActiveTarget, current - LAYOUT_SCALE_STEP);
          });
        }
        if(layoutScaleUpBtn){
          layoutScaleUpBtn.addEventListener('click', function(){
            var current = state.backLayout[state.backLayoutActiveTarget].s;
            updateBackLayoutTargetScale(state.backLayoutActiveTarget, current + LAYOUT_SCALE_STEP);
          });
        }
        if(layoutResetBtn){
          layoutResetBtn.addEventListener('click', function(){
            var defaults = baseBackLayout();
            var target = state.backLayoutActiveTarget;
            state.backLayout[target] = sanitizeLayoutNode(defaults[target], defaults[target]);
            applyBackLayoutTransforms();
            syncLayoutModeControls();
          });
        }
        if(layoutSaveBtn){
          layoutSaveBtn.addEventListener('click', async function(){
            var exportJson = saveBackLayoutForCurrentHandle();
            if(!exportJson) return;
            var copied = false;
            try{
              await copyTextToClipboard(exportJson);
              copied = true;
            }catch(_layoutCopyErr){}
            if(copied){
              setLayoutSaveFeedback('Saved locally for this handle. JSON copied — paste into Back layout profiles JSON setting.', 'ok');
            }else{
              setLayoutSaveFeedback('Saved locally for this handle. Copy JSON below into Back layout profiles JSON setting.', 'warn');
            }
          });
        }
        if(layoutCopyBtn){
          layoutCopyBtn.addEventListener('click', async function(){
            if(!layoutJsonOutput) return;
            try{
              await copyTextToClipboard(layoutJsonOutput.value || '');
              setLayoutSaveFeedback('Layout JSON copied.', 'ok');
            }catch(_copyErr){
              layoutJsonOutput.focus();
              layoutJsonOutput.select();
              setLayoutSaveFeedback('Clipboard blocked. Select/copy JSON manually.', 'warn');
            }
          });
        }
      }

      bindStageResizeObserver();


      async function commitNumber(reason){
        await ensureDigitsReady();
        Render.request(reason || 'number-commit');
      }

      numberCommitDebounced = debounce(function(){
        commitNumber('number-input-debounce').catch(function(err){
          console.warn('[MSH KB] number debounce commit failed', err);
        });
      }, 250);

      elNumber.addEventListener('input', function(){
        elNumber.value = sanitizeNumber(elNumber.value);
        syncInsideTunePanel();
        saveState();
        if(numberCommitDebounced) numberCommitDebounced();
      }, { passive:true });

      elNumber.addEventListener('blur', function(){
        commitNumber('number-input-blur').catch(function(err){
          console.warn('[MSH KB] number blur commit failed', err);
        });
      });

      elNumber.addEventListener('keydown', function(evt){
        if(evt.key !== 'Enter') return;
        evt.preventDefault();
        commitNumber('number-input-enter').catch(function(err){
          console.warn('[MSH KB] number enter commit failed', err);
        });
      });


      if(KB_TUNE && insideTunePanel){
        ['0','1'].forEach(function(digitIndex){
          var field = insideTuneFields[digitIndex];
          if(!field) return;

          if(field.ax){
            field.ax.addEventListener('input', function(){
              updateInsidePresetFromField(parseInt(digitIndex, 10), 'ax', parseFloat(field.ax.value));
            });
          }
          if(field.ay){
            field.ay.addEventListener('input', function(){
              updateInsidePresetFromField(parseInt(digitIndex, 10), 'ay', parseFloat(field.ay.value));
            });
          }
          if(field.s){
            field.s.addEventListener('input', function(){
              updateInsidePresetFromField(parseInt(digitIndex, 10), 's', parseFloat(field.s.value));
            });
          }
        });

        if(insideTuneResetBtn){
          insideTuneResetBtn.addEventListener('click', function(){
            var numberStr = getCurrentNumberStr();
            delete insideBadgePresets[numberStr];
            saveInsideBadgePresets();
            syncInsideTunePanel();
            Render.request('reset inside badge preset');
          });
        }

        if(insideTuneCopyBtn){
          insideTuneCopyBtn.addEventListener('click', async function(){
            try{
              await copyInsidePresetsToClipboard();
            }catch(copyErr){
              showErr('Copy presets JSON failed:\n' + (copyErr && copyErr.message ? copyErr.message : copyErr));
            }
          });
        }

        if(insideTuneClearBtn){
          insideTuneClearBtn.addEventListener('click', function(){
            insideBadgePresets = {};
            try{ localStorage.removeItem(INSIDE_BADGE_PRESET_STORAGE_KEY); }catch(_insidePresetClearErr){}
            syncInsideTunePanel();
            Render.request('clear inside badge presets');
          });
        }
      }

      elFill.addEventListener('input', function(){
        if(suppressUIEvents) return;
        state.fillOverride = normalizeManualColor(elFill.value) || '';
        syncNumberColorInputs();
        syncNapeOverrideInputs();
        saveState();
        render();
      }, { passive:true });
      elStroke.addEventListener('input', function(){
        if(suppressUIEvents) return;
        state.strokeOverride = normalizeManualColor(elStroke.value) || '';
        syncNumberColorInputs();
        syncNapeOverrideInputs();
        saveState();
        render();
      }, { passive:true });


      if(elFillHex){
        elFillHex.addEventListener('change', function(){
          var value = normalizeHexColor(elFillHex.value);
          if(!value) return;
          setInputValueSilently(elFill, value);
          elFill.dispatchEvent(new Event('input', { bubbles:true }));
        });
      }
      if(elStrokeHex){
        elStrokeHex.addEventListener('change', function(){
          var value = normalizeHexColor(elStrokeHex.value);
          if(!value) return;
          setInputValueSilently(elStroke, value);
          elStroke.dispatchEvent(new Event('input', { bubbles:true }));
        });
      }

      if(elNapeTextOverrideColor && elNapeTextOverrideHex){
        elNapeTextOverrideColor.addEventListener('input', function(){
          var value = normalizeHexColor(elNapeTextOverrideColor.value);
          if(!value) return;
          state.napeTextOverride = value;
          syncNumberColorInputs();
          setInputValueSilently(elNapeTextOverrideHex, value);
          saveState();
          render();
        }, { passive:true });
        elNapeTextOverrideHex.addEventListener('change', function(){
          var value = normalizeHexColor(elNapeTextOverrideHex.value);
          state.napeTextOverride = value || '';
          syncNumberColorInputs();
          syncNapeOverrideInputs();
          saveState();
          render();
        });
      }

      if(elNapeSquaresOverrideColor && elNapeSquaresOverrideHex){
        elNapeSquaresOverrideColor.addEventListener('input', function(){
          var value = normalizeHexColor(elNapeSquaresOverrideColor.value);
          if(!value) return;
          state.napeSquaresOverride = value;
          syncNumberColorInputs();
          setInputValueSilently(elNapeSquaresOverrideHex, value);
          saveState();
          render();
        }, { passive:true });
        elNapeSquaresOverrideHex.addEventListener('change', function(){
          var value = normalizeHexColor(elNapeSquaresOverrideHex.value);
          state.napeSquaresOverride = value || '';
          syncNumberColorInputs();
          syncNapeOverrideInputs();
          saveState();
          render();
        });
      }

      elBadge.addEventListener('change', async function(){
        try{
          var file = elBadge.files && elBadge.files[0] ? elBadge.files[0] : null;
          state.badgeData = file ? await readFileAsDataURL(file) : '';
          state.badgeAspect = file ? await readImageAspectFromFile(file) : 1;
          state.digitLayerRenderCache = {};
          saveState();
          render();
        }catch(e){ showErr('Badge load failed:\n' + (e && e.message ? e.message : e)); }
      });

      elSponsor.addEventListener('change', async function(){
        try{
          var file = elSponsor.files && elSponsor.files[0] ? elSponsor.files[0] : null;
          state.sponsorData = file ? await readFileAsDataURL(file) : '';
          state.sponsorAspect = file ? await readImageAspectFromFile(file) : (1 / 0.35);
          saveState();
          render();
        }catch(e){ showErr('Sponsor load failed:\n' + (e && e.message ? e.message : e)); }
      });

      clearBtn.addEventListener('click', function(){
        elBadge.value = '';
        elSponsor.value = '';
        state.badgeData = '';
        state.badgeAspect = 1;
        state.digitLayerRenderCache = {};
        state.sponsorData = '';
        state.sponsorAspect = (1 / 0.35);
        saveState();
        render();
      });

      resetBtn.addEventListener('click', function(){
        state.placements = {
          badge:   { s:0.12, x:0.30, y:0.255 },
          sponsor: { s:0.44, x:0.50, y:0.41 }
        };
        syncSliders();
        saveState();
        render();
      });

      if(dlFrontBtn) dlFrontBtn.addEventListener('click', function(){ exportSideToPng('front', 'kit-front.png'); });
      if(zoomOpenBtn){
        zoomOpenBtn.addEventListener('click', function(){
          const isMobile = window.matchMedia('(max-width: 989px)').matches;
          var activeSide = isMobile
            ? (root.getAttribute('data-kb-mobile-side') === 'back' ? 'back' : 'front')
            : 'front';
          openLightbox(activeSide);
        });
      }

      for(var z=0; z<stageZoomToggles.length; z++){
        (function(toggle){
          var side = toggle.getAttribute('data-kb-zoom-toggle') || 'front';
          toggle.setAttribute('aria-pressed', 'false');
          toggle.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            toggleStageZoom(side);
            queueMobileOverlaySync();
          });
        })(stageZoomToggles[z]);
      }

      if(dlFrontBtnMain) dlFrontBtnMain.addEventListener('click', function(){ exportSideToPng('front', 'kit-front.png'); });
      if(dlFrontQuickBtn) dlFrontQuickBtn.addEventListener('click', function(){ exportSideToPng('front', 'kit-front.png'); });
      for(var db=0; db<dlBackBtns.length; db++){
        dlBackBtns[db].addEventListener('click', function(){ exportSideToPng('back', 'kit-back.png'); });
      }

      function isZoomBlockedTarget(target){
        if(!target || !target.closest) return false;
        return !!target.closest('.kb-hit, [data-kb-layout-target], [data-kb-resize-overlay], [data-kb-resize-box], [data-kb-resize-handle], [data-kb-zoom-toggle]');
      }

      for(var t=0; t<previewTriggers.length; t++){
        (function(trigger){
          var side = trigger.getAttribute('data-kb-lightbox-trigger') || 'front';

          trigger.addEventListener('pointerdown', function(e){
            stageTapState[side] = {
              x: e.clientX || 0,
              y: e.clientY || 0,
              moved: false,
              hitInteractive: isZoomBlockedTarget(e.target)
            };
          }, { passive:true });
          trigger.addEventListener('pointermove', function(e){
            var stateTap = stageTapState[side];
            if(!stateTap) return;
            if(Math.abs((e.clientX || 0) - stateTap.x) > 8 || Math.abs((e.clientY || 0) - stateTap.y) > 8){
              stateTap.moved = true;
            }
          }, { passive:true });
          trigger.addEventListener('pointerup', function(){
            var stateTap = stageTapState[side];
            if(!stateTap) return;
            stateTap.ended = true;
            setTimeout(function(){ delete stageTapState[side]; }, 220);
          }, { passive:true });
          trigger.addEventListener('pointercancel', function(){ delete stageTapState[side]; }, { passive:true });

          trigger.addEventListener('click', function(e){
            if(isEditModeActive()) return;
            if(isZoomBlockedTarget(e.target)) return;
            var tapState = stageTapState[side];
            if(tapState && (tapState.moved || tapState.hitInteractive)) return;
            if(state.activeDragTarget) return;
            openLightbox(side);
          });
          trigger.addEventListener('keydown', function(e){
            if(e.key === 'Enter' || e.key === ' '){
              e.preventDefault();
              if(isEditModeActive()) return;
              openLightbox(side);
            }
          });
        })(previewTriggers[t]);
      }

      if(lightbox){
        lightbox.addEventListener('click', function(e){
          if(e.target === lightbox) closeLightbox();
        });
      }
      if(lightboxDialog){
        lightboxDialog.addEventListener('click', function(e){ e.stopPropagation(); });
      }
      if(lightboxCloseBtn){
        lightboxCloseBtn.addEventListener('click', closeLightbox);
      }
      if(lightboxCloseXBtn){
        lightboxCloseXBtn.addEventListener('click', closeLightbox);
      }
      if(lightboxDownloadBtn){
        lightboxDownloadBtn.addEventListener('click', function(){
          if(lightboxSide === 'back') exportSideToPng('back', 'kit-back.png');
          else exportSideToPng('front', 'kit-front.png');
        });
      }

      window.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && lightbox && !lightbox.hidden){
          closeLightbox();
        }
      });

      populateColourways();
      setColourwayDropdownState('ready');
      elColour.addEventListener('change', function(){ setColour(elColour.value); }, { passive:true });
      setupContinueToShorts();

      builderReady = true;
      var triggerHandleRefresh = function(){ reloadForHandleChange(getSelectedHandle()); };
      window.addEventListener('popstate', triggerHandleRefresh, { passive:true });
      window.addEventListener('hashchange', triggerHandleRefresh, { passive:true });
      window.addEventListener('pageshow', triggerHandleRefresh, { passive:true });
      window.addEventListener('storage', function(ev){
        if(!ev || ev.key === 'mshModelHandle' || ev.key === 'msh_last_model') triggerHandleRefresh();
      });
      if(handleWatchTimer) clearInterval(handleWatchTimer);
      handleWatchTimer = setInterval(triggerHandleRefresh, 800);
      window.addEventListener('pagehide', function(){
        if(handleWatchTimer){ clearInterval(handleWatchTimer); handleWatchTimer = 0; }
      });

      // digits + nape (preload once, non-blocking)
      ensureDigitsReady().then(function(){
        Render.request('digits ready');
      }).catch(function(e){
        showErr(String(e && e.message ? e.message : e));
      });

      if(isDebugEnabled()){
        renderDebugPanel();
        try{
          validateKerning();
        }catch(debugErr){
          console.warn('[MSH KB] validateKerning failed', debugErr);
        }
      }

      state.dragTool = 'badge';
      syncToolChips();
      syncNapeOverrideInputs();
      syncNumberColorInputs();
      syncColourSwatches();

      if(!ensurePreviewMounted()){
        showErr('Preview container missing or not mounted yet.');
        return;
      }
      elColour.value = state.colours[0];
      await setColour(elColour.value);
      syncContinueToShortsState();

      // Force one more UI sync (helps inside theme editor)
      syncSliders();
      render();
    }

    init().catch(function(e){
      showErr('Init failed:\n' + (e && e.message ? e.message : e));
    });

  })();
